!function (t, e) {
  if ("object" == typeof exports && "object" == typeof module) module.exports = e();else if ("function" == typeof define && define.amd) define([], e);else {
    var i = e();
    for (var n in i) ("object" == typeof exports ? exports : t)[n] = i[n];
  }
}(globalThis, () => (() => {
  var t = {
      1096: function (t, e, i) {
        "use strict";

        var n = this && this.__awaiter || function (t, e, i, n) {
            return new (i || (i = Promise))(function (r, s) {
              function a(t) {
                try {
                  l(n.next(t));
                } catch (t) {
                  s(t);
                }
              }
              function o(t) {
                try {
                  l(n.throw(t));
                } catch (t) {
                  s(t);
                }
              }
              function l(t) {
                t.done ? r(t.value) : new i(function (e) {
                  e(t.value);
                }).then(a, o);
              }
              l((n = n.apply(t, e || [])).next());
            });
          },
          r = this && this.__generator || function (t, e) {
            var i,
              n,
              r,
              s,
              a = {
                label: 0,
                sent: function () {
                  if (1 & r[0]) throw r[1];
                  return r[1];
                },
                trys: [],
                ops: []
              };
            return s = {
              next: o(0),
              throw: o(1),
              return: o(2)
            }, "function" == typeof Symbol && (s[Symbol.iterator] = function () {
              return this;
            }), s;
            function o(s) {
              return function (o) {
                return function (s) {
                  if (i) throw TypeError("Generator is already executing.");
                  for (; a;) try {
                    if (i = 1, n && (r = 2 & s[0] ? n.return : s[0] ? n.throw || ((r = n.return) && r.call(n), 0) : n.next) && !(r = r.call(n, s[1])).done) return r;
                    switch (n = 0, r && (s = [2 & s[0], r.value]), s[0]) {
                      case 0:
                      case 1:
                        r = s;
                        break;
                      case 4:
                        return a.label++, {
                          value: s[1],
                          done: !1
                        };
                      case 5:
                        a.label++, n = s[1], s = [0];
                        continue;
                      case 7:
                        s = a.ops.pop(), a.trys.pop();
                        continue;
                      default:
                        if (!(r = (r = a.trys).length > 0 && r[r.length - 1]) && (6 === s[0] || 2 === s[0])) {
                          a = 0;
                          continue;
                        }
                        if (3 === s[0] && (!r || s[1] > r[0] && s[1] < r[3])) {
                          a.label = s[1];
                          break;
                        }
                        if (6 === s[0] && a.label < r[1]) {
                          a.label = r[1], r = s;
                          break;
                        }
                        if (r && a.label < r[2]) {
                          a.label = r[2], a.ops.push(s);
                          break;
                        }
                        r[2] && a.ops.pop(), a.trys.pop();
                        continue;
                    }
                    s = e.call(t, a);
                  } catch (t) {
                    s = [6, t], n = 0;
                  } finally {
                    i = r = 0;
                  }
                  if (5 & s[0]) throw s[1];
                  return {
                    value: s[0] ? s[1] : void 0,
                    done: !0
                  };
                }([s, o]);
              };
            }
          };
        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var s = i(3565),
          a = "browser-tabs-lock-key";
        function o(t) {
          return new Promise(function (e) {
            return setTimeout(e, t);
          });
        }
        function l(t) {
          for (var e = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz", i = "", n = 0; n < t; n++) {
            var r = Math.floor(Math.random() * e.length);
            i += e[r];
          }
          return i;
        }
        var c = function () {
          function t() {
            this.acquiredIatSet = new Set(), this.id = Date.now().toString() + l(15), this.acquireLock = this.acquireLock.bind(this), this.releaseLock = this.releaseLock.bind(this), this.releaseLock__private__ = this.releaseLock__private__.bind(this), this.waitForSomethingToChange = this.waitForSomethingToChange.bind(this), this.refreshLockWhileAcquired = this.refreshLockWhileAcquired.bind(this), void 0 === t.waiters && (t.waiters = []);
          }
          return t.prototype.acquireLock = function (e, i) {
            return void 0 === i && (i = 5e3), n(this, void 0, void 0, function () {
              var n, s, c, h, d, u;
              return r(this, function (r) {
                switch (r.label) {
                  case 0:
                    n = Date.now() + l(4), s = Date.now() + i, c = a + "-" + e, h = window.localStorage, r.label = 1;
                  case 1:
                    if (!(Date.now() < s)) return [3, 8];
                    return [4, o(30)];
                  case 2:
                    if (r.sent(), null !== h.getItem(c)) return [3, 5];
                    return d = this.id + "-" + e + "-" + n, [4, o(Math.floor(25 * Math.random()))];
                  case 3:
                    return r.sent(), h.setItem(c, JSON.stringify({
                      id: this.id,
                      iat: n,
                      timeoutKey: d,
                      timeAcquired: Date.now(),
                      timeRefreshed: Date.now()
                    })), [4, o(30)];
                  case 4:
                    if (r.sent(), null !== (u = h.getItem(c)) && (u = JSON.parse(u)).id === this.id && u.iat === n) return this.acquiredIatSet.add(n), this.refreshLockWhileAcquired(c, n), [2, !0];
                    return [3, 7];
                  case 5:
                    return t.lockCorrector(), [4, this.waitForSomethingToChange(s)];
                  case 6:
                    r.sent(), r.label = 7;
                  case 7:
                    return n = Date.now() + l(4), [3, 1];
                  case 8:
                    return [2, !1];
                }
              });
            });
          }, t.prototype.refreshLockWhileAcquired = function (t, e) {
            return n(this, void 0, void 0, function () {
              var i = this;
              return r(this, function (a) {
                return setTimeout(function () {
                  return n(i, void 0, void 0, function () {
                    var i, n;
                    return r(this, function (r) {
                      switch (r.label) {
                        case 0:
                          return [4, s.default().lock(e)];
                        case 1:
                          if (r.sent(), !this.acquiredIatSet.has(e) || null === (n = (i = window.localStorage).getItem(t))) return s.default().unlock(e), [2];
                          return (n = JSON.parse(n)).timeRefreshed = Date.now(), i.setItem(t, JSON.stringify(n)), s.default().unlock(e), this.refreshLockWhileAcquired(t, e), [2];
                      }
                    });
                  });
                }, 1e3), [2];
              });
            });
          }, t.prototype.waitForSomethingToChange = function (e) {
            return n(this, void 0, void 0, function () {
              return r(this, function (i) {
                switch (i.label) {
                  case 0:
                    return [4, new Promise(function (i) {
                      var n = !1,
                        r = Date.now(),
                        s = !1;
                      function a() {
                        if (s || (window.removeEventListener("storage", a), t.removeFromWaiting(a), clearTimeout(o), s = !0), !n) {
                          n = !0;
                          var e = 50 - (Date.now() - r);
                          e > 0 ? setTimeout(i, e) : i();
                        }
                      }
                      window.addEventListener("storage", a), t.addToWaiting(a);
                      var o = setTimeout(a, Math.max(0, e - Date.now()));
                    })];
                  case 1:
                    return i.sent(), [2];
                }
              });
            });
          }, t.addToWaiting = function (e) {
            this.removeFromWaiting(e), void 0 !== t.waiters && t.waiters.push(e);
          }, t.removeFromWaiting = function (e) {
            void 0 !== t.waiters && (t.waiters = t.waiters.filter(function (t) {
              return t !== e;
            }));
          }, t.notifyWaiters = function () {
            void 0 !== t.waiters && t.waiters.slice().forEach(function (t) {
              return t();
            });
          }, t.prototype.releaseLock = function (t) {
            return n(this, void 0, void 0, function () {
              return r(this, function (e) {
                switch (e.label) {
                  case 0:
                    return [4, this.releaseLock__private__(t)];
                  case 1:
                    return [2, e.sent()];
                }
              });
            });
          }, t.prototype.releaseLock__private__ = function (e) {
            return n(this, void 0, void 0, function () {
              var i, n, o;
              return r(this, function (r) {
                switch (r.label) {
                  case 0:
                    if (i = window.localStorage, n = a + "-" + e, null === (o = i.getItem(n))) return [2];
                    if ((o = JSON.parse(o)).id !== this.id) return [3, 2];
                    return [4, s.default().lock(o.iat)];
                  case 1:
                    r.sent(), this.acquiredIatSet.delete(o.iat), i.removeItem(n), s.default().unlock(o.iat), t.notifyWaiters(), r.label = 2;
                  case 2:
                    return [2];
                }
              });
            });
          }, t.lockCorrector = function () {
            for (var e = Date.now() - 5e3, i = window.localStorage, n = Object.keys(i), r = !1, s = 0; s < n.length; s++) {
              var o = n[s];
              if (o.includes(a)) {
                var l = i.getItem(o);
                null !== l && (void 0 === (l = JSON.parse(l)).timeRefreshed && l.timeAcquired < e || void 0 !== l.timeRefreshed && l.timeRefreshed < e) && (i.removeItem(o), r = !0);
              }
            }
            r && t.notifyWaiters();
          }, t.waiters = void 0, t;
        }();
        e.default = c;
      },
      3565: function (t, e) {
        "use strict";

        Object.defineProperty(e, "__esModule", {
          value: !0
        });
        var i = function () {
          function t() {
            var t = this;
            this.locked = new Map(), this.addToLocked = function (e, i) {
              var n = t.locked.get(e);
              void 0 === n ? void 0 === i ? t.locked.set(e, []) : t.locked.set(e, [i]) : void 0 !== i && (n.unshift(i), t.locked.set(e, n));
            }, this.isLocked = function (e) {
              return t.locked.has(e);
            }, this.lock = function (e) {
              return new Promise(function (i, n) {
                t.isLocked(e) ? t.addToLocked(e, i) : (t.addToLocked(e), i());
              });
            }, this.unlock = function (e) {
              var i = t.locked.get(e);
              if (void 0 === i || 0 === i.length) {
                t.locked.delete(e);
                return;
              }
              var n = i.pop();
              t.locked.set(e, i), void 0 !== n && setTimeout(n, 0);
            };
          }
          return t.getInstance = function () {
            return void 0 === t.instance && (t.instance = new t()), t.instance;
          }, t;
        }();
        e.default = function () {
          return i.getInstance();
        };
      },
      450: function (t) {
        t.exports = function (t, e) {
          if ("string" != typeof t) throw TypeError("Expected a string");
          for (var i, n = String(t), r = "", s = !!e && !!e.extended, a = !!e && !!e.globstar, o = !1, l = e && "string" == typeof e.flags ? e.flags : "", c = 0, h = n.length; c < h; c++) switch (i = n[c]) {
            case "/":
            case "$":
            case "^":
            case "+":
            case ".":
            case "(":
            case ")":
            case "=":
            case "!":
            case "|":
              r += "\\" + i;
              break;
            case "?":
              if (s) {
                r += ".";
                break;
              }
            case "[":
            case "]":
              if (s) {
                r += i;
                break;
              }
            case "{":
              if (s) {
                o = !0, r += "(";
                break;
              }
            case "}":
              if (s) {
                o = !1, r += ")";
                break;
              }
            case ",":
              if (o) {
                r += "|";
                break;
              }
              r += "\\" + i;
              break;
            case "*":
              for (var d = n[c - 1], u = 1; "*" === n[c + 1];) u++, c++;
              var p = n[c + 1];
              a ? u > 1 && ("/" === d || void 0 === d) && ("/" === p || void 0 === p) ? (r += "((?:[^/]*(?:/|$))*)", c++) : r += "([^/]*)" : r += ".*";
              break;
            default:
              r += i;
          }
          return l && ~l.indexOf("g") || (r = "^" + r + "$"), new RegExp(r, l);
        };
      },
      5047: function (t) {
        var e = function (t) {
          "use strict";

          var e,
            i = Object.prototype,
            n = i.hasOwnProperty,
            r = Object.defineProperty || function (t, e, i) {
              t[e] = i.value;
            },
            s = "function" == typeof Symbol ? Symbol : {},
            a = s.iterator || "@@iterator",
            o = s.asyncIterator || "@@asyncIterator",
            l = s.toStringTag || "@@toStringTag";
          function c(t, e, i) {
            return Object.defineProperty(t, e, {
              value: i,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }), t[e];
          }
          try {
            c({}, "");
          } catch (t) {
            c = function (t, e, i) {
              return t[e] = i;
            };
          }
          function h(t, i, n, s) {
            var a,
              o,
              l,
              c,
              h = Object.create((i && i.prototype instanceof v ? i : v).prototype);
            return r(h, "_invoke", {
              value: (a = t, o = n, l = new I(s || []), c = u, function (t, i) {
                if (c === p) throw Error("Generator is already running");
                if (c === f) {
                  if ("throw" === t) throw i;
                  return E();
                }
                for (l.method = t, l.arg = i;;) {
                  var n = l.delegate;
                  if (n) {
                    var r = function t(i, n) {
                      var r = n.method,
                        s = i.iterator[r];
                      if (e === s) return n.delegate = null, "throw" === r && i.iterator.return && (n.method = "return", n.arg = e, t(i, n), "throw" === n.method) || "return" !== r && (n.method = "throw", n.arg = TypeError("The iterator does not provide a '" + r + "' method")), m;
                      var a = d(s, i.iterator, n.arg);
                      if ("throw" === a.type) return n.method = "throw", n.arg = a.arg, n.delegate = null, m;
                      var o = a.arg;
                      return o ? o.done ? (n[i.resultName] = o.value, n.next = i.nextLoc, "return" !== n.method && (n.method = "next", n.arg = e), n.delegate = null, m) : o : (n.method = "throw", n.arg = TypeError("iterator result is not an object"), n.delegate = null, m);
                    }(n, l);
                    if (r) {
                      if (r === m) continue;
                      return r;
                    }
                  }
                  if ("next" === l.method) l.sent = l._sent = l.arg;else if ("throw" === l.method) {
                    if (c === u) throw c = f, l.arg;
                    l.dispatchException(l.arg);
                  } else "return" === l.method && l.abrupt("return", l.arg);
                  c = p;
                  var s = d(a, o, l);
                  if ("normal" === s.type) {
                    if (c = l.done ? f : "suspendedYield", s.arg === m) continue;
                    return {
                      value: s.arg,
                      done: l.done
                    };
                  }
                  "throw" === s.type && (c = f, l.method = "throw", l.arg = s.arg);
                }
              })
            }), h;
          }
          function d(t, e, i) {
            try {
              return {
                type: "normal",
                arg: t.call(e, i)
              };
            } catch (t) {
              return {
                type: "throw",
                arg: t
              };
            }
          }
          t.wrap = h;
          var u = "suspendedStart",
            p = "executing",
            f = "completed",
            m = {};
          function v() {}
          function g() {}
          function w() {}
          var _ = {};
          c(_, a, function () {
            return this;
          });
          var b = Object.getPrototypeOf,
            y = b && b(b(C([])));
          y && y !== i && n.call(y, a) && (_ = y);
          var k = w.prototype = v.prototype = Object.create(_);
          function S(t) {
            ["next", "throw", "return"].forEach(function (e) {
              c(t, e, function (t) {
                return this._invoke(e, t);
              });
            });
          }
          function U(t, e) {
            var i;
            r(this, "_invoke", {
              value: function (r, s) {
                function a() {
                  return new e(function (i, a) {
                    !function i(r, s, a, o) {
                      var l = d(t[r], t, s);
                      if ("throw" === l.type) o(l.arg);else {
                        var c = l.arg,
                          h = c.value;
                        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
                          i("next", t, a, o);
                        }, function (t) {
                          i("throw", t, a, o);
                        }) : e.resolve(h).then(function (t) {
                          c.value = t, a(c);
                        }, function (t) {
                          return i("throw", t, a, o);
                        });
                      }
                    }(r, s, i, a);
                  });
                }
                return i = i ? i.then(a, a) : a();
              }
            });
          }
          function A(t) {
            var e = {
              tryLoc: t[0]
            };
            1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
          }
          function O(t) {
            var e = t.completion || {};
            e.type = "normal", delete e.arg, t.completion = e;
          }
          function I(t) {
            this.tryEntries = [{
              tryLoc: "root"
            }], t.forEach(A, this), this.reset(!0);
          }
          function C(t) {
            if (t) {
              var i = t[a];
              if (i) return i.call(t);
              if ("function" == typeof t.next) return t;
              if (!isNaN(t.length)) {
                var r = -1,
                  s = function i() {
                    for (; ++r < t.length;) if (n.call(t, r)) return i.value = t[r], i.done = !1, i;
                    return i.value = e, i.done = !0, i;
                  };
                return s.next = s;
              }
            }
            return {
              next: E
            };
          }
          function E() {
            return {
              value: e,
              done: !0
            };
          }
          return g.prototype = w, r(k, "constructor", {
            value: w,
            configurable: !0
          }), r(w, "constructor", {
            value: g,
            configurable: !0
          }), g.displayName = c(w, l, "GeneratorFunction"), t.isGeneratorFunction = function (t) {
            var e = "function" == typeof t && t.constructor;
            return !!e && (e === g || "GeneratorFunction" === (e.displayName || e.name));
          }, t.mark = function (t) {
            return Object.setPrototypeOf ? Object.setPrototypeOf(t, w) : (t.__proto__ = w, c(t, l, "GeneratorFunction")), t.prototype = Object.create(k), t;
          }, t.awrap = function (t) {
            return {
              __await: t
            };
          }, S(U.prototype), c(U.prototype, o, function () {
            return this;
          }), t.AsyncIterator = U, t.async = function (e, i, n, r, s) {
            void 0 === s && (s = Promise);
            var a = new U(h(e, i, n, r), s);
            return t.isGeneratorFunction(i) ? a : a.next().then(function (t) {
              return t.done ? t.value : a.next();
            });
          }, S(k), c(k, l, "Generator"), c(k, a, function () {
            return this;
          }), c(k, "toString", function () {
            return "[object Generator]";
          }), t.keys = function (t) {
            var e = Object(t),
              i = [];
            for (var n in e) i.push(n);
            return i.reverse(), function t() {
              for (; i.length;) {
                var n = i.pop();
                if (n in e) return t.value = n, t.done = !1, t;
              }
              return t.done = !0, t;
            };
          }, t.values = C, I.prototype = {
            constructor: I,
            reset: function (t) {
              if (this.prev = 0, this.next = 0, this.sent = this._sent = e, this.done = !1, this.delegate = null, this.method = "next", this.arg = e, this.tryEntries.forEach(O), !t) for (var i in this) "t" === i.charAt(0) && n.call(this, i) && !isNaN(+i.slice(1)) && (this[i] = e);
            },
            stop: function () {
              this.done = !0;
              var t = this.tryEntries[0].completion;
              if ("throw" === t.type) throw t.arg;
              return this.rval;
            },
            dispatchException: function (t) {
              if (this.done) throw t;
              var i = this;
              function r(n, r) {
                return o.type = "throw", o.arg = t, i.next = n, r && (i.method = "next", i.arg = e), !!r;
              }
              for (var s = this.tryEntries.length - 1; s >= 0; --s) {
                var a = this.tryEntries[s],
                  o = a.completion;
                if ("root" === a.tryLoc) return r("end");
                if (a.tryLoc <= this.prev) {
                  var l = n.call(a, "catchLoc"),
                    c = n.call(a, "finallyLoc");
                  if (l && c) {
                    if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
                    if (this.prev < a.finallyLoc) return r(a.finallyLoc);
                  } else if (l) {
                    if (this.prev < a.catchLoc) return r(a.catchLoc, !0);
                  } else if (c) {
                    if (this.prev < a.finallyLoc) return r(a.finallyLoc);
                  } else throw Error("try statement without catch or finally");
                }
              }
            },
            abrupt: function (t, e) {
              for (var i = this.tryEntries.length - 1; i >= 0; --i) {
                var r = this.tryEntries[i];
                if (r.tryLoc <= this.prev && n.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                  var s = r;
                  break;
                }
              }
              s && ("break" === t || "continue" === t) && s.tryLoc <= e && e <= s.finallyLoc && (s = null);
              var a = s ? s.completion : {};
              return (a.type = t, a.arg = e, s) ? (this.method = "next", this.next = s.finallyLoc, m) : this.complete(a);
            },
            complete: function (t, e) {
              if ("throw" === t.type) throw t.arg;
              return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), m;
            },
            finish: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var i = this.tryEntries[e];
                if (i.finallyLoc === t) return this.complete(i.completion, i.afterLoc), O(i), m;
              }
            },
            catch: function (t) {
              for (var e = this.tryEntries.length - 1; e >= 0; --e) {
                var i = this.tryEntries[e];
                if (i.tryLoc === t) {
                  var n = i.completion;
                  if ("throw" === n.type) {
                    var r = n.arg;
                    O(i);
                  }
                  return r;
                }
              }
              throw Error("illegal catch attempt");
            },
            delegateYield: function (t, i, n) {
              return this.delegate = {
                iterator: C(t),
                resultName: i,
                nextLoc: n
              }, "next" === this.method && (this.arg = e), m;
            }
          }, t;
        }(t.exports);
        try {
          regeneratorRuntime = e;
        } catch (t) {
          "object" == typeof globalThis ? globalThis.regeneratorRuntime = e : Function("r", "regeneratorRuntime = r")(e);
        }
      },
      5139: function (t, e, i) {
        "use strict";

        let n;
        function r(t, e) {
          return e.get ? e.get.call(t) : e.value;
        }
        function s(t, e, i) {
          if (!e.has(t)) throw TypeError("attempted to " + i + " private field on non-instance");
          return e.get(t);
        }
        function a(t, e) {
          var i = s(t, e, "get");
          return r(t, i);
        }
        function o(t, e) {
          if (e.has(t)) throw TypeError("Cannot initialize the same private elements twice on an object");
        }
        function l(t, e, i) {
          o(t, e), e.set(t, i);
        }
        function c(t, e, i) {
          if (e.set) e.set.call(t, i);else {
            if (!e.writable) throw TypeError("attempted to set read only private field");
            e.value = i;
          }
        }
        function h(t, e, i) {
          var n = s(t, e, "set");
          return c(t, n, i), i;
        }
        function d(t, e, i) {
          return e in t ? Object.defineProperty(t, e, {
            value: i,
            enumerable: !0,
            configurable: !0,
            writable: !0
          }) : t[e] = i, t;
        }
        i.r(e), i.d(e, {
          isClerkRuntimeError: () => f.uX,
          isEmailLinkError: () => f.G1,
          isClerkAPIResponseError: () => f.kD,
          EmailLinkErrorCode: () => f._L,
          Clerk: () => nx,
          ClerkRuntimeError: () => f.w$,
          isKnownError: () => f.sZ,
          isMetamaskError: () => f.ZC,
          ClerkAPIResponseError: () => f.gO,
          isUserLockedError: () => f.ay,
          EmailLinkError: () => f.N
        }), i("5047");
        var u = i("9934");
        i("2689");
        var p = i("2634"),
          f = i("2434"),
          m = i("4193"),
          v = class {
            constructor(t) {
              this.eventTarget = window, this.postMessage = t => {
                if ("undefined" != typeof window) try {
                  window.localStorage.setItem(this.channelKey, JSON.stringify(t)), window.localStorage.removeItem(this.channelKey);
                } catch (t) {}
              }, this.addEventListener = (t, e) => {
                this.eventTarget.addEventListener(this.prefixEventName(t), t => {
                  e(t);
                });
              }, this.setupLocalStorageListener = () => {
                window.addEventListener("storage", t => {
                  if (t.key === this.channelKey && t.newValue) try {
                    let e = JSON.parse(t.newValue || ""),
                      i = new MessageEvent(this.prefixEventName("message"), {
                        data: e
                      });
                    this.eventTarget.dispatchEvent(i);
                  } catch (t) {}
                });
              }, this.channelKey = "__lsbc__" + t, this.setupLocalStorageListener();
            }
            prefixEventName(t) {
              return this.channelKey + t;
            }
          },
          g = i("8003");
        function w(t) {
          return /^http(s)?:\/\//.test(t || "");
        }
        function _(t) {
          return t.startsWith("/");
        }
        var b = i("3310"),
          y = i("7717"),
          k = i("4677"),
          S = new WeakMap(),
          U = new WeakMap();
        class A {
          mount(t, e, i) {
            let n = this.componentRegistry.get(t);
            if (!n) throw Error("clerk/ui: Unable to find component definition for ".concat(t));
            n.load(), this.renderer().then(() => {
              var t;
              null === (t = a(this, U)) || void 0 === t || t.mount(a(this, U).createElementFromComponentDefinition(n), i, e);
            }).catch(e => {
              console.error("clerk/ui: Error mounting component ".concat(t, ":"), e);
            });
          }
          unmount(t) {
            var e;
            null === (e = a(this, U)) || void 0 === e || e.unmount(t);
          }
          register(t, e) {
            this.componentRegistry.set(t, e);
          }
          renderer() {
            return a(this, S) || (h(this, S, (0, k.WK)()), i.e("834").then(i.bind(i, 9578)).then(t => {
              var e;
              let {
                init: i,
                wrapperInit: n
              } = t;
              (function (t) {
                if (!t) throw Error('Clerk: Attempted to use functionality that requires the "router" option to be provided to Clerk.');
              })(this.router), h(this, U, i({
                wrapper: n({
                  clerk: this.clerk,
                  options: this.options,
                  router: this.router
                })
              })), null === (e = a(this, S)) || void 0 === e || e.resolve();
            })), a(this, S).promise;
          }
          constructor({
            router: t,
            clerk: e,
            options: n
          }) {
            d(this, "router", void 0), d(this, "clerk", void 0), d(this, "options", void 0), d(this, "componentRegistry", new Map()), l(this, S, {
              writable: !0,
              value: void 0
            }), l(this, U, {
              writable: !0,
              value: void 0
            }), this.router = t, this.clerk = e, this.options = n, this.register("SignIn", {
              type: "component",
              load: () => i.e("885").then(i.bind(i, 8795)).then(t => {
                let {
                  SignIn: e
                } = t;
                return {
                  default: e
                };
              })
            }), this.register("SignUp", {
              type: "component",
              load: () => i.e("36").then(i.bind(i, 1219)).then(t => {
                let {
                  SignUp: e
                } = t;
                return {
                  default: e
                };
              })
            });
          }
        }
        let O = "clerk:beforeunload",
          I = ["http:", "https:", "wails:", "chrome-extension:"];
        function C(t) {
          let e = new URL(t, window.location.href);
          I.includes(e.protocol) || (console.warn('Clerk: "'.concat(e.protocol, '" is not a valid protocol. Redirecting to "/" instead. If you think this is a mistake, please open an issue.')), e = new URL("/", window.location.href)), window.dispatchEvent(new CustomEvent(O)), window.location.href = e.href;
        }
        let E = () => {
            let t = !1,
              e = () => t = !0;
            return {
              startTracking: () => {
                window.addEventListener("beforeunload", e), window.addEventListener(O, e);
              },
              stopTracking: () => {
                window.removeEventListener("beforeunload", e), window.removeEventListener(O, e);
              },
              isUnloading: () => t
            };
          },
          P = (t, e) => !!(t.session && (null == e ? void 0 : e.authConfig.singleSessionMode)),
          x = t => !t.user,
          T = t => !t.organization,
          R = (t, e) => !(null == e ? void 0 : e.organizationSettings.enabled);
        function M(t) {
          let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "";
          return t.errors && !!t.errors.find(t => t.code === e);
        }
        let z = (0, f.t5)({
          packageName: "@clerk/clerk-js"
        });
        function W(t) {
          return new URL(window.location.href).searchParams.get(t) || null;
        }
        function N(t) {
          let e = new URL(window.location.href);
          e.searchParams.has(t) && (e.searchParams.delete(t), window.history.replaceState(window.history.state, "", e));
        }
        let F = t => !!t && "object" == typeof t && "target" in t && "currentTarget" in t && "preventDefault" in t;
        function L(t) {
          let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
          if (!(e.requireType && typeof t !== e.requireType || F(t))) return t;
        }
        var D = i("450"),
          j = {
            toRegexp: t => {
              try {
                return D(t);
              } catch (e) {
                throw Error(`Invalid pattern: ${t}.
Consult the documentation of glob-to-regexp here: https://www.npmjs.com/package/glob-to-regexp.
${e.message}`);
              }
            }
          },
          J = i("5670");
        let V = RegExp("/{1,}", "g"),
          K = t => {
            let e = {};
            return new URLSearchParams(t).forEach((t, i) => {
              if (i in e) {
                let n = e[i];
                Array.isArray(n) ? n.push(t) : e[i] = [n, t];
              } else e[i] = t;
            }), e;
          },
          B = function (t) {
            let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            if (null == t || !t || "object" != typeof t) return "";
            let i = new URLSearchParams();
            return Object.keys(t).forEach(n => {
              let r = e.keyEncoder ? e.keyEncoder(n) : n,
                s = t[n];
              if (Array.isArray(s)) s.forEach(t => void 0 !== t && i.append(r, t || ""));else {
                if (void 0 === s) return;
                "object" == typeof s && null !== s ? i.append(r, JSON.stringify(s)) : i.append(r, String(null != s ? s : ""));
              }
            }), i.toString();
          },
          $ = "http://clerk-dummy",
          {
            isDevOrStagingUrl: q
          } = (0, m.MY)(),
          G = new Map();
        function H(t) {
          return t.replace("clerk.", "");
        }
        function Z(t) {
          let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            {
              base: i,
              hashPath: n,
              hashSearch: r,
              searchParams: s,
              hashSearchParams: a,
              ...o
            } = t,
            l = "",
            c = new URL(i || "", "undefined" != typeof window && window.location ? window.location.href : "http://react-native-fake-base-url");
          if (s instanceof URLSearchParams && s.forEach((t, e) => {
            null != t && c.searchParams.set((0, J.a1)(e), t);
          }), Object.assign(c, o), n || r || a) {
            let t = new URL($ + c.hash.substring(1));
            for (let [e, i] of (t.pathname = [t.pathname, n || ""].filter(t => t).join("/").replace(V, "/"), Object.entries(K(r || "")))) t.searchParams.append(e, i);
            if (a) for (let e of Array.isArray(a) ? a : [a]) (e instanceof URLSearchParams || "object" == typeof e) && new URLSearchParams(e).forEach((e, i) => {
              null != e && t.searchParams.set((0, J.a1)(i), e);
            });
            let e = t.href.replace($, "");
            "/" !== e && (c.hash = e);
          }
          let {
            stringify: h,
            skipOrigin: d
          } = e;
          return h ? d ? c.href.replace(c.origin, "") : c.href : c;
        }
        let Y = t => (t || "").replace(/\/+$/, ""),
          Q = t => {
            let {
              externalAccount: e
            } = t.verifications;
            return !!e.error;
          },
          X = ["/oauth/authorize"],
          tt = ["/v1/verify", "/v1/tickets/accept"],
          te = t => e => {
            if (!t || function (t) {
              if (t != t && !t || t.startsWith("//") || t.startsWith("http/") || t.startsWith("https/")) return !1;
              try {
                return new URL(t), !1;
              } catch (e) {
                try {
                  return new URL(t, $), !0;
                } catch (t) {
                  return !1;
                }
              }
            }(e)) return !0;
            let i = new URL(e, $),
              n = t.map(t => "string" == typeof t ? j.toRegexp(Y(t)) : t).some(t => t.test(Y(i.origin)));
            return n || g.k.warnOnce("Clerk: Redirect URL ".concat(i, " is not on one of the allowedRedirectOrigins, falling back to the default redirect URL.")), n;
          };
        function ti(t) {
          var e;
          return e = t.replace(/_/g, "/").replace(/-/g, "+"), decodeURIComponent(i.g.atob(e).split("").map(t => "%" + ("00" + t.charCodeAt(0).toString(16)).slice(-2)).join(""));
        }
        function tn(t) {
          let e = (t || "").split("."),
            [i, n, r] = e;
          if (3 !== e.length || !i || !n || !r) throw Error("JWT could not be decoded");
          let s = JSON.parse(ti(n)),
            a = {
              __raw: t
            };
          return Object.keys(s).forEach(t => {
            a[t] = s[t];
          }), {
            encoded: {
              header: i,
              payload: n,
              signature: r
            },
            header: JSON.parse(ti(i)),
            claims: a
          };
        }
        let tr = () => {},
          ts = () => {
            if (!(0, u._f)()) return {
              onPageFocus: tr
            };
            let t = {
              focus: []
            };
            return window.addEventListener("focus", () => {
              "visible" === document.visibilityState && t.focus.forEach(t => t());
            }), {
              onPageFocus: e => {
                t.focus.push(e);
              }
            };
          };
        function ta() {
          return void 0 !== globalThis.document;
        }
        function to() {
          return ta() && window.self !== window.top && !window.frameElement;
        }
        function tl(t, e) {
          if (t !== e) throw TypeError("Private static access of wrong provenance");
        }
        function tc(t, e) {
          if (void 0 === t) throw TypeError("attempted to " + e + " private static field before its declaration");
        }
        function th(t, e, i) {
          return tl(t, e), tc(i, "get"), r(t, i);
        }
        var td = new WeakMap(),
          tu = new WeakMap(),
          tp = new WeakMap();
        class tf {
          static getInstance() {
            if (!th(tf, tf, tm)) {
              var t;
              t = new tf(), tl(tf, tf), tc(tm, "set"), c(tf, tm, t);
            }
            return th(tf, tf, tm);
          }
          constructor() {
            if (l(this, td, {
              writable: !0,
              value: []
            }), l(this, tu, {
              writable: !0,
              value: {
                metamask: "MetaMask"
              }
            }), d(this, "get", t => {
              var e;
              return 1 === a(this, td).length ? a(this, td)[0].provider : null === (e = a(this, td).find(e => e.info.name === a(this, tu)[t])) || void 0 === e ? void 0 : e.provider;
            }), l(this, tp, {
              writable: !0,
              value: t => {
                !a(this, td).some(e => e.info.uuid === t.detail.info.uuid) && a(this, td).push(t.detail);
              }
            }), "undefined" == typeof window) return;
            window.addEventListener("eip6963:announceProvider", a(this, tp)), window.dispatchEvent(new Event("eip6963:requestProvider"));
          }
        }
        var tm = {
          writable: !0,
          value: null
        };
        let tv = () => tf.getInstance();
        async function tg(t) {
          let {
              provider: e
            } = t,
            i = await tS(e);
          if (!i) return "";
          let n = await i.request({
            method: "eth_requestAccounts"
          });
          return n && n[0] || "";
        }
        async function tw(t) {
          let {
              identifier: e,
              nonce: i,
              provider: n
            } = t,
            r = await tS(n);
          return r ? await r.request({
            method: "personal_sign",
            params: ["0x".concat(i.split("").map(t => t.charCodeAt(0).toString(16).padStart(2, "0")).join("")), e]
          }) : "";
        }
        async function t_() {
          return await tg({
            provider: "metamask"
          });
        }
        async function tb() {
          return await tg({
            provider: "coinbase_wallet"
          });
        }
        async function ty(t) {
          return await tw({
            ...t,
            provider: "metamask"
          });
        }
        async function tk(t) {
          return await tw({
            ...t,
            provider: "coinbase_wallet"
          });
        }
        async function tS(t) {
          return "coinbase_wallet" === t ? new (await i.e("456").then(i.bind(i, 6221)).then(t => t.CoinbaseWalletSDK))({}).makeWeb3Provider({
            options: "all"
          }) : tv().get(t);
        }
        let tU = t => {
          let {
            signUp: e,
            verifyEmailPath: i,
            verifyPhonePath: n,
            navigate: r,
            handleComplete: s,
            redirectUrl: a = "",
            redirectUrlComplete: o = ""
          } = t;
          if ("complete" === e.status) return s && s();
          if ("missing_requirements" === e.status) {
            var l, c;
            if (e.missingFields.some(t => "saml" === t)) return e.authenticateWithRedirect({
              strategy: "saml",
              redirectUrl: a,
              redirectUrlComplete: o,
              continueSignUp: !0
            });
            if ((null === (l = e.unverifiedFields) || void 0 === l ? void 0 : l.includes("email_address")) && i) return r(i);
            if ((null === (c = e.unverifiedFields) || void 0 === c ? void 0 : c.includes("phone_number")) && n) return r(n);
          }
        };
        function tA(t) {
          let e = ["redirectUrl", "afterSignInUrl", "afterSignUpUrl", "after_sign_in_url", "after_sign_up_url"],
            i = Object.keys(t).find(t => e.includes(t));
          i && t[i] && g.k.warnOnce('Clerk: The prop "'.concat(i, '" is deprecated and should be replaced with the new "fallbackRedirectUrl" or "forceRedirectUrl" props instead. Learn more: https://clerk.com/docs/guides/custom-redirects#redirect-url-props'));
        }
        let tO = "ClerkJS:";
        function tI() {
          let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
          throw Error("".concat(tO, " Something went wrong initializing Clerk in development mode.").concat(t && " ".concat(t)));
        }
        function tC(t) {
          throw Error("".concat(tO, " Token refresh failed (error='").concat(t, "')"));
        }
        function tE(t) {
          throw Error("".concat(tO, " Something went wrong initializing Clerk during the ").concat(t, " flow. Please contact support."));
        }
        function tP(t) {
          throw Error("".concat(tO, " You need to start a ").concat(t, " flow by calling ").concat(t, ".create() first."));
        }
        function tx(t, e) {
          throw Error("".concat(tO, ' Strategy "').concat(e, '" is not a valid strategy for ').concat(t, "."));
        }
        function tT(t) {
          throw Error("".concat(tO, " You need to start a ").concat(t, " flow by calling ").concat(t, ".create({ identifier: 'your web3 wallet address' }) first"));
        }
        function tR() {
          let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
          throw Error("".concat(tO, " Missing '").concat(t, "' option"));
        }
        function tM(t, e) {
          throw Error("".concat(tO, " Response: ").concat(t || 0, " not supported yet.\nFor more information contact us at ").concat(e));
        }
        function tz(t) {
          throw Error("".concat(tO, " Missing publicKey. When calling 'navigator.credentials.").concat(t, "()' it is required to pass a publicKey object."));
        }
        class tW {
          static get fapiClient() {
            return tW.clerk.getFapiClient();
          }
          static async _fetch(t) {
            let e,
              i = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            tW.fapiClient || function () {
              throw Error("".concat(tO, " Missing FAPI client in resources."));
            }();
            try {
              e = await tW.fapiClient.request(t);
            } catch (t) {
              if (!(0, u.af)()) return console.warn(t), null;
              throw t;
            }
            let {
              payload: n,
              status: r,
              statusText: s,
              headers: a
            } = e;
            if (a) {
              let t = a.get("x-country");
              this.clerk.__internal_setCountry(t ? t.toLowerCase() : null);
            }
            if (("GET" !== t.method || i.forceUpdateClient) && this._updateClient(n), r >= 200 && r <= 299) return n;
            if (401 === r && (await tW.clerk.handleUnauthenticated()), r >= 400) throw new f.gO(s, {
              data: null == n ? void 0 : n.errors,
              status: r
            });
            return null;
          }
          static _updateClient(t) {
            var e;
            if (!t) return;
            let i = t.client || (null === (e = t.meta) || void 0 === e ? void 0 : e.client);
            i && tW.clerk && tW.clerk.updateClient(tJ.getInstance().fromJSON(i));
          }
          isNew() {
            return !this.id;
          }
          path(t) {
            let e = this.pathRoot;
            if (this.isNew()) return e;
            let i = e.replace(/[^/]$/, "$&/") + encodeURIComponent(this.id);
            return t ? i.replace(/[^/]$/, "$&/") + encodeURIComponent(t) : i;
          }
          async _baseGet() {
            let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              e = await tW._fetch({
                method: "GET",
                path: this.path(),
                rotatingTokenNonce: t.rotatingTokenNonce
              }, t);
            return this.fromJSON((null == e ? void 0 : e.response) || e);
          }
          async _baseMutate(t) {
            let {
                action: e,
                body: i,
                method: n = "POST",
                path: r
              } = t,
              s = await tW._fetch({
                method: n,
                path: r || this.path(e),
                body: i
              });
            return this.fromJSON((null == s ? void 0 : s.response) || s);
          }
          async _basePost() {
            let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return this._baseMutate({
              ...t,
              method: "POST"
            });
          }
          async _basePut() {
            let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return this._baseMutate({
              ...t,
              method: "PUT"
            });
          }
          async _basePatch() {
            let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            return this._baseMutate({
              ...t,
              method: "PATCH"
            });
          }
          async _baseDelete() {
            let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            await this._baseMutate({
              ...t,
              method: "DELETE"
            });
          }
          async reload(t) {
            let {
              rotatingTokenNonce: e
            } = t || {};
            return this._baseGet({
              forceUpdateClient: !0,
              rotatingTokenNonce: e
            });
          }
          constructor() {
            d(this, "id", void 0), d(this, "pathRoot", "");
          }
        }
        d(tW, "clerk", void 0);
        class tN extends tW {
          get instanceIsPasswordBased() {
            return this.attributes.password.enabled && this.attributes.password.required;
          }
          get hasValidAuthFactor() {
            return this.attributes.email_address.enabled || this.attributes.phone_number.enabled || this.attributes.password.required && this.attributes.username.required;
          }
          fromJSON(t) {
            var e, i, n;
            return t && (this.social = t.social, this.saml = t.saml, this.attributes = Object.fromEntries(Object.entries(t.attributes).map(t => [t[0], {
              ...t[1],
              name: t[0]
            }])), this.actions = t.actions, this.signIn = t.sign_in, this.signUp = t.sign_up, this.passwordSettings = {
              ...t.password_settings,
              min_length: Math.max(null == t ? void 0 : null === (e = t.password_settings) || void 0 === e ? void 0 : e.min_length, 8),
              max_length: (null == t ? void 0 : null === (i = t.password_settings) || void 0 === i ? void 0 : i.max_length) === 0 ? 72 : Math.min(null == t ? void 0 : null === (n = t.password_settings) || void 0 === n ? void 0 : n.max_length, 72)
            }, this.passkeySettings = t.passkey_settings, this.socialProviderStrategies = this.getSocialProviderStrategies(t.social), this.authenticatableSocialStrategies = this.getAuthenticatableSocialStrategies(t.social), this.web3FirstFactors = this.getWeb3FirstFactors(this.attributes), this.enabledFirstFactorIdentifiers = this.getEnabledFirstFactorIdentifiers(this.attributes)), this;
          }
          getEnabledFirstFactorIdentifiers(t) {
            return t ? Object.entries(t).filter(t => {
              let [e, i] = t;
              return i.used_for_first_factor && !e.startsWith("web3");
            }).map(t => {
              let [e] = t;
              return e;
            }) : [];
          }
          getWeb3FirstFactors(t) {
            return t ? Object.entries(t).filter(t => {
              let [e, i] = t;
              return i.used_for_first_factor && e.startsWith("web3");
            }).map(t => {
              let [, e] = t;
              return e.first_factors;
            }).flat() : [];
          }
          getSocialProviderStrategies(t) {
            return t ? Object.entries(t).filter(t => {
              let [, e] = t;
              return e.enabled;
            }).map(t => {
              let [, e] = t;
              return e.strategy;
            }).sort() : [];
          }
          getAuthenticatableSocialStrategies(t) {
            return t ? Object.entries(t).filter(t => {
              let [, e] = t;
              return e.enabled && e.authenticatable;
            }).map(t => {
              let [, e] = t;
              return e.strategy;
            }).sort() : [];
          }
          constructor(t) {
            super(), d(this, "id", void 0), d(this, "social", void 0), d(this, "saml", void 0), d(this, "attributes", void 0), d(this, "actions", void 0), d(this, "signIn", void 0), d(this, "signUp", void 0), d(this, "passwordSettings", void 0), d(this, "passkeySettings", void 0), d(this, "socialProviderStrategies", []), d(this, "authenticatableSocialStrategies", []), d(this, "web3FirstFactors", []), d(this, "enabledFirstFactorIdentifiers", []), this.fromJSON(t);
          }
        }
        class tF extends tW {
          fromJSON(t) {
            return this.singleSessionMode = !t || t.single_session_mode, this;
          }
          constructor(t) {
            super(), d(this, "singleSessionMode", void 0), this.fromJSON(t);
          }
        }
        function tL(t) {
          let e = new Date(t || new Date());
          return e instanceof Date && !isNaN(e.getTime()) ? e : new Date();
        }
        class tD {
          static fromKey(t) {
            let [e, i, n = ""] = t.split("::");
            return new tD(e, {
              audience: n,
              tokenId: i
            });
          }
          toKey() {
            let {
              tokenId: t,
              audience: e
            } = this.data;
            return [this.prefix, t, e || ""].join("::");
          }
          constructor(t, e) {
            d(this, "prefix", void 0), d(this, "data", void 0), this.prefix = t, this.data = e, this.prefix = t, this.data = e;
          }
        }
        let tj = function () {
          let t,
            e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "clerk",
            i = new Map();
          return {
            get: function (t) {
              let n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : 10,
                r = new tD(e, t),
                s = i.get(r.toKey());
              if (!s) return;
              let a = Math.floor(Date.now() / 1e3) - s.createdAt;
              if (s.expiresIn - a < (n || 1) + 5) {
                i.delete(r.toKey());
                return;
              }
              return s.entry;
            },
            set: n => {
              let r = new tD(e, {
                  audience: n.audience,
                  tokenId: n.tokenId
                }).toKey(),
                s = {
                  entry: n,
                  createdAt: Math.floor(Date.now() / 1e3)
                },
                a = () => {
                  i.get(r) === s && i.delete(r);
                };
              n.tokenResolver.then(e => {
                if (!e.jwt) return a();
                let i = e.jwt.claims.exp - e.jwt.claims.iat;
                s.expiresIn = i, "function" == typeof (t = setTimeout(a, 1e3 * i)).unref && t.unref();
              }).catch(() => {
                a();
              }), i.set(r, s);
            },
            clear: () => {
              clearTimeout(t), i.clear();
            },
            size: () => i.size
          };
        }();
        class tJ extends tW {
          static getInstance() {
            return tJ.instance || (tJ.instance = new tJ()), tJ.instance;
          }
          static isClientResource(t) {
            return !!t && t instanceof tJ;
          }
          get signUpAttempt() {
            return this.signUp;
          }
          get signInAttempt() {
            return this.signIn;
          }
          get activeSessions() {
            return this.sessions.filter(t => "active" === t.status);
          }
          create() {
            return this._basePut();
          }
          fetch() {
            return this._baseGet();
          }
          async destroy() {
            return this._baseDelete({
              path: "/client"
            }).then(() => {
              tj.clear(), this.id = "", this.sessions = [], this.signUp = new e4(null), this.signIn = new eV(null), this.lastActiveSessionId = null, this.cookieExpiresAt = null, this.createdAt = null, this.updatedAt = null;
            });
          }
          removeSessions() {
            return this._baseDelete({
              path: this.path() + "/sessions"
            });
          }
          clearCache() {
            return this.sessions.forEach(t => t.clearCache());
          }
          isEligibleForTouch() {
            return !!this.cookieExpiresAt && this.cookieExpiresAt.getTime() - Date.now() <= 6912e5;
          }
          buildTouchUrl(t) {
            let {
              redirectUrl: e
            } = t;
            return tW.fapiClient.buildUrl({
              method: "GET",
              path: "/client/touch",
              pathPrefix: "v1",
              search: {
                redirect_url: e.toString()
              }
            }).toString();
          }
          fromJSON(t) {
            return t && (this.id = t.id, this.sessions = (t.sessions || []).map(t => new eP(t)), this.signUp = new e4(t.sign_up), this.signIn = new eV(t.sign_in), this.lastActiveSessionId = t.last_active_session_id, this.cookieExpiresAt = t.cookie_expires_at ? tL(t.cookie_expires_at) : null, this.createdAt = tL(t.created_at), this.updatedAt = tL(t.updated_at)), this;
          }
          path() {
            return this.pathRoot;
          }
          constructor(t = null) {
            super(), d(this, "pathRoot", "/client"), d(this, "sessions", []), d(this, "signUp", new e4()), d(this, "signIn", new eV()), d(this, "lastActiveSessionId", null), d(this, "cookieExpiresAt", null), d(this, "createdAt", null), d(this, "updatedAt", null), this.fromJSON(t);
          }
        }
        d(tJ, "instance", void 0);
        class tV {
          fromJSON(t) {
            return t && (this.object = t.object, this.id = t.id, this.slug = t.slug, this.deleted = t.deleted), this;
          }
          constructor(t) {
            d(this, "object", ""), d(this, "id", void 0), d(this, "slug", void 0), d(this, "deleted", !1), this.fromJSON(t);
          }
        }
        class tK extends tW {
          fromJSON(t) {
            return t && (this.id = t.id, this.instanceEnvironmentType = t.instance_environment_type, this.applicationName = t.application_name, this.theme = t.theme, this.preferredSignInStrategy = t.preferred_sign_in_strategy, this.logoImageUrl = t.logo_image_url, this.faviconImageUrl = t.favicon_image_url, this.homeUrl = t.home_url, this.signInUrl = t.sign_in_url, this.signUpUrl = t.sign_up_url, this.userProfileUrl = t.user_profile_url, this.afterSignInUrl = t.after_sign_in_url, this.afterSignUpUrl = t.after_sign_up_url, this.afterSignOutOneUrl = t.after_sign_out_one_url, this.afterSignOutAllUrl = t.after_sign_out_all_url, this.afterSwitchSessionUrl = t.after_switch_session_url, this.branded = t.branded, this.captchaPublicKey = t.captcha_public_key, this.captchaWidgetType = t.captcha_widget_type, this.captchaProvider = t.captcha_provider, this.captchaPublicKeyInvisible = t.captcha_public_key_invisible, this.captchaOauthBypass = t.captcha_oauth_bypass || ["oauth_google", "oauth_microsoft", "oauth_apple"], this.supportEmail = t.support_email || "", this.clerkJSVersion = t.clerk_js_version, this.organizationProfileUrl = t.organization_profile_url, this.createOrganizationUrl = t.create_organization_url, this.afterLeaveOrganizationUrl = t.after_leave_organization_url, this.afterCreateOrganizationUrl = t.after_create_organization_url, this.googleOneTapClientId = t.google_one_tap_client_id, this.showDevModeWarning = t.show_devmode_warning, this.termsUrl = t.terms_url, this.privacyPolicyUrl = t.privacy_policy_url), this;
          }
          constructor(t) {
            super(), d(this, "id", void 0), d(this, "afterSignInUrl", void 0), d(this, "afterSignOutAllUrl", void 0), d(this, "afterSignOutOneUrl", void 0), d(this, "afterSignOutUrl", void 0), d(this, "afterSignUpUrl", void 0), d(this, "afterSwitchSessionUrl", void 0), d(this, "applicationName", void 0), d(this, "backendHost", void 0), d(this, "branded", void 0), d(this, "captchaPublicKey", null), d(this, "captchaWidgetType", null), d(this, "captchaProvider", "turnstile"), d(this, "captchaPublicKeyInvisible", null), d(this, "captchaOauthBypass", []), d(this, "homeUrl", void 0), d(this, "instanceEnvironmentType", void 0), d(this, "faviconImageUrl", void 0), d(this, "logoImageUrl", void 0), d(this, "preferredSignInStrategy", void 0), d(this, "signInUrl", void 0), d(this, "signUpUrl", void 0), d(this, "supportEmail", void 0), d(this, "theme", void 0), d(this, "userProfileUrl", void 0), d(this, "clerkJSVersion", void 0), d(this, "experimental__forceOauthFirst", void 0), d(this, "organizationProfileUrl", void 0), d(this, "createOrganizationUrl", void 0), d(this, "afterLeaveOrganizationUrl", void 0), d(this, "afterCreateOrganizationUrl", void 0), d(this, "googleOneTapClientId", void 0), d(this, "showDevModeWarning", void 0), d(this, "termsUrl", void 0), d(this, "privacyPolicyUrl", void 0), this.fromJSON(t);
          }
        }
        var tB = i("8231");
        class t$ extends tW {
          create() {
            return this._basePost({
              body: {
                email_address: this.emailAddress
              }
            });
          }
          fromJSON(t) {
            return t && (this.id = t.id, this.emailAddress = t.email_address, this.verification = new t5(t.verification), this.linkedTo = (t.linked_to || []).map(t => new t7(t))), this;
          }
          constructor(t, e) {
            super(), d(this, "id", void 0), d(this, "emailAddress", ""), d(this, "linkedTo", []), d(this, "verification", void 0), d(this, "prepareVerification", t => this._basePost({
              action: "prepare_verification",
              body: {
                ...t
              }
            })), d(this, "attemptVerification", t => {
              let {
                code: e
              } = t || {};
              return this._basePost({
                action: "attempt_verification",
                body: {
                  code: e
                }
              });
            }), d(this, "createEmailLinkFlow", () => {
              let {
                run: t,
                stop: e
              } = (0, tB.W)();
              return {
                startEmailLinkFlow: async i => {
                  let {
                    redirectUrl: n
                  } = i;
                  return this.id || tP("SignUp"), await this.prepareVerification({
                    strategy: "email_link",
                    redirectUrl: n
                  }), new Promise((i, n) => {
                    t(() => this.reload().then(t => {
                      "verified" === t.verification.status && (e(), i(t));
                    }).catch(t => {
                      e(), n(t);
                    }));
                  });
                },
                cancelEmailLinkFlow: e
              };
            }), d(this, "destroy", () => this._baseDelete()), d(this, "toString", () => this.emailAddress), this.pathRoot = e, this.fromJSON(t);
          }
        }
        class tq extends tW {
          fromJSON(t) {
            let {
              enabled: e = !1,
              max_allowed_memberships: i = 0,
              actions: n,
              domains: r
            } = t || {};
            return this.enabled = e, this.maxAllowedMemberships = i, this.actions = {
              adminDelete: (null == n ? void 0 : n.admin_delete) || !1
            }, this.domains = {
              enabled: (null == r ? void 0 : r.enabled) || !1,
              enrollmentModes: (null == r ? void 0 : r.enrollment_modes) || [],
              defaultRole: (null == r ? void 0 : r.default_role) || null
            }, this;
          }
          constructor(t) {
            super(), d(this, "enabled", void 0), d(this, "maxAllowedMemberships", void 0), d(this, "actions", void 0), d(this, "domains", void 0), this.fromJSON(t);
          }
        }
        class tG extends tW {
          static getInstance() {
            return tG.instance || (tG.instance = new tG()), tG.instance;
          }
          fetch() {
            let {
              touch: t
            } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
              touch: !1
            };
            return t ? this._basePatch({}) : this._baseGet();
          }
          fromJSON(t) {
            return t && (this.authConfig = new tF(t.auth_config), this.displayConfig = new tK(t.display_config), this.userSettings = new tN(t.user_settings), this.organizationSettings = new tq(t.organization_settings), this.maintenanceMode = t.maintenance_mode), this;
          }
          constructor(t = null) {
            super(), d(this, "pathRoot", "/environment"), d(this, "authConfig", void 0), d(this, "displayConfig", void 0), d(this, "userSettings", void 0), d(this, "organizationSettings", void 0), d(this, "maintenanceMode", void 0), d(this, "isSingleSession", () => this.authConfig.singleSessionMode), d(this, "isProduction", () => "production" === this.displayConfig.instanceEnvironmentType), d(this, "isDevelopmentOrStaging", () => !this.isProduction()), d(this, "onWindowLocationHost", () => this.displayConfig.backendHost === window.location.host), this.fromJSON(t);
          }
        }
        d(tG, "instance", void 0);
        class tH {
          static encode(t) {
            return btoa(String.fromCharCode(...new Uint8Array(t))).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
          }
          static decode(t) {
            let e = atob(t.replace(/-/g, "+").replace(/_/g, "/")),
              i = e.length,
              n = new Uint8Array(i);
            for (let t = 0; t < i; t++) n[t] = e.charCodeAt(t);
            return n.buffer;
          }
        }
        async function tZ(t) {
          try {
            let e = await navigator.credentials.create({
              publicKey: t
            });
            if (!e) return {
              error: new t2("Browser failed to create credential", {
                code: "passkey_registration_failed"
              }),
              publicKeyCredential: null
            };
            return {
              publicKeyCredential: e,
              error: null
            };
          } catch (t) {
            var e;
            return {
              error: "InvalidStateError" === (e = t).name ? new t2(e.message, {
                code: "passkey_already_exists"
              }) : "NotAllowedError" === e.name ? new t2(e.message, {
                code: "passkey_registration_cancelled"
              }) : tX(e),
              publicKeyCredential: null
            };
          }
        }
        let tY = new class {
          __abort() {
            if (!this.controller) return;
            let t = Error();
            t.name = "AbortError", this.controller.abort(t);
          }
          createAbortSignal() {
            this.__abort();
            let t = new AbortController();
            return this.controller = t, t.signal;
          }
          abort() {
            this.__abort(), this.controller = void 0;
          }
          constructor() {
            d(this, "controller", void 0);
          }
        }();
        async function tQ(t) {
          let {
            publicKeyOptions: e,
            conditionalUI: i
          } = t;
          try {
            let t = await navigator.credentials.get({
              publicKey: e,
              mediation: i ? "conditional" : "optional",
              signal: tY.createAbortSignal()
            });
            if (!t) return {
              error: new t2("Browser failed to get credential", {
                code: "passkey_retrieval_failed"
              }),
              publicKeyCredential: null
            };
            return {
              publicKeyCredential: t,
              error: null
            };
          } catch (t) {
            var n;
            return {
              error: "NotAllowedError" === (n = t).name ? new t2(n.message, {
                code: "passkey_retrieval_cancelled"
              }) : tX(n),
              publicKeyCredential: null
            };
          }
        }
        function tX(t) {
          return "AbortError" === t.name ? new t2(t.message, {
            code: "passkey_operation_aborted"
          }) : "SecurityError" === t.name ? new t2(t.message, {
            code: "passkey_invalid_rpID_or_domain"
          }) : t;
        }
        function t0(t) {
          return {
            type: t.type,
            id: t.id,
            rawId: t1(t.rawId),
            authenticatorAttachment: t.authenticatorAttachment
          };
        }
        let t1 = tH.encode.bind(tH),
          t3 = tH.decode.bind(tH);
        class t2 extends f.w$ {
          constructor(t, {
            code: e
          }) {
            super(t, {
              code: e
            }), d(this, "code", void 0), this.code = e;
          }
        }
        class t5 extends tW {
          fromJSON(t) {
            return t && (this.status = t.status, this.verifiedAtClient = t.verified_at_client, this.strategy = t.strategy, this.nonce = t.nonce || null, this.message = t.message || null, t.external_verification_redirect_url ? this.externalVerificationRedirectURL = new URL(t.external_verification_redirect_url) : this.externalVerificationRedirectURL = null, this.attempts = t.attempts, this.expireAt = tL(t.expire_at), this.error = t.error ? (0, f.nU)(t.error) : null), this;
          }
          constructor(t) {
            super(), d(this, "pathRoot", ""), d(this, "status", null), d(this, "strategy", null), d(this, "nonce", null), d(this, "message", null), d(this, "externalVerificationRedirectURL", null), d(this, "attempts", null), d(this, "expireAt", null), d(this, "error", null), d(this, "verifiedAtClient", null), d(this, "verifiedFromTheSameClient", () => {
              var t, e;
              return this.verifiedAtClient === (null === (e = tW.clerk) || void 0 === e ? void 0 : null === (t = e.client) || void 0 === t ? void 0 : t.id);
            }), this.fromJSON(t);
          }
        }
        class t6 extends t5 {
          fromJSON(t) {
            return super.fromJSON(t), (null == t ? void 0 : t.nonce) && (this.publicKey = function (t) {
              let e = t3(t.user.id),
                i = t3(t.challenge),
                n = (t.excludeCredentials || []).map(t => ({
                  ...t,
                  id: t3(t.id)
                }));
              return {
                ...t,
                excludeCredentials: n,
                challenge: i,
                user: {
                  ...t.user,
                  id: e
                }
              };
            }(JSON.parse(t.nonce))), this;
          }
          constructor(t) {
            super(t), d(this, "publicKey", null), this.fromJSON(t);
          }
        }
        class t4 {
          constructor(t) {
            d(this, "emailAddress", void 0), d(this, "phoneNumber", void 0), d(this, "web3Wallet", void 0), d(this, "externalAccount", void 0), t ? (this.emailAddress = new t9(t.email_address), this.phoneNumber = new t9(t.phone_number), this.web3Wallet = new t9(t.web3_wallet), this.externalAccount = new t5(t.external_account)) : (this.emailAddress = new t9(null), this.phoneNumber = new t9(null), this.web3Wallet = new t9(null), this.externalAccount = new t5(null));
          }
        }
        class t9 extends t5 {
          constructor(t) {
            super(t), d(this, "nextAction", void 0), d(this, "supportedStrategies", void 0), t ? (this.nextAction = t.next_action, this.supportedStrategies = t.supported_strategies) : (this.nextAction = "", this.supportedStrategies = []);
          }
        }
        class t8 extends tW {
          fromJSON(t) {
            return t && (this.id = t.id, this.identificationId = t.identification_id, this.providerUserId = t.provider_user_id, this.approvedScopes = t.approved_scopes, this.imageUrl = t.image_url, this.emailAddress = t.email_address, this.firstName = t.first_name, this.lastName = t.last_name, this.provider = (t.provider || "").replace("oauth_", ""), this.username = t.username, this.publicMetadata = t.public_metadata, this.label = t.label, t.verification && (this.verification = new t5(t.verification))), this;
          }
          providerSlug() {
            return this.provider;
          }
          providerTitle() {
            return [(0, J.MI)(this.providerSlug()), "Account"].join(" ");
          }
          accountIdentifier() {
            return this.username || this.emailAddress || this.label;
          }
          constructor(t, e) {
            super(), d(this, "id", void 0), d(this, "identificationId", void 0), d(this, "provider", void 0), d(this, "providerUserId", ""), d(this, "emailAddress", ""), d(this, "approvedScopes", ""), d(this, "firstName", ""), d(this, "lastName", ""), d(this, "imageUrl", ""), d(this, "username", ""), d(this, "publicMetadata", {}), d(this, "label", ""), d(this, "verification", null), d(this, "reauthorize", t => {
              let {
                additionalScopes: e,
                redirectUrl: i
              } = t || {};
              return this._basePatch({
                action: "reauthorize",
                body: {
                  additional_scope: e,
                  redirect_url: i
                }
              });
            }), d(this, "destroy", () => this._baseDelete()), this.pathRoot = e, this.fromJSON(t);
          }
        }
        class t7 extends tW {
          fromJSON(t) {
            return t && (this.id = t.id, this.type = t.type), this;
          }
          constructor(t) {
            super(), d(this, "id", void 0), d(this, "type", void 0), this.fromJSON(t);
          }
        }
        class et extends tW {
          static async create(t) {
            var e;
            let i,
              n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
              r = n;
            return "string" == typeof n.file ? (r = n.file, i = new Headers({
              "Content-Type": "application/octet-stream"
            })) : n.file && (r = new FormData()).append("file", n.file), new et(null === (e = await tW._fetch({
              path: t,
              method: "POST",
              body: r,
              headers: i
            })) || void 0 === e ? void 0 : e.response);
          }
          static async delete(t) {
            var e;
            return new et(null === (e = await tW._fetch({
              path: t,
              method: "DELETE"
            })) || void 0 === e ? void 0 : e.response);
          }
          fromJSON(t) {
            return t && (this.id = t.id, this.name = t.name, this.publicUrl = t.public_url), this;
          }
          constructor(t) {
            super(), d(this, "id", void 0), d(this, "name", null), d(this, "publicUrl", null), this.fromJSON(t);
          }
        }
        class ee extends tW {
          fromJSON(t) {
            return t && (this.id = t.id, this.phoneNumber = t.phone_number, this.reservedForSecondFactor = t.reserved_for_second_factor, this.defaultSecondFactor = t.default_second_factor, this.verification = new t5(t.verification), this.linkedTo = (t.linked_to || []).map(t => new t7(t)), this.backupCodes = t.backup_codes), this;
          }
          constructor(t, e) {
            super(), d(this, "id", void 0), d(this, "phoneNumber", ""), d(this, "reservedForSecondFactor", !1), d(this, "defaultSecondFactor", !1), d(this, "linkedTo", []), d(this, "verification", void 0), d(this, "backupCodes", void 0), d(this, "create", () => this._basePost({
              body: {
                phone_number: this.phoneNumber
              }
            })), d(this, "prepareVerification", () => this._basePost({
              action: "prepare_verification",
              body: {
                strategy: "phone_code"
              }
            })), d(this, "attemptVerification", t => {
              let {
                code: e
              } = t || {};
              return this._basePost({
                action: "attempt_verification",
                body: {
                  code: e
                }
              });
            }), d(this, "setReservedForSecondFactor", t => {
              let {
                reserved: e
              } = t || {};
              return this._basePatch({
                body: {
                  reserved_for_second_factor: e
                }
              });
            }), d(this, "makeDefaultSecondFactor", () => this._basePatch({
              body: {
                default_second_factor: !0
              }
            })), d(this, "destroy", () => this._baseDelete()), d(this, "toString", () => {
              let t = this.phoneNumber.match(/^(\d{3})(\d{3})(\d{4})$/);
              return t ? "(" + t[1] + ") " + t[2] + "-" + t[3] : this.phoneNumber;
            }), this.pathRoot = e, this.fromJSON(t);
          }
        }
        function ei(t) {
          let {
              pageSize: e,
              initialPage: i,
              ...n
            } = t || {},
            r = null != e ? e : 10;
          return new URLSearchParams({
            ...(0, J.hF)(n),
            limit: r + "",
            offset: ((null != i ? i : 1) - 1) * r + ""
          });
        }
        class en extends tW {
          static async create(t, e) {
            var i;
            let {
              name: n
            } = e;
            return new en(null === (i = await tW._fetch({
              path: "/organizations/".concat(t, "/domains"),
              method: "POST",
              body: {
                name: n
              }
            })) || void 0 === i ? void 0 : i.response);
          }
          fromJSON(t) {
            return t && (this.id = t.id, this.name = t.name, this.organizationId = t.organization_id, this.enrollmentMode = t.enrollment_mode, this.affiliationEmailAddress = t.affiliation_email_address, this.totalPendingSuggestions = t.total_pending_suggestions, this.totalPendingInvitations = t.total_pending_invitations, t.verification ? this.verification = {
              status: t.verification.status,
              strategy: t.verification.strategy,
              attempts: t.verification.attempts,
              expiresAt: tL(t.verification.expires_at)
            } : this.verification = null), this;
          }
          constructor(t) {
            super(), d(this, "id", void 0), d(this, "name", void 0), d(this, "organizationId", void 0), d(this, "enrollmentMode", void 0), d(this, "verification", void 0), d(this, "affiliationEmailAddress", void 0), d(this, "createdAt", void 0), d(this, "updatedAt", void 0), d(this, "totalPendingInvitations", void 0), d(this, "totalPendingSuggestions", void 0), d(this, "prepareAffiliationVerification", async t => this._basePost({
              path: "/organizations/".concat(this.organizationId, "/domains/").concat(this.id, "/prepare_affiliation_verification"),
              method: "POST",
              body: t
            })), d(this, "attemptAffiliationVerification", async t => this._basePost({
              path: "/organizations/".concat(this.organizationId, "/domains/").concat(this.id, "/attempt_affiliation_verification"),
              method: "POST",
              body: t
            })), d(this, "updateEnrollmentMode", t => this._basePost({
              path: "/organizations/".concat(this.organizationId, "/domains/").concat(this.id, "/update_enrollment_mode"),
              body: t
            })), d(this, "delete", () => this._baseDelete({
              path: "/organizations/".concat(this.organizationId, "/domains/").concat(this.id)
            })), this.fromJSON(t);
          }
        }
        class er extends tW {
          fromJSON(t) {
            return t && (this.id = t.id, this.organizationId = t.organization_id, this.status = t.status, this.createdAt = tL(t.created_at), this.updatedAt = tL(t.updated_at), t.public_user_data && (this.publicUserData = new eM(t.public_user_data))), this;
          }
          constructor(t) {
            super(), d(this, "id", void 0), d(this, "organizationId", void 0), d(this, "status", void 0), d(this, "publicUserData", void 0), d(this, "createdAt", void 0), d(this, "updatedAt", void 0), d(this, "accept", async () => await this._basePost({
              path: "/organizations/".concat(this.organizationId, "/membership_requests/").concat(this.id, "/accept")
            })), d(this, "reject", async () => await this._basePost({
              path: "/organizations/".concat(this.organizationId, "/membership_requests/").concat(this.id, "/reject")
            })), this.fromJSON(t);
          }
        }
        class es extends tW {
          fromJSON(t) {
            return t && (this.id = t.id, this.key = t.key, this.name = t.name, this.description = t.description, this.type = t.type, this.createdAt = tL(t.created_at), this.updatedAt = tL(t.updated_at)), this;
          }
          constructor(t) {
            super(), d(this, "id", void 0), d(this, "key", void 0), d(this, "name", void 0), d(this, "description", void 0), d(this, "type", void 0), d(this, "createdAt", void 0), d(this, "updatedAt", void 0), this.fromJSON(t);
          }
        }
        class ea extends tW {
          fromJSON(t) {
            return t && (this.id = t.id, this.key = t.key, this.name = t.name, this.description = t.description, this.permissions = t.permissions.map(t => new es(t)), this.createdAt = tL(t.created_at), this.updatedAt = tL(t.updated_at)), this;
          }
          constructor(t) {
            super(), d(this, "id", void 0), d(this, "key", void 0), d(this, "name", void 0), d(this, "description", void 0), d(this, "permissions", []), d(this, "createdAt", void 0), d(this, "updatedAt", void 0), this.fromJSON(t);
          }
        }
        class eo extends tW {
          static async create(t) {
            var e;
            return new eo(null === (e = await tW._fetch({
              path: "/organizations",
              method: "POST",
              body: t
            })) || void 0 === e ? void 0 : e.response);
          }
          static async get(t) {
            var e;
            return new eo(null === (e = await tW._fetch({
              path: "/organizations/".concat(t),
              method: "GET"
            })) || void 0 === e ? void 0 : e.response);
          }
          fromJSON(t) {
            return t && (this.id = t.id, this.name = t.name, this.slug = t.slug, this.imageUrl = t.image_url, this.hasImage = t.has_image, this.publicMetadata = t.public_metadata, this.membersCount = t.members_count, this.pendingInvitationsCount = t.pending_invitations_count, this.maxAllowedMemberships = t.max_allowed_memberships, this.adminDeleteEnabled = t.admin_delete_enabled, this.createdAt = tL(t.created_at), this.updatedAt = tL(t.updated_at)), this;
          }
          async reload(t) {
            var e;
            let {
                rotatingTokenNonce: i
              } = t || {},
              n = null === (e = await tW._fetch({
                path: "/organizations/".concat(this.id),
                method: "GET",
                rotatingTokenNonce: i
              }, {
                forceUpdateClient: !0
              })) || void 0 === e ? void 0 : e.response;
            return this.fromJSON(n);
          }
          constructor(t) {
            super(), d(this, "pathRoot", "/organizations"), d(this, "id", void 0), d(this, "name", void 0), d(this, "slug", void 0), d(this, "imageUrl", void 0), d(this, "hasImage", void 0), d(this, "publicMetadata", {}), d(this, "adminDeleteEnabled", void 0), d(this, "createdAt", void 0), d(this, "updatedAt", void 0), d(this, "membersCount", 0), d(this, "pendingInvitationsCount", 0), d(this, "maxAllowedMemberships", void 0), d(this, "update", async t => this._basePatch({
              body: t
            })), d(this, "getRoles", async t => await tW._fetch({
              path: "/organizations/".concat(this.id, "/roles"),
              method: "GET",
              search: ei(t)
            }, {
              forceUpdateClient: !0
            }).then(t => {
              let {
                data: e,
                total_count: i
              } = null == t ? void 0 : t.response;
              return {
                total_count: i,
                data: e.map(t => new ea(t))
              };
            })), d(this, "getDomains", async t => await tW._fetch({
              path: "/organizations/".concat(this.id, "/domains"),
              method: "GET",
              search: ei(t)
            }, {
              forceUpdateClient: !0
            }).then(t => {
              let {
                data: e,
                total_count: i
              } = null == t ? void 0 : t.response;
              return {
                total_count: i,
                data: e.map(t => new en(t))
              };
            })), d(this, "getDomain", async t => {
              var e;
              let {
                domainId: i
              } = t;
              return new en(null === (e = await tW._fetch({
                path: "/organizations/".concat(this.id, "/domains/").concat(i),
                method: "GET"
              })) || void 0 === e ? void 0 : e.response);
            }), d(this, "getMembershipRequests", async t => await tW._fetch({
              path: "/organizations/".concat(this.id, "/membership_requests"),
              method: "GET",
              search: ei(t)
            }).then(t => {
              let {
                data: e,
                total_count: i
              } = null == t ? void 0 : t.response;
              return {
                total_count: i,
                data: e.map(t => new er(t))
              };
            })), d(this, "createDomain", async t => en.create(this.id, {
              name: t
            })), d(this, "getMemberships", async t => await tW._fetch({
              path: "/organizations/".concat(this.id, "/memberships"),
              method: "GET",
              search: ei({
                ...t,
                paginated: !0
              })
            }).then(t => {
              let {
                data: e,
                total_count: i
              } = null == t ? void 0 : t.response;
              return {
                total_count: i,
                data: e.map(t => new ec(t))
              };
            })), d(this, "getInvitations", async t => await tW._fetch({
              path: "/organizations/".concat(this.id, "/invitations"),
              method: "GET",
              search: ei(t)
            }, {
              forceUpdateClient: !0
            }).then(t => {
              let {
                data: e,
                total_count: i
              } = null == t ? void 0 : t.response;
              return {
                total_count: i,
                data: e.map(t => new el(t))
              };
            })), d(this, "addMember", async t => {
              let {
                userId: e,
                role: i
              } = t;
              return await tW._fetch({
                method: "POST",
                path: "/organizations/".concat(this.id, "/memberships"),
                body: {
                  userId: e,
                  role: i
                }
              }).then(t => new ec(null == t ? void 0 : t.response));
            }), d(this, "inviteMember", async t => el.create(this.id, t)), d(this, "inviteMembers", async t => el.createBulk(this.id, t)), d(this, "updateMember", async t => {
              let {
                userId: e,
                role: i
              } = t;
              return await tW._fetch({
                method: "PATCH",
                path: "/organizations/".concat(this.id, "/memberships/").concat(e),
                body: {
                  role: i
                }
              }).then(t => new ec(null == t ? void 0 : t.response));
            }), d(this, "removeMember", async t => await tW._fetch({
              method: "DELETE",
              path: "/organizations/".concat(this.id, "/memberships/").concat(t)
            }).then(t => new ec(null == t ? void 0 : t.response))), d(this, "destroy", async () => this._baseDelete()), d(this, "setLogo", async t => {
              let e,
                i,
                {
                  file: n
                } = t;
              return null === n ? await tW._fetch({
                path: "/organizations/".concat(this.id, "/logo"),
                method: "DELETE"
              }).then(t => new eo(null == t ? void 0 : t.response)) : ("string" == typeof n ? (e = n, i = new Headers({
                "Content-Type": "application/octet-stream"
              })) : (e = new FormData()).append("file", n), await tW._fetch({
                path: "/organizations/".concat(this.id, "/logo"),
                method: "PUT",
                body: e,
                headers: i
              }).then(t => new eo(null == t ? void 0 : t.response)));
            }), this.fromJSON(t);
          }
        }
        class el extends tW {
          static async create(t, e) {
            var i;
            let {
              emailAddress: n,
              role: r
            } = e;
            return new el(null === (i = await tW._fetch({
              path: "/organizations/".concat(t, "/invitations"),
              method: "POST",
              body: {
                email_address: n,
                role: r
              }
            })) || void 0 === i ? void 0 : i.response);
          }
          static async createBulk(t, e) {
            var i;
            let {
              emailAddresses: n,
              role: r
            } = e;
            return (null === (i = await tW._fetch({
              path: "/organizations/".concat(t, "/invitations/bulk"),
              method: "POST",
              body: {
                email_address: n,
                role: r
              }
            })) || void 0 === i ? void 0 : i.response).map(t => new el(t));
          }
          fromJSON(t) {
            return t && (this.id = t.id, this.emailAddress = t.email_address, this.organizationId = t.organization_id, this.publicMetadata = t.public_metadata, this.role = t.role, this.status = t.status, this.createdAt = tL(t.created_at), this.updatedAt = tL(t.updated_at)), this;
          }
          constructor(t) {
            super(), d(this, "id", void 0), d(this, "emailAddress", void 0), d(this, "organizationId", void 0), d(this, "publicMetadata", {}), d(this, "status", void 0), d(this, "role", void 0), d(this, "createdAt", void 0), d(this, "updatedAt", void 0), d(this, "revoke", async () => await this._basePost({
              path: "/organizations/".concat(this.organizationId, "/invitations/").concat(this.id, "/revoke")
            })), this.fromJSON(t);
          }
        }
        class ec extends tW {
          fromJSON(t) {
            return t && (this.id = t.id, this.organization = new eo(t.organization), this.publicMetadata = t.public_metadata, t.public_user_data && (this.publicUserData = new eM(t.public_user_data)), this.permissions = Array.isArray(t.permissions) ? [...t.permissions] : [], this.role = t.role, this.createdAt = tL(t.created_at), this.updatedAt = tL(t.updated_at)), this;
          }
          reload(t) {
            !function (t) {
              throw Error("".concat(tO, " Calling ").concat(t, ".reload is not currently supported. Please contact support."));
            }("OrganizationMembership");
          }
          constructor(t) {
            super(), d(this, "id", void 0), d(this, "publicMetadata", {}), d(this, "publicUserData", void 0), d(this, "organization", void 0), d(this, "permissions", []), d(this, "role", void 0), d(this, "createdAt", void 0), d(this, "updatedAt", void 0), d(this, "destroy", async () => await this._baseDelete({
              path: "/organizations/".concat(this.organization.id, "/memberships/").concat(this.publicUserData.userId)
            })), d(this, "update", async t => {
              let {
                role: e
              } = t;
              return await this._basePatch({
                path: "/organizations/".concat(this.organization.id, "/memberships/").concat(this.publicUserData.userId),
                body: {
                  role: e
                }
              });
            }), this.fromJSON(t);
          }
        }
        d(ec, "retrieve", async t => await tW._fetch({
          path: "/me/organization_memberships",
          method: "GET",
          search: ei({
            ...t,
            paginated: !0
          })
        }).then(t => {
          let {
            data: e,
            total_count: i
          } = null == t ? void 0 : t.response;
          return {
            total_count: i,
            data: e.map(t => new ec(t))
          };
        }));
        class eh extends tW {
          static async retrieve(t) {
            return await tW._fetch({
              path: "/me/organization_suggestions",
              method: "GET",
              search: ei(t)
            }).then(t => {
              let {
                data: e,
                total_count: i
              } = null == t ? void 0 : t.response;
              return {
                total_count: i,
                data: e.map(t => new eh(t))
              };
            });
          }
          fromJSON(t) {
            return t && (this.id = t.id, this.status = t.status, this.publicOrganizationData = {
              hasImage: t.public_organization_data.has_image,
              imageUrl: t.public_organization_data.image_url,
              name: t.public_organization_data.name,
              id: t.public_organization_data.id,
              slug: t.public_organization_data.slug
            }, this.createdAt = tL(t.created_at), this.updatedAt = tL(t.updated_at)), this;
          }
          constructor(t) {
            super(), d(this, "id", void 0), d(this, "publicOrganizationData", void 0), d(this, "status", void 0), d(this, "createdAt", void 0), d(this, "updatedAt", void 0), d(this, "accept", async () => await this._basePost({
              path: "/me/organization_suggestions/".concat(this.id, "/accept")
            })), this.fromJSON(t);
          }
        }
        class ed extends tW {
          fromJSON(t) {
            return t && (this.id = t.id, this.provider = t.provider, this.providerUserId = t.provider_user_id, this.active = t.active, this.emailAddress = t.email_address, this.firstName = t.first_name, this.lastName = t.last_name, t.verification && (this.verification = new t5(t.verification)), t.saml_connection && (this.samlConnection = new eu(t.saml_connection))), this;
          }
          constructor(t, e) {
            super(), d(this, "id", void 0), d(this, "provider", "saml_custom"), d(this, "providerUserId", null), d(this, "active", !1), d(this, "emailAddress", ""), d(this, "firstName", ""), d(this, "lastName", ""), d(this, "verification", null), d(this, "samlConnection", null), this.pathRoot = e, this.fromJSON(t);
          }
        }
        class eu extends tW {
          fromJSON(t) {
            return t && (this.id = t.id, this.name = t.name, this.domain = t.domain, this.active = t.active, this.provider = t.provider, this.syncUserAttributes = t.sync_user_attributes, this.allowSubdomains = t.allow_subdomains, this.allowIdpInitiated = t.allow_idp_initiated, this.disableAdditionalIdentifications = t.disable_additional_identifications, this.createdAt = tL(t.created_at), this.updatedAt = tL(t.updated_at)), this;
          }
          constructor(t) {
            super(), d(this, "id", void 0), d(this, "name", void 0), d(this, "domain", void 0), d(this, "active", void 0), d(this, "provider", void 0), d(this, "syncUserAttributes", void 0), d(this, "allowSubdomains", void 0), d(this, "allowIdpInitiated", void 0), d(this, "disableAdditionalIdentifications", void 0), d(this, "createdAt", void 0), d(this, "updatedAt", void 0), this.fromJSON(t);
          }
        }
        function ep(t, e, i) {
          if (!e.has(t)) throw TypeError("attempted to get private field on non-instance");
          return i;
        }
        function ef(t, e) {
          o(t, e), e.add(t);
        }
        var em = {
            veryStrict: {
              afterMinutes: 10,
              level: "multiFactor"
            },
            strict: {
              afterMinutes: 10,
              level: "secondFactor"
            },
            moderate: {
              afterMinutes: 60,
              level: "secondFactor"
            },
            lax: {
              afterMinutes: 1440,
              level: "secondFactor"
            }
          },
          ev = new Set(["firstFactor", "secondFactor", "multiFactor"]),
          eg = new Set(["veryStrict", "strict", "moderate", "lax"]),
          ew = t => "number" == typeof t && t > 0,
          e_ = t => ev.has(t),
          eb = t => eg.has(t),
          ey = (t, e) => {
            let {
              orgId: i,
              orgRole: n,
              orgPermissions: r
            } = e;
            return (t.role || t.permission) && i && n && r ? t.permission ? r.includes(t.permission) : t.role ? n === t.role : null : null;
          },
          ek = t => !!("string" == typeof t && eb(t) || "object" == typeof t && e_(t.level) && ew(t.afterMinutes)) && (t => "string" == typeof t ? em[t] : t).bind(null, t),
          eS = (t, {
            __experimental_factorVerificationAge: e
          }) => {
            if (!t.__experimental_reverification || !e) return null;
            let i = ek(t.__experimental_reverification);
            if (!i) return null;
            let {
                level: n,
                afterMinutes: r
              } = i(),
              [s, a] = e,
              o = -1 !== s ? r > s : null,
              l = -1 !== a ? r > a : null;
            switch (n) {
              case "firstFactor":
                return o;
              case "secondFactor":
                return -1 !== a ? l : o;
              case "multiFactor":
                return -1 === a ? o : o && l;
            }
          },
          eU = t => e => {
            if (!t.userId) return !1;
            let i = ey(e, t),
              n = eS(e, t);
            return [i, n].some(t => null === t) ? [i, n].some(t => !0 === t) : [i, n].every(t => !0 === t);
          };
        let eA = {
            TokenUpdate: "token:update"
          },
          eO = (() => {
            let t = new Map();
            return {
              on: (e, i) => {
                var n;
                t.get(e) || t.set(e, []), null === (n = t.get(e)) || void 0 === n || n.push(i);
              },
              dispatch: (e, i) => {
                (t.get(e) || []).forEach(t => "function" == typeof t && t(i));
              },
              off: (e, i) => {
                let n = t.get(e) || [];
                n.length && (i && t.set(e, n.filter(t => t !== i)), t.set(e, []));
              }
            };
          })();
        class eI extends tW {
          fromJSON(t) {
            return t && (this.id = t.id, this.status = t.status, this.session = new eP(t.session), this.level = t.level, this.supportedFirstFactors = (0, J.aw)(t.supported_first_factors), this.supportedSecondFactors = (0, J.aw)(t.supported_second_factors), this.firstFactorVerification = new t5(t.first_factor_verification), this.secondFactorVerification = new t5(t.second_factor_verification)), this;
          }
          constructor(t = null) {
            super(), d(this, "status", void 0), d(this, "level", void 0), d(this, "session", void 0), d(this, "supportedFirstFactors", []), d(this, "supportedSecondFactors", []), d(this, "firstFactorVerification", new t5(null)), d(this, "secondFactorVerification", new t5(null)), this.fromJSON(t);
          }
        }
        var eC = new WeakMap(),
          eE = new WeakSet();
        class eP extends tW {
          static isSessionResource(t) {
            return !!t && t instanceof eP;
          }
          fromJSON(t) {
            return t && (this.id = t.id, this.status = t.status, this.expireAt = tL(t.expire_at), this.abandonAt = tL(t.abandon_at), this.__experimental_factorVerificationAge = t.factor_verification_age, this.lastActiveAt = tL(t.last_active_at), this.lastActiveOrganizationId = t.last_active_organization_id, this.actor = t.actor, this.createdAt = tL(t.created_at), this.updatedAt = tL(t.updated_at), this.user = new ie(t.user), t.public_user_data && (this.publicUserData = new eM(t.public_user_data)), this.lastActiveToken = t.last_active_token ? new e9(t.last_active_token) : null), this;
          }
          async _getToken(t) {
            if (!this.user) return null;
            let {
                leewayInSeconds: e,
                template: i,
                skipCache: n = !1
              } = t || {},
              r = void 0 === (null == t ? void 0 : t.organizationId) ? this.lastActiveOrganizationId : null == t ? void 0 : t.organizationId;
            if (!i && Number(e) >= 60) throw Error("Leeway can not exceed the token lifespan (60 seconds)");
            let s = ep(this, eE, ex).call(this, i, r),
              a = n ? void 0 : tj.get({
                tokenId: s
              }, e),
              o = !i && r === this.lastActiveOrganizationId;
            if (a) {
              let t = await a.tokenResolver;
              return o && eO.dispatch(eA.TokenUpdate, {
                token: t
              }), t.getRawString() || null;
            }
            let l = i ? "".concat(this.path(), "/tokens/").concat(i) : "".concat(this.path(), "/tokens"),
              c = i ? {} : {
                organizationId: r
              },
              h = e9.create(l, c);
            return tj.set({
              tokenId: s,
              tokenResolver: h
            }), h.then(t => (o && eO.dispatch(eA.TokenUpdate, {
              token: t
            }), t.getRawString() || null));
          }
          constructor(t) {
            super(), ef(this, eE), d(this, "pathRoot", "/client/sessions"), d(this, "id", void 0), d(this, "status", void 0), d(this, "lastActiveAt", void 0), d(this, "lastActiveToken", void 0), d(this, "lastActiveOrganizationId", void 0), d(this, "actor", void 0), d(this, "user", void 0), d(this, "publicUserData", void 0), d(this, "__experimental_factorVerificationAge", null), d(this, "expireAt", void 0), d(this, "abandonAt", void 0), d(this, "createdAt", void 0), d(this, "updatedAt", void 0), d(this, "end", () => (tj.clear(), this._basePost({
              action: "end"
            }))), d(this, "remove", () => (tj.clear(), this._basePost({
              action: "remove"
            }))), d(this, "touch", () => this._basePost({
              action: "touch",
              body: {
                active_organization_id: this.lastActiveOrganizationId
              }
            })), d(this, "clearCache", () => tj.clear()), d(this, "getToken", async t => (0, k.$V)(() => this._getToken(t), {
              shouldRetry: (t, e) => !(0, f.ix)(t) && e < 4
            })), d(this, "checkAuthorization", t => {
              var e, i;
              let n = ((null === (e = this.user) || void 0 === e ? void 0 : e.organizationMemberships) || []).find(t => t.organization.id === this.lastActiveOrganizationId);
              return eU({
                userId: null === (i = this.user) || void 0 === i ? void 0 : i.id,
                __experimental_factorVerificationAge: this.__experimental_factorVerificationAge,
                orgId: null == n ? void 0 : n.id,
                orgRole: null == n ? void 0 : n.role,
                orgPermissions: null == n ? void 0 : n.permissions
              })(t);
            }), l(this, eC, {
              writable: !0,
              value: t => {
                t && (tj.set({
                  tokenId: ep(this, eE, ex).call(this),
                  tokenResolver: Promise.resolve(t)
                }), eO.dispatch(eA.TokenUpdate, {
                  token: t
                }));
              }
            }), d(this, "__experimental_startVerification", async t => {
              var e;
              let {
                level: i
              } = t;
              return new eI(null === (e = await tW._fetch({
                method: "POST",
                path: "/client/sessions/".concat(this.id, "/verify"),
                body: {
                  level: i
                }
              })) || void 0 === e ? void 0 : e.response);
            }), d(this, "__experimental_prepareFirstFactorVerification", async t => {
              var e;
              let i;
              switch (t.strategy) {
                case "email_code":
                  i = {
                    emailAddressId: t.emailAddressId
                  };
                  break;
                case "phone_code":
                  i = {
                    phoneNumberId: t.phoneNumberId,
                    default: t.default
                  };
                  break;
                default:
                  tx("Session.prepareFirstFactorVerification", t.strategy);
              }
              return new eI(null === (e = await tW._fetch({
                method: "POST",
                path: "/client/sessions/".concat(this.id, "/verify/prepare_first_factor"),
                body: {
                  ...i,
                  strategy: t.strategy
                }
              })) || void 0 === e ? void 0 : e.response);
            }), d(this, "__experimental_attemptFirstFactorVerification", async t => {
              var e;
              return new eI(null === (e = await tW._fetch({
                method: "POST",
                path: "/client/sessions/".concat(this.id, "/verify/attempt_first_factor"),
                body: {
                  ...t,
                  strategy: t.strategy
                }
              })) || void 0 === e ? void 0 : e.response);
            }), d(this, "__experimental_prepareSecondFactorVerification", async t => {
              var e;
              return new eI(null === (e = await tW._fetch({
                method: "POST",
                path: "/client/sessions/".concat(this.id, "/verify/prepare_second_factor"),
                body: t
              })) || void 0 === e ? void 0 : e.response);
            }), d(this, "__experimental_attemptSecondFactorVerification", async t => {
              var e;
              return new eI(null === (e = await tW._fetch({
                method: "POST",
                path: "/client/sessions/".concat(this.id, "/verify/attempt_second_factor"),
                body: t
              })) || void 0 === e ? void 0 : e.response);
            }), this.fromJSON(t), a(this, eC).call(this, this.lastActiveToken);
          }
        }
        function ex(t, e) {
          let i = void 0 === e ? this.lastActiveOrganizationId : e;
          return [this.id, t, i, this.updatedAt.getTime()].filter(Boolean).join("-");
        }
        var eT = i("5263");
        class eR extends tW {
          static async create() {
            return tW._fetch({
              path: "/me/passkeys",
              method: "POST"
            }).then(t => new eR(null == t ? void 0 : t.response));
          }
          static async attemptVerification(t, e) {
            let i = function (t) {
              let e = t.response;
              return {
                ...t0(t),
                response: {
                  clientDataJSON: t1(e.clientDataJSON),
                  attestationObject: t1(e.attestationObject),
                  transports: e.getTransports()
                }
              };
            }(e);
            return tW._fetch({
              path: "/me/passkeys/".concat(t, "/attempt_verification"),
              method: "POST",
              body: {
                strategy: "passkey",
                publicKeyCredential: JSON.stringify(i)
              }
            }).then(t => new eR(null == t ? void 0 : t.response));
          }
          static async registerPasskey() {
            var t;
            if (!(0, eT.iW)()) throw new t2("Passkeys are not supported on this device.", {
              code: "passkey_not_supported"
            });
            let e = await this.create(),
              {
                verification: i
              } = e,
              n = null == i ? void 0 : i.publicKey;
            if (n || tz("create"), (null === (t = n.authenticatorSelection) || void 0 === t ? void 0 : t.authenticatorAttachment) === "platform" && !(await (0, eT.C6)())) throw new t2("Registration requires a platform authenticator but the device does not support it.", {
              code: "passkey_pa_not_supported"
            });
            let {
              publicKeyCredential: r,
              error: s
            } = await tZ(n);
            if (!r) throw s;
            return this.attemptVerification(e.id, r);
          }
          fromJSON(t) {
            return t && (this.id = t.id, this.name = t.name, this.lastUsedAt = t.last_used_at ? tL(t.last_used_at) : null, this.createdAt = tL(t.created_at), this.updatedAt = tL(t.updated_at), t.verification && (this.verification = new t6(t.verification))), this;
          }
          constructor(t) {
            super(), d(this, "id", void 0), d(this, "pathRoot", "/me/passkeys"), d(this, "verification", null), d(this, "name", null), d(this, "lastUsedAt", null), d(this, "createdAt", void 0), d(this, "updatedAt", void 0), d(this, "update", t => this._basePatch({
              body: t
            })), d(this, "delete", async () => {
              var t;
              return new tV(null === (t = await tW._fetch({
                path: this.path(),
                method: "DELETE"
              })) || void 0 === t ? void 0 : t.response);
            }), this.fromJSON(t);
          }
        }
        class eM {
          fromJSON(t) {
            return t && (this.firstName = t.first_name, this.lastName = t.last_name, this.imageUrl = t.image_url, this.hasImage = t.has_image, this.identifier = t.identifier, this.userId = t.user_id), this;
          }
          constructor(t) {
            d(this, "firstName", void 0), d(this, "lastName", void 0), d(this, "imageUrl", void 0), d(this, "hasImage", void 0), d(this, "identifier", void 0), d(this, "userId", void 0), this.fromJSON(t);
          }
        }
        let ez = t => ({
          id: t.id,
          deviceType: t.device_type,
          browserName: t.browser_name,
          browserVersion: t.browser_version,
          country: t.country,
          city: t.city,
          isMobile: t.is_mobile,
          ipAddress: t.ip_address
        });
        class eW extends tW {
          static retrieve() {
            var t;
            let e = null === (t = tW.clerk.session) || void 0 === t ? void 0 : t.id;
            return this.clerk.getFapiClient().request({
              method: "GET",
              path: "/me/sessions/active",
              sessionId: e
            }).then(t => t.payload.map(t => new eW(t, "/me/sessions"))).catch(() => []);
          }
          revoke() {
            return this._basePost({
              action: "revoke",
              body: {}
            });
          }
          fromJSON(t) {
            var e;
            return t && (this.id = t.id, this.status = t.status, this.expireAt = tL(t.expire_at), this.abandonAt = tL(t.abandon_at), this.lastActiveAt = tL(t.last_active_at), this.latestActivity = ez(null !== (e = t.latest_activity) && void 0 !== e ? e : {}), this.actor = t.actor), this;
          }
          constructor(t, e) {
            super(), d(this, "pathRoot", ""), d(this, "id", void 0), d(this, "status", void 0), d(this, "abandonAt", void 0), d(this, "expireAt", void 0), d(this, "lastActiveAt", void 0), d(this, "latestActivity", void 0), d(this, "actor", void 0), this.pathRoot = e, this.fromJSON(t);
          }
        }
        let eN = () => Promise.all([i.e("948").then(i.bind(i, 1134)), i.e("90").then(i.bind(i, 6869))]).then(t => {
            let [e, i] = t,
              {
                zxcvbnOptions: n,
                zxcvbn: r
              } = e,
              {
                dictionary: s,
                adjacencyGraphs: a
              } = i;
            return n.setOptions({
              dictionary: {
                ...s
              },
              graphs: a
            }), r;
          }),
          eF = t => {
            let e;
            if (t.allowed_special_characters) {
              let i = t.allowed_special_characters.replace("[", "\\[");
              i = i.replace("]", "\\]"), e = new RegExp("[".concat(i, "]"));
            } else e = /[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]/;
            return (t, i) => {
              let {
                minLength: n,
                maxLength: r
              } = i;
              return {
                max_length: t.length < r,
                min_length: t.length >= n,
                require_numbers: /\d/.test(t),
                require_lowercase: /[a-z]/.test(t),
                require_uppercase: /[A-Z]/.test(t),
                require_special_char: e.test(t)
              };
            };
          },
          eL = (t, e) => {
            let {
                max_length: i,
                min_length: n,
                require_special_char: r,
                require_lowercase: s,
                require_numbers: a,
                require_uppercase: o
              } = e,
              l = eF(e)(t, {
                maxLength: e.max_length,
                minLength: e.min_length
              }),
              c = {
                max_length: i,
                min_length: n,
                require_special_char: r,
                require_lowercase: s,
                require_numbers: a,
                require_uppercase: o
              },
              h = new Map();
            for (let t in c) c[t] && (l[t] || h.set(t, !0));
            return Object.freeze(Object.fromEntries(h));
          },
          eD = t => e => eL(e, t),
          ej = t => {
            let {
              min_zxcvbn_strength: e,
              onResult: i
            } = t;
            return t => n => {
              let r = t(n);
              return (null == i || i(r), r.score >= e && r.score < 3) ? {
                state: "pass",
                keys: ["unstable__errors.zxcvbn.couldBeStronger"],
                result: r
              } : r.score >= e ? {
                state: "excellent",
                result: r
              } : {
                state: "fail",
                keys: ["unstable__errors.zxcvbn.notEnough", ...r.feedback.suggestions.map(t => "unstable__errors.zxcvbn.suggestions.".concat(t))],
                result: r
              };
            };
          },
          eJ = (t, e) => {
            let {
                onValidation: i = k.ZT,
                onValidationComplexity: n = k.ZT
              } = e || {},
              {
                show_zxcvbn: r,
                validatePassword: s
              } = t,
              a = eD(t),
              o = ej(t),
              l = {};
            return (t, e) => {
              let {
                onValidation: c = i,
                onValidationComplexity: h = n
              } = e || {};
              if (!s) return;
              let d = a(t);
              h(0 === Object.keys(d).length), l = {
                ...l,
                complexity: d
              }, r && eN().then(e => {
                let i = o(e)(t);
                c({
                  ...(l = {
                    ...l,
                    strength: i
                  }),
                  strength: i
                });
              }), (!l.complexity || 0 !== Object.keys(l.complexity).length || !r) && c(l);
            };
          };
        class eV extends tW {
          fromJSON(t) {
            return t && (this.id = t.id, this.status = t.status, this.supportedIdentifiers = t.supported_identifiers, this.identifier = t.identifier, this.supportedFirstFactors = (0, J.aw)(t.supported_first_factors), this.supportedSecondFactors = (0, J.aw)(t.supported_second_factors), this.firstFactorVerification = new t5(t.first_factor_verification), this.secondFactorVerification = new t5(t.second_factor_verification), this.createdSessionId = t.created_session_id, this.userData = new eK(t.user_data)), this;
          }
          constructor(t = null) {
            super(), d(this, "pathRoot", "/client/sign_ins"), d(this, "id", void 0), d(this, "status", null), d(this, "supportedIdentifiers", []), d(this, "supportedFirstFactors", []), d(this, "supportedSecondFactors", null), d(this, "firstFactorVerification", new t5(null)), d(this, "secondFactorVerification", new t5(null)), d(this, "identifier", null), d(this, "createdSessionId", null), d(this, "userData", new eK(null)), d(this, "create", t => this._basePost({
              path: this.pathRoot,
              body: t
            })), d(this, "resetPassword", t => this._basePost({
              body: t,
              action: "reset_password"
            })), d(this, "prepareFirstFactor", t => {
              let e;
              switch (t.strategy) {
                case "passkey":
                  e = {};
                  break;
                case "email_link":
                  e = {
                    emailAddressId: t.emailAddressId,
                    redirectUrl: t.redirectUrl
                  };
                  break;
                case "email_code":
                case "reset_password_email_code":
                  e = {
                    emailAddressId: t.emailAddressId
                  };
                  break;
                case "phone_code":
                  e = {
                    phoneNumberId: t.phoneNumberId,
                    default: t.default
                  };
                  break;
                case "web3_metamask_signature":
                case "web3_coinbase_wallet_signature":
                  e = {
                    web3WalletId: t.web3WalletId
                  };
                  break;
                case "reset_password_phone_code":
                  e = {
                    phoneNumberId: t.phoneNumberId
                  };
                  break;
                case "saml":
                  e = {
                    redirectUrl: t.redirectUrl,
                    actionCompleteRedirectUrl: t.actionCompleteRedirectUrl
                  };
                  break;
                default:
                  tx("SignIn.prepareFirstFactor", t.strategy);
              }
              return this._basePost({
                body: {
                  ...e,
                  strategy: t.strategy
                },
                action: "prepare_first_factor"
              });
            }), d(this, "attemptFirstFactor", t => {
              let e;
              return e = "passkey" === t.strategy ? {
                publicKeyCredential: JSON.stringify(function (t) {
                  let e = t.response;
                  return {
                    ...t0(t),
                    response: {
                      clientDataJSON: t1(e.clientDataJSON),
                      authenticatorData: t1(e.authenticatorData),
                      signature: t1(e.signature),
                      userHandle: e.userHandle ? t1(e.userHandle) : null
                    }
                  };
                }(t.publicKeyCredential))
              } : {
                ...t
              }, this._basePost({
                body: {
                  ...e,
                  strategy: t.strategy
                },
                action: "attempt_first_factor"
              });
            }), d(this, "createEmailLinkFlow", () => {
              let {
                run: t,
                stop: e
              } = (0, tB.W)();
              return {
                startEmailLinkFlow: async i => {
                  let {
                    emailAddressId: n,
                    redirectUrl: r
                  } = i;
                  return this.id || tP("SignIn"), await this.prepareFirstFactor({
                    strategy: "email_link",
                    emailAddressId: n,
                    redirectUrl: r
                  }), new Promise((i, n) => {
                    t(() => this.reload().then(t => {
                      let n = t.firstFactorVerification.status;
                      ("verified" === n || "expired" === n) && (e(), i(t));
                    }).catch(t => {
                      e(), n(t);
                    }));
                  });
                },
                cancelEmailLinkFlow: e
              };
            }), d(this, "prepareSecondFactor", t => this._basePost({
              body: t,
              action: "prepare_second_factor"
            })), d(this, "attemptSecondFactor", t => this._basePost({
              body: t,
              action: "attempt_second_factor"
            })), d(this, "authenticateWithRedirect", async t => {
              let {
                  strategy: e,
                  redirectUrl: i,
                  redirectUrlComplete: n,
                  identifier: r
                } = t || {},
                {
                  firstFactorVerification: s
                } = "saml" === e && this.id ? await this.prepareFirstFactor({
                  strategy: e,
                  redirectUrl: eV.clerk.buildUrlWithAuth(i),
                  actionCompleteRedirectUrl: n
                }) : await this.create({
                  strategy: e,
                  identifier: r,
                  redirectUrl: eV.clerk.buildUrlWithAuth(i),
                  actionCompleteRedirectUrl: n
                }),
                {
                  status: a,
                  externalVerificationRedirectURL: o
                } = s;
              "unverified" === a && o ? C(o) : tM(a, eV.fapiClient.buildEmailAddress("support"));
            }), d(this, "authenticateWithWeb3", async t => {
              var e;
              let i;
              let {
                  identifier: n,
                  generateSignature: r,
                  strategy: s = "web3_metamask_signature"
                } = t || {},
                a = s.replace("web3_", "").replace("_signature", "");
              "function" != typeof r && tR("generateSignature"), await this.create({
                identifier: n
              });
              let o = null === (e = this.supportedFirstFactors) || void 0 === e ? void 0 : e.find(t => t.strategy === s);
              o || tT("SignIn"), await this.prepareFirstFactor(o);
              let {
                message: l
              } = this.firstFactorVerification;
              l || tT("SignIn");
              try {
                i = await r({
                  identifier: n,
                  nonce: l,
                  provider: a
                });
              } catch (t) {
                if ("coinbase_wallet" === a && 4001 === t.code) i = await r({
                  identifier: n,
                  nonce: l,
                  provider: a
                });else throw t;
              }
              return this.attemptFirstFactor({
                signature: i,
                strategy: s
              });
            }), d(this, "authenticateWithMetamask", async () => {
              let t = await t_();
              return this.authenticateWithWeb3({
                identifier: t,
                generateSignature: ty,
                strategy: "web3_metamask_signature"
              });
            }), d(this, "authenticateWithCoinbaseWallet", async () => {
              let t = await tb();
              return this.authenticateWithWeb3({
                identifier: t,
                generateSignature: tk,
                strategy: "web3_coinbase_wallet_signature"
              });
            }), d(this, "authenticateWithPasskey", async t => {
              let {
                flow: e
              } = t || {};
              if (!(0, eT.iW)()) throw new t2("Passkeys are not supported", {
                code: "passkey_not_supported"
              });
              if ("autofill" === e || "discoverable" === e) await this.create({
                strategy: "passkey"
              });else {
                let t = this.supportedFirstFactors.find(t => "passkey" === t.strategy);
                t || function () {
                  throw Error("".concat(tO, " You need to start a SignIn flow by calling SignIn.create({ strategy: 'passkey' }) first"));
                }(), await this.prepareFirstFactor(t);
              }
              let {
                  nonce: i
                } = this.firstFactorVerification,
                n = i ? function (t) {
                  let e = t3(t.challenge),
                    i = (t.allowCredentials || []).map(t => ({
                      ...t,
                      id: t3(t.id)
                    }));
                  return {
                    ...t,
                    allowCredentials: i,
                    challenge: e
                  };
                }(JSON.parse(i)) : null;
              n || tz("get");
              let r = !1;
              "autofill" === e && (r = await (0, eT.h_)());
              let {
                publicKeyCredential: s,
                error: a
              } = await tQ({
                publicKeyOptions: n,
                conditionalUI: r
              });
              if (!s) throw a;
              return this.attemptFirstFactor({
                publicKeyCredential: s,
                strategy: "passkey"
              });
            }), d(this, "validatePassword", (t, e) => {
              var i, n;
              if (null === (i = eV.clerk.__unstable__environment) || void 0 === i ? void 0 : i.userSettings.passwordSettings) return eJ({
                ...(null === (n = eV.clerk.__unstable__environment) || void 0 === n ? void 0 : n.userSettings.passwordSettings),
                validatePassword: !0
              })(t, e);
            }), this.fromJSON(t);
          }
        }
        class eK {
          fromJSON(t) {
            return t && (this.firstName = t.first_name, this.lastName = t.last_name, this.imageUrl = t.image_url, this.hasImage = t.has_image), this;
          }
          constructor(t) {
            d(this, "firstName", void 0), d(this, "lastName", void 0), d(this, "imageUrl", void 0), d(this, "hasImage", void 0), this.fromJSON(t);
          }
        }
        function eB(t) {
          let e = [],
            i = [];
          async function n(t) {
            for await (let i of ["undefined" != typeof window && window.__unstable__onBeforeRequest, ...e].filter(t => t)) if ((await i(t)) === !1) return !1;
            return !0;
          }
          async function r(t, e) {
            for await (let n of ["undefined" != typeof window && window.__unstable__onAfterResponse, ...i].filter(t => t)) if ((await n(t, e)) === !1) return !1;
            return !0;
          }
          function s(e) {
            let {
                method: i,
                path: n,
                sessionId: r,
                search: s,
                rotatingTokenNonce: a
              } = e,
              o = new URLSearchParams(s);
            return t.version && o.append("_clerk_js_version", t.version), a && o.append("rotating_token_nonce", a), "development" === t.instanceType && t.isSatellite && o.append("__domain", t.domain), i && "GET" !== i && "POST" !== i && o.append("_method", i), n && !n.startsWith("/client") && r && o.append("_clerk_session_id", r), B([...o.entries()].reduce((t, e) => {
              let [i, n] = e;
              return t[i] = n.includes(",") ? n.split(",") : n, t;
            }, {}));
          }
          function a(e) {
            let {
                path: i,
                pathPrefix: n = "v1"
              } = e,
              {
                proxyUrl: r,
                domain: a,
                frontendApi: o,
                instanceType: l
              } = t;
            if (r) {
              let t = new URL(r),
                a = t.pathname.slice(1, t.pathname.length);
              return Z({
                base: t.origin,
                pathname: "".concat(a, "/").concat(n).concat(i),
                search: s(e)
              }, {
                stringify: !1
              });
            }
            return Z({
              base: "https://".concat(("production" === l ? a : "") || o),
              pathname: "".concat(n).concat(i),
              search: s(e)
            }, {
              stringify: !1
            });
          }
          async function o(e) {
            var i;
            let s;
            let {
              method: o = "GET",
              body: l
            } = e;
            e.url = a({
              ...e,
              sessionId: null === (i = t.session) || void 0 === i ? void 0 : i.id
            }), e.headers || (e.headers = new Headers()), "GET" === o || l instanceof FormData || e.headers.has("content-type") || e.headers.set("content-type", "application/x-www-form-urlencoded"), "application/x-www-form-urlencoded" === e.headers.get("content-type") && (e.body = l ? B(l, {
              keyEncoder: J.a1
            }) : l);
            let c = await n(e),
              h = "GET" === o ? "GET" : "POST",
              d = e.url.toString(),
              p = {
                ...e,
                credentials: "include",
                method: h
              };
            try {
              if (c) {
                let t = (0, u.TN)() ? 4 : 11;
                s = "GET" === h ? await (0, k.$V)(() => fetch(d, p), {
                  firstDelay: 500,
                  maxDelay: 3e3,
                  shouldRetry: (e, i) => i < t
                }) : await fetch(d, p);
              } else s = new Response("{}", e);
            } catch (t) {
              !function (t, e) {
                throw Error("".concat(tO, ' Network error at "').concat(t, '" - ').concat(e, ". Please try again."));
              }(d, t);
            }
            let f = await s.json(),
              m = Object.assign(s, {
                payload: f
              });
            return await r(e, m), m;
          }
          return {
            buildEmailAddress: function (e) {
              return function (t) {
                let {
                    localPart: e,
                    frontendApi: i
                  } = t,
                  n = i ? i.replace("clerk.", "") : "clerk.com";
                return "".concat(e, "@").concat(n);
              }({
                localPart: e,
                frontendApi: t.frontendApi
              });
            },
            buildUrl: a,
            onAfterResponse: function (t) {
              i.push(t);
            },
            onBeforeRequest: function (t) {
              e.push(t);
            },
            request: o
          };
        }
        let e$ = t => {
          let e = t.__unstable__environment,
            i = eB(t),
            n = e ? e.displayConfig.captchaProvider : "turnstile";
          return {
            captchaSiteKey: e ? e.displayConfig.captchaPublicKey : null,
            captchaWidgetType: e ? e.displayConfig.captchaWidgetType : null,
            captchaProvider: n,
            captchaPublicKeyInvisible: e ? e.displayConfig.captchaPublicKeyInvisible : null,
            canUseCaptcha: e ? e.userSettings.signUp.captcha_enabled && t.isStandardBrowser && "production" === t.instanceType : null,
            captchaURL: i.buildUrl({
              path: "hcaptcha" == n ? "hcaptcha/1/api.js" : "cloudflare/turnstile/v0/api.js",
              pathPrefix: "",
              search: "?render=explicit"
            }).toString()
          };
        };
        var eq = i("5339");
        async function eG(t = "", e) {
          let {
            async: i,
            defer: n,
            beforeLoad: r,
            crossOrigin: s,
            nonce: a
          } = e || {};
          return (0, eq.$V)(() => new Promise((e, o) => {
            t || o("loadScript cannot be called without a src"), document && document.body || o("loadScript cannot be called when document does not exist");
            let l = document.createElement("script");
            s && l.setAttribute("crossorigin", s), l.async = i || !1, l.defer = n || !1, l.addEventListener("load", () => {
              l.remove(), e(l);
            }), l.addEventListener("error", () => {
              l.remove(), o();
            }), l.src = t, l.nonce = a, null == r || r(l), document.body.appendChild(l);
          }), {
            shouldRetry: (t, e) => e < 5
          });
        }
        let eH = "clerk-captcha",
          eZ = "clerk-invisible-captcha";
        async function eY(t) {
          if (!window.hcaptcha) try {
            await eG(t, {
              defer: !0
            });
          } catch {
            throw console.error("Clerk: Failed to load the CAPTCHA script from the URL: ", t), {
              captchaError: "captcha_script_failed_to_load"
            };
          }
          return window.hcaptcha;
        }
        let eQ = async t => {
            let {
                siteKey: e,
                scriptUrl: i,
                widgetType: n,
                invisibleSiteKey: r
              } = t,
              s = "",
              a = "",
              o = !n || "invisible" === n,
              l = e,
              c = null,
              h = () => {
                let t = document.createElement("div");
                return t.id = eZ, document.body.appendChild(t), t;
              },
              d = await eY(i),
              u = 0,
              p = [];
            try {
              [s, a] = await new Promise((t, e) => {
                try {
                  if (o) c = h();else {
                    let t = document.getElementById(eH);
                    t ? (t.style.display = "block", c = t) : (console.error("Cannot initialize Smart CAPTCHA widget because the `clerk-captcha` DOM element was not found; falling back to Invisible CAPTCHA widget. If you are using a custom flow, visit https://clerk.com/docs/custom-flows/bot-sign-up-protection for instructions"), c = h(), o = !0, l = r);
                  }
                  let i = d.render(o ? eZ : eH, {
                    sitekey: l,
                    size: o ? "invisible" : "normal",
                    callback: function (e) {
                      t([e, i]);
                    },
                    "error-callback": function (t) {
                      if (p.push(t), u < 2) {
                        setTimeout(() => {
                          d.reset(i), u++;
                        }, 250);
                        return;
                      }
                      e([p.join(","), i]);
                    }
                  });
                  o && d.execute(i);
                } catch (t) {
                  e([t, void 0]);
                }
              }), d.remove(a);
            } catch (i) {
              let [t, e] = i;
              throw e && d.remove(e), {
                captchaError: t
              };
            } finally {
              c && (o ? document.body.removeChild(c) : c.style.display = "none");
            }
            return {
              captchaToken: s,
              captchaWidgetTypeUsed: o ? "invisible" : "smart"
            };
          },
          eX = t => !!["crashed", "undefined_error", "102", "103", "104", "106", "110600", "300", "600"].find(e => t.startsWith(e));
        async function e0(t) {
          return window.turnstile || (await e1().catch(() => e3(t)).catch(() => {
            throw {
              captchaError: "captcha_script_failed_to_load"
            };
          })), window.turnstile;
        }
        async function e1() {
          try {
            return await eG("https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit", {
              defer: !0
            });
          } catch (t) {
            throw console.warn("Clerk: Failed to load the CAPTCHA script from Cloudflare. If you see a CSP error in your browser, please add the necessary CSP rules to your app. Visit https://clerk.com/docs/security/clerk-csp for more information."), t;
          }
        }
        async function e3(t) {
          try {
            return await eG(t, {
              defer: !0
            });
          } catch (e) {
            throw console.error("Clerk: Failed to load the CAPTCHA script from the URL: ", t), e;
          }
        }
        let e2 = async t => {
            let {
                siteKey: e,
                scriptUrl: i,
                widgetType: n,
                invisibleSiteKey: r
              } = t,
              s = "",
              a = "",
              o = !n || "invisible" === n,
              l = e,
              c = null,
              h = () => {
                let t = document.createElement("div");
                return t.classList.add(eZ), document.body.appendChild(t), t;
              },
              d = await e0(i),
              u = 0,
              p = [];
            try {
              [s, a] = await new Promise((t, e) => {
                try {
                  if (o) c = h();else {
                    let t = document.getElementById(eH);
                    t ? (t.style.display = "block", c = t) : (console.error("Cannot initialize Smart CAPTCHA widget because the `clerk-captcha` DOM element was not found; falling back to Invisible CAPTCHA widget. If you are using a custom flow, visit https://clerk.com/docs/custom-flows/bot-sign-up-protection for instructions"), c = h(), o = !0, l = r);
                  }
                  let i = d.render(o ? ".".concat(eZ) : "#".concat(eH), {
                    sitekey: l,
                    appearance: "interaction-only",
                    retry: "never",
                    "refresh-expired": "auto",
                    callback: function (e) {
                      t([e, i]);
                    },
                    "error-callback": function (t) {
                      if (p.push(t), u < 2 && eX(t.toString())) {
                        setTimeout(() => {
                          d.reset(i), u++;
                        }, 250);
                        return;
                      }
                      e([p.join(","), i]);
                    },
                    "unsupported-callback": function () {
                      return e(["This browser is not supported by the CAPTCHA.", i]), !0;
                    }
                  });
                } catch (t) {
                  e([t, void 0]);
                }
              }), d.remove(a);
            } catch (i) {
              let [t, e] = i;
              throw e && d.remove(e), {
                captchaError: t
              };
            } finally {
              c && (o ? document.body.removeChild(c) : c.style.display = "none");
            }
            return {
              captchaToken: s,
              captchaWidgetTypeUsed: o ? "invisible" : "smart"
            };
          },
          e5 = t => {
            let {
              captchaProvider: e,
              ...i
            } = t;
            return "hcaptcha" === e ? eQ(i) : e2(i);
          };
        function e6(t) {
          let {
              unsafeMetadata: e
            } = {
              ...t
            },
            i = e ? "object" == typeof e ? JSON.stringify(e) : e : "";
          return {
            ...t,
            ...(e ? {
              unsafeMetadata: i
            } : {})
          };
        }
        class e4 extends tW {
          fromJSON(t) {
            return t && (this.id = t.id, this.status = t.status, this.requiredFields = t.required_fields, this.optionalFields = t.optional_fields, this.missingFields = t.missing_fields, this.unverifiedFields = t.unverified_fields, this.verifications = new t4(t.verifications), this.username = t.username, this.firstName = t.first_name, this.lastName = t.last_name, this.emailAddress = t.email_address, this.phoneNumber = t.phone_number, this.hasPassword = t.has_password, this.unsafeMetadata = t.unsafe_metadata, this.createdSessionId = t.created_session_id, this.createdUserId = t.created_user_id, this.abandonAt = t.abandon_at, this.web3wallet = t.web3_wallet, this.legalAcceptedAt = t.legal_accepted_at), this;
          }
          shouldBypassCaptchaForAttempt(t) {
            if (!t.strategy) return !1;
            let e = e4.clerk.__unstable__environment.displayConfig.captchaOauthBypass;
            return !!(e.some(e => e === t.strategy) || t.transfer && e.some(t => t === e4.clerk.client.signIn.firstFactorVerification.strategy));
          }
          constructor(t = null) {
            super(), d(this, "pathRoot", "/client/sign_ups"), d(this, "id", void 0), d(this, "status", null), d(this, "requiredFields", []), d(this, "optionalFields", []), d(this, "missingFields", []), d(this, "unverifiedFields", []), d(this, "verifications", new t4(null)), d(this, "username", null), d(this, "firstName", null), d(this, "lastName", null), d(this, "emailAddress", null), d(this, "phoneNumber", null), d(this, "web3wallet", null), d(this, "externalAccount", void 0), d(this, "hasPassword", !1), d(this, "unsafeMetadata", {}), d(this, "createdSessionId", null), d(this, "createdUserId", null), d(this, "abandonAt", null), d(this, "legalAcceptedAt", null), d(this, "create", async t => {
              let {
                captchaSiteKey: e,
                canUseCaptcha: i,
                captchaURL: n,
                captchaWidgetType: r,
                captchaProvider: s,
                captchaPublicKeyInvisible: a
              } = e$(e4.clerk);
              if (!this.shouldBypassCaptchaForAttempt(t) && i && e && n && a) try {
                let {
                  captchaToken: i,
                  captchaWidgetTypeUsed: o
                } = await e5({
                  siteKey: e,
                  widgetType: r,
                  invisibleSiteKey: a,
                  scriptUrl: n,
                  captchaProvider: s
                });
                t.captchaToken = i, t.captchaWidgetType = o;
              } catch (e) {
                if (e.captchaError) t.captchaError = e.captchaError;else throw new f.w$(e.message, {
                  code: "captcha_unavailable"
                });
              }
              if (t.transfer && this.shouldBypassCaptchaForAttempt(t)) {
                var o;
                t.strategy = null === (o = e4.clerk.client) || void 0 === o ? void 0 : o.signIn.firstFactorVerification.strategy;
              }
              return void 0 !== t.__experimental_legalAccepted && (t.legalAccepted = t.__experimental_legalAccepted, t.__experimental_legalAccepted = void 0), this._basePost({
                path: this.pathRoot,
                body: e6(t)
              });
            }), d(this, "prepareVerification", t => this._basePost({
              body: t,
              action: "prepare_verification"
            })), d(this, "attemptVerification", t => this._basePost({
              body: t,
              action: "attempt_verification"
            })), d(this, "prepareEmailAddressVerification", t => this.prepareVerification(t || {
              strategy: "email_code"
            })), d(this, "attemptEmailAddressVerification", t => this.attemptVerification({
              ...t,
              strategy: "email_code"
            })), d(this, "createEmailLinkFlow", () => {
              let {
                run: t,
                stop: e
              } = (0, tB.W)();
              return {
                startEmailLinkFlow: async i => {
                  let {
                    redirectUrl: n
                  } = i;
                  return this.id || tP("SignUp"), await this.prepareEmailAddressVerification({
                    strategy: "email_link",
                    redirectUrl: n
                  }), new Promise((i, n) => {
                    t(() => this.reload().then(t => {
                      let n = t.verifications.emailAddress.status;
                      ("verified" === n || "expired" === n) && (e(), i(t));
                    }).catch(t => {
                      e(), n(t);
                    }));
                  });
                },
                cancelEmailLinkFlow: e
              };
            }), d(this, "preparePhoneNumberVerification", t => this.prepareVerification(t || {
              strategy: "phone_code"
            })), d(this, "attemptPhoneNumberVerification", t => this.attemptVerification({
              ...t,
              strategy: "phone_code"
            })), d(this, "prepareWeb3WalletVerification", t => this.prepareVerification({
              strategy: "web3_metamask_signature",
              ...t
            })), d(this, "attemptWeb3WalletVerification", async t => {
              let {
                signature: e,
                strategy: i = "web3_metamask_signature"
              } = t;
              return this.attemptVerification({
                signature: e,
                strategy: i
              });
            }), d(this, "authenticateWithWeb3", async t => {
              let e;
              let {
                  generateSignature: i,
                  identifier: n,
                  unsafeMetadata: r,
                  strategy: s = "web3_metamask_signature",
                  __experimental_legalAccepted: a
                } = t || {},
                o = s.replace("web3_", "").replace("_signature", "");
              "function" != typeof i && tR("generateSignature");
              let l = n || this.web3wallet;
              await this.create({
                web3Wallet: l,
                unsafeMetadata: r,
                __experimental_legalAccepted: a
              }), await this.prepareWeb3WalletVerification({
                strategy: s
              });
              let {
                message: c
              } = this.verifications.web3Wallet;
              c || tT("SignUp");
              try {
                e = await i({
                  identifier: n,
                  nonce: c,
                  provider: o
                });
              } catch (t) {
                if ("coinbase_wallet" === o && 4001 === t.code) e = await i({
                  identifier: n,
                  nonce: c,
                  provider: o
                });else throw t;
              }
              return this.attemptWeb3WalletVerification({
                signature: e,
                strategy: s
              });
            }), d(this, "authenticateWithMetamask", async t => {
              let e = await t_();
              return this.authenticateWithWeb3({
                identifier: e,
                generateSignature: ty,
                unsafeMetadata: null == t ? void 0 : t.unsafeMetadata,
                strategy: "web3_metamask_signature",
                __experimental_legalAccepted: null == t ? void 0 : t.__experimental_legalAccepted
              });
            }), d(this, "authenticateWithCoinbaseWallet", async t => {
              let e = await tb();
              return this.authenticateWithWeb3({
                identifier: e,
                generateSignature: tk,
                unsafeMetadata: null == t ? void 0 : t.unsafeMetadata,
                strategy: "web3_coinbase_wallet_signature",
                __experimental_legalAccepted: null == t ? void 0 : t.__experimental_legalAccepted
              });
            }), d(this, "authenticateWithRedirect", async t => {
              let {
                  redirectUrl: e,
                  redirectUrlComplete: i,
                  strategy: n,
                  continueSignUp: r = !1,
                  unsafeMetadata: s,
                  emailAddress: a,
                  __experimental_legalAccepted: o
                } = t,
                l = () => {
                  let t = {
                    strategy: n,
                    redirectUrl: e4.clerk.buildUrlWithAuth(e),
                    actionCompleteRedirectUrl: i,
                    unsafeMetadata: s,
                    emailAddress: a,
                    __experimental_legalAccepted: o
                  };
                  return r && this.id ? this.update(t) : this.create(t);
                },
                {
                  verifications: c
                } = await l().catch(async t => {
                  if ((0, f.kD)(t) && (0, f.pG)(t)) return await e4.clerk.__unstable__environment.reload(), l();
                  throw t;
                }),
                {
                  externalAccount: h
                } = c,
                {
                  status: d,
                  externalVerificationRedirectURL: u
                } = h;
              "unverified" === d && u ? C(u) : tM(d, e4.fapiClient.buildEmailAddress("support"));
            }), d(this, "update", t => (void 0 !== t.__experimental_legalAccepted && (t.legalAccepted = t.__experimental_legalAccepted, t.__experimental_legalAccepted = void 0), this._basePatch({
              body: e6(t)
            }))), d(this, "validatePassword", (t, e) => {
              var i, n;
              if (null === (i = e4.clerk.__unstable__environment) || void 0 === i ? void 0 : i.userSettings.passwordSettings) return eJ({
                ...(null === (n = e4.clerk.__unstable__environment) || void 0 === n ? void 0 : n.userSettings.passwordSettings),
                validatePassword: !0
              })(t, e);
            }), this.fromJSON(t);
          }
        }
        class e9 extends tW {
          static async create(t) {
            let e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return new e9(await tW._fetch({
              path: t,
              method: "POST",
              body: e
            }), t);
          }
          fromJSON(t) {
            return t && (this.jwt = tn(t.jwt)), this;
          }
          constructor(t, e) {
            super(), d(this, "pathRoot", "tokens"), d(this, "jwt", void 0), d(this, "getRawString", () => {
              var t;
              return (null === (t = this.jwt) || void 0 === t ? void 0 : t.claims.__raw) || "";
            }), e && (this.pathRoot = e), (null == t ? void 0 : t.jwt) && (this.jwt = tn(t.jwt));
          }
        }
        class e8 extends tW {
          fromJSON(t) {
            return t && (this.id = t.id, this.secret = t.secret, this.uri = t.uri, this.verified = t.verified, this.backupCodes = t.backup_codes, this.updatedAt = tL(t.updated_at), this.createdAt = tL(t.created_at)), this;
          }
          constructor(t) {
            super(), d(this, "pathRoot", "/me"), d(this, "id", ""), d(this, "secret", void 0), d(this, "uri", void 0), d(this, "verified", !1), d(this, "backupCodes", void 0), d(this, "updatedAt", null), d(this, "createdAt", null), this.fromJSON(t);
          }
        }
        let e7 = t => {
          let {
            firstName: e,
            lastName: i,
            name: n
          } = t;
          return n || [e, i].join(" ").trim() || "";
        };
        class it extends tW {
          fromJSON(t) {
            return t && (this.id = t.id, this.codes = t.codes, this.updatedAt = tL(t.updated_at), this.createdAt = tL(t.created_at)), this;
          }
          constructor(t) {
            super(), d(this, "pathRoot", "/me"), d(this, "id", void 0), d(this, "codes", []), d(this, "updatedAt", null), d(this, "createdAt", null), this.fromJSON(t);
          }
        }
        class ie extends tW {
          static isUserResource(t) {
            return !!t && t instanceof ie;
          }
          path() {
            return this.pathRoot;
          }
          get verifiedExternalAccounts() {
            return this.externalAccounts.filter(t => {
              var e;
              return (null === (e = t.verification) || void 0 === e ? void 0 : e.status) == "verified";
            });
          }
          get unverifiedExternalAccounts() {
            return this.externalAccounts.filter(t => {
              var e;
              return (null === (e = t.verification) || void 0 === e ? void 0 : e.status) != "verified";
            });
          }
          get verifiedWeb3Wallets() {
            return this.web3Wallets.filter(t => {
              var e;
              return (null === (e = t.verification) || void 0 === e ? void 0 : e.status) == "verified";
            });
          }
          get hasVerifiedEmailAddress() {
            return this.emailAddresses.filter(t => "verified" === t.verification.status).length > 0;
          }
          get hasVerifiedPhoneNumber() {
            return this.phoneNumbers.filter(t => "verified" === t.verification.status).length > 0;
          }
          fromJSON(t) {
            return t && (this.id = t.id, this.externalId = t.external_id, this.firstName = t.first_name, this.lastName = t.last_name, (this.firstName || this.lastName) && (this.fullName = e7({
              firstName: this.firstName,
              lastName: this.lastName
            })), this.imageUrl = t.image_url, this.hasImage = t.has_image, this.username = t.username, this.passwordEnabled = t.password_enabled, this.emailAddresses = (t.email_addresses || []).map(t => new t$(t, this.path() + "/email_addresses")), this.primaryEmailAddressId = t.primary_email_address_id, this.primaryEmailAddress = this.emailAddresses.find(t => {
              let {
                id: e
              } = t;
              return e === this.primaryEmailAddressId;
            }) || null, this.phoneNumbers = (t.phone_numbers || []).map(t => new ee(t, this.path() + "/phone_numbers")), this.primaryPhoneNumberId = t.primary_phone_number_id, this.primaryPhoneNumber = this.phoneNumbers.find(t => {
              let {
                id: e
              } = t;
              return e === this.primaryPhoneNumberId;
            }) || null, this.web3Wallets = (t.web3_wallets || []).map(t => new ir(t, this.path() + "/web3_wallets")), this.primaryWeb3WalletId = t.primary_web3_wallet_id, this.primaryWeb3Wallet = this.web3Wallets.find(t => {
              let {
                id: e
              } = t;
              return e === this.primaryWeb3WalletId;
            }) || null, this.externalAccounts = (t.external_accounts || []).map(t => new t8(t, this.path() + "/external_accounts")), this.passkeys = (t.passkeys || []).map(t => new eR(t)), this.organizationMemberships = (t.organization_memberships || []).map(t => new ec(t)), this.samlAccounts = (t.saml_accounts || []).map(t => new ed(t, this.path() + "/saml_accounts")), this.publicMetadata = t.public_metadata, this.unsafeMetadata = t.unsafe_metadata, this.totpEnabled = t.totp_enabled, this.backupCodeEnabled = t.backup_code_enabled, this.twoFactorEnabled = t.two_factor_enabled, this.createOrganizationEnabled = t.create_organization_enabled, this.createOrganizationsLimit = t.create_organizations_limit, this.deleteSelfEnabled = t.delete_self_enabled, t.last_sign_in_at && (this.lastSignInAt = tL(t.last_sign_in_at)), t.legal_accepted_at && (this.legalAcceptedAt = tL(t.legal_accepted_at)), this.updatedAt = tL(t.updated_at), this.createdAt = tL(t.created_at)), this;
          }
          constructor(t) {
            super(), d(this, "pathRoot", "/me"), d(this, "id", ""), d(this, "externalId", null), d(this, "username", null), d(this, "emailAddresses", []), d(this, "phoneNumbers", []), d(this, "web3Wallets", []), d(this, "externalAccounts", []), d(this, "passkeys", []), d(this, "samlAccounts", []), d(this, "organizationMemberships", []), d(this, "passwordEnabled", !1), d(this, "firstName", null), d(this, "lastName", null), d(this, "fullName", null), d(this, "primaryEmailAddressId", null), d(this, "primaryEmailAddress", null), d(this, "primaryPhoneNumberId", null), d(this, "primaryPhoneNumber", null), d(this, "primaryWeb3WalletId", null), d(this, "primaryWeb3Wallet", null), d(this, "imageUrl", ""), d(this, "hasImage", !1), d(this, "twoFactorEnabled", !1), d(this, "totpEnabled", !1), d(this, "backupCodeEnabled", !1), d(this, "publicMetadata", {}), d(this, "unsafeMetadata", {}), d(this, "createOrganizationEnabled", !1), d(this, "createOrganizationsLimit", null), d(this, "deleteSelfEnabled", !1), d(this, "lastSignInAt", null), d(this, "legalAcceptedAt", null), d(this, "updatedAt", null), d(this, "createdAt", null), d(this, "cachedSessionsWithActivities", null), d(this, "isPrimaryIdentification", t => {
              switch (t.constructor) {
                case t$:
                  return this.primaryEmailAddressId === t.id;
                case ee:
                  return this.primaryPhoneNumberId === t.id;
                case ir:
                  return this.primaryWeb3WalletId === t.id;
                default:
                  return !1;
              }
            }), d(this, "createEmailAddress", t => {
              let {
                email: e
              } = t || {};
              return new t$({
                email_address: e
              }, this.path() + "/email_addresses/").create();
            }), d(this, "createPasskey", () => eR.registerPasskey()), d(this, "createPhoneNumber", t => {
              let {
                phoneNumber: e
              } = t || {};
              return new ee({
                phone_number: e
              }, this.path() + "/phone_numbers/").create();
            }), d(this, "createWeb3Wallet", t => {
              let {
                web3Wallet: e
              } = t || {};
              return new ir({
                web3_wallet: e
              }, this.path() + "/web3_wallets/").create();
            }), d(this, "createExternalAccount", async t => {
              var e;
              let {
                strategy: i,
                redirectUrl: n,
                additionalScopes: r
              } = t || {};
              return new t8(null === (e = await tW._fetch({
                path: "/me/external_accounts",
                method: "POST",
                body: {
                  strategy: i,
                  redirect_url: n,
                  additional_scope: r
                }
              })) || void 0 === e ? void 0 : e.response, this.path() + "/external_accounts");
            }), d(this, "createTOTP", async () => {
              var t;
              return new e8(null === (t = await tW._fetch({
                path: "/me/totp",
                method: "POST"
              })) || void 0 === t ? void 0 : t.response);
            }), d(this, "verifyTOTP", async t => {
              var e;
              let {
                code: i
              } = t;
              return new e8(null === (e = await tW._fetch({
                path: "/me/totp/attempt_verification",
                method: "POST",
                body: {
                  code: i
                }
              })) || void 0 === e ? void 0 : e.response);
            }), d(this, "disableTOTP", async () => {
              var t;
              return new tV(null === (t = await tW._fetch({
                path: "/me/totp",
                method: "DELETE"
              })) || void 0 === t ? void 0 : t.response);
            }), d(this, "createBackupCode", async () => {
              var t;
              return new it(null === (t = await tW._fetch({
                path: this.path() + "/backup_codes/",
                method: "POST"
              })) || void 0 === t ? void 0 : t.response);
            }), d(this, "update", t => this._basePatch({
              body: e6(t)
            })), d(this, "updatePassword", t => this._basePost({
              body: t,
              path: "".concat(this.path(), "/change_password")
            })), d(this, "removePassword", t => this._basePost({
              body: t,
              path: "".concat(this.path(), "/remove_password")
            })), d(this, "delete", () => this._baseDelete({
              path: "/me"
            })), d(this, "getSessions", async () => {
              if (this.cachedSessionsWithActivities) return this.cachedSessionsWithActivities;
              let t = await eW.retrieve();
              return this.cachedSessionsWithActivities = t, t;
            }), d(this, "setProfileImage", t => {
              let {
                file: e
              } = t || {};
              return null === e ? et.delete("".concat(this.path(), "/profile_image")) : et.create("".concat(this.path(), "/profile_image"), {
                file: e
              });
            }), d(this, "getOrganizationInvitations", t => ii.retrieve(t)), d(this, "getOrganizationSuggestions", t => eh.retrieve(t)), d(this, "getOrganizationMemberships", t => ec.retrieve(t)), d(this, "leaveOrganization", async t => {
              var e;
              return new tV(null === (e = await tW._fetch({
                path: "".concat(this.path(), "/organization_memberships/").concat(t),
                method: "DELETE"
              })) || void 0 === e ? void 0 : e.response);
            }), this.fromJSON(t);
          }
        }
        class ii extends tW {
          static async retrieve(t) {
            return await tW._fetch({
              path: "/me/organization_invitations",
              method: "GET",
              search: ei(t)
            }).then(t => {
              let {
                data: e,
                total_count: i
              } = null == t ? void 0 : t.response;
              return {
                total_count: i,
                data: e.map(t => new ii(t))
              };
            });
          }
          fromJSON(t) {
            return t && (this.id = t.id, this.emailAddress = t.email_address, this.publicOrganizationData = {
              hasImage: t.public_organization_data.has_image,
              imageUrl: t.public_organization_data.image_url,
              name: t.public_organization_data.name,
              id: t.public_organization_data.id,
              slug: t.public_organization_data.slug
            }, this.publicMetadata = t.public_metadata, this.role = t.role, this.status = t.status, this.createdAt = tL(t.created_at), this.updatedAt = tL(t.updated_at)), this;
          }
          constructor(t) {
            super(), d(this, "id", void 0), d(this, "emailAddress", void 0), d(this, "publicOrganizationData", void 0), d(this, "publicMetadata", {}), d(this, "status", void 0), d(this, "role", void 0), d(this, "createdAt", void 0), d(this, "updatedAt", void 0), d(this, "accept", async () => await this._basePost({
              path: "/me/organization_invitations/".concat(this.id, "/accept")
            })), this.fromJSON(t);
          }
        }
        class ir extends tW {
          create() {
            return this._basePost({
              body: {
                web3_wallet: this.web3Wallet
              }
            });
          }
          destroy() {
            return this._baseDelete();
          }
          toString() {
            return this.web3Wallet;
          }
          fromJSON(t) {
            return t && (this.id = t.id, this.web3Wallet = t.web3_wallet, this.verification = new t5(t.verification)), this;
          }
          constructor(t, e) {
            super(), d(this, "id", void 0), d(this, "web3Wallet", ""), d(this, "verification", void 0), d(this, "prepareVerification", t => this._basePost({
              action: "prepare_verification",
              body: {
                ...t
              }
            })), d(this, "attemptVerification", t => {
              let {
                signature: e
              } = t;
              return this._basePost({
                action: "attempt_verification",
                body: {
                  signature: e
                }
              });
            }), this.pathRoot = e, this.fromJSON(t);
          }
        }
        function is(t, e) {
          return !function (t, e) {
            if (!t && e || t && !e) return !0;
            if (!t && t === e) return !1;
            if (!t || !e) return !0;
            try {
              if (tJ.isClientResource(t)) return t.id !== e.id || t.updatedAt.getTime() < e.updatedAt.getTime() || t.sessions.length !== e.sessions.length;
              if (eP.isSessionResource(t)) return t.id !== e.id || t.updatedAt.getTime() < e.updatedAt.getTime() || function (t, e) {
                let i = t.__experimental_factorVerificationAge,
                  n = e.__experimental_factorVerificationAge;
                return null !== i && null !== n ? i[0] !== n[0] || i[1] !== n[1] : i !== n;
              }(t, e) || function (t, e) {
                var i, n, r, s, a, o;
                if (t.lastActiveOrganizationId !== e.lastActiveOrganizationId) return !0;
                let l = null === (n = t.user) || void 0 === n ? void 0 : null === (i = n.organizationMemberships) || void 0 === i ? void 0 : i.find(e => e.organization.id === t.lastActiveOrganizationId),
                  c = null === (s = e.user) || void 0 === s ? void 0 : null === (r = s.organizationMemberships) || void 0 === r ? void 0 : r.find(e => e.organization.id === t.lastActiveOrganizationId);
                return (null == l ? void 0 : l.role) !== (null == c ? void 0 : c.role) || (null == l ? void 0 : null === (a = l.permissions) || void 0 === a ? void 0 : a.length) !== (null == c ? void 0 : null === (o = c.permissions) || void 0 === o ? void 0 : o.length);
              }(t, e);
              if (ie.isUserResource(t)) {
                var i, n, r, s;
                return t.id !== e.id || t.updatedAt.getTime() < e.updatedAt.getTime() || (i = e, n = t, i.organizationMemberships.length !== n.organizationMemberships.length || (null === (r = i.organizationMemberships[0]) || void 0 === r ? void 0 : r.updatedAt) !== (null === (s = n.organizationMemberships[0]) || void 0 === s ? void 0 : s.updatedAt));
              }
            } catch (t) {}
            return !0;
          }(t, e) ? t : e;
        }
        var ia = t => Object.entries(t).reduce((t, [e, i]) => (null != i && (t[e] = i), t), {}),
          io = (t, e) => {
            let i = {};
            for (let n in t) i[n] = e(t[n], n);
            return i;
          },
          il = (t, e) => {
            let i = {};
            for (let n in t) t[n] && e(t[n]) && (i[n] = t[n]);
            return i;
          },
          ic = new WeakSet(),
          ih = new WeakSet(),
          id = new WeakSet(),
          iu = new WeakSet(),
          ip = new WeakSet(),
          im = new WeakSet(),
          iv = new WeakSet(),
          ig = new WeakMap();
        class iw {
          getAfterSignInUrl() {
            return ep(this, iu, ik).call(this, "signIn");
          }
          getAfterSignUpUrl() {
            return ep(this, iu, ik).call(this, "signUp");
          }
          getPreservedSearchParams() {
            return ep(this, ic, i_).call(this, ep(this, ih, ib).call(this));
          }
          toSearchParams() {
            return ep(this, ic, i_).call(this, ep(this, id, iy).call(this));
          }
          constructor(t, e = {}, i = {}) {
            ef(this, ic), ef(this, ih), ef(this, id), ef(this, iu), ef(this, ip), ef(this, im), ef(this, iv), d(this, "options", void 0), d(this, "fromOptions", void 0), d(this, "fromProps", void 0), d(this, "fromSearchParams", void 0), l(this, ig, {
              writable: !0,
              value: t => {
                var e;
                return il(t, te(null === (e = this.options) || void 0 === e ? void 0 : e.allowedRedirectOrigins));
              }
            }), this.options = t, this.fromOptions = ep(this, ip, iS).call(this, t || {}), this.fromProps = ep(this, ip, iS).call(this, e || {}), this.fromSearchParams = ep(this, im, iU).call(this, i || {});
          }
        }
        function i_(t) {
          return new URLSearchParams(ia(Object.fromEntries(Object.entries(t).map(t => {
            let [e, i] = t;
            return [(0, J.a1)(e), i];
          }))));
        }
        function ib() {
          return Object.fromEntries(Object.entries({
            ...this.fromSearchParams
          }).filter(t => {
            let [e] = t;
            return iw.preserved.includes(e);
          }));
        }
        function iy() {
          let t = this.fromSearchParams.signUpForceRedirectUrl || this.fromProps.signUpForceRedirectUrl || this.fromOptions.signUpForceRedirectUrl,
            e = this.fromSearchParams.signUpFallbackRedirectUrl || this.fromProps.signUpFallbackRedirectUrl || this.fromOptions.signUpFallbackRedirectUrl,
            i = this.fromSearchParams.signInForceRedirectUrl || this.fromProps.signInForceRedirectUrl || this.fromOptions.signInForceRedirectUrl,
            n = this.fromSearchParams.signInFallbackRedirectUrl || this.fromProps.signInFallbackRedirectUrl || this.fromOptions.signInFallbackRedirectUrl,
            r = this.fromSearchParams.afterSignInUrl || this.fromProps.afterSignInUrl || this.fromOptions.afterSignInUrl,
            s = {
              signUpForceRedirectUrl: t,
              signUpFallbackRedirectUrl: e,
              signInFallbackRedirectUrl: n,
              signInForceRedirectUrl: i,
              afterSignInUrl: r,
              afterSignUpUrl: this.fromSearchParams.afterSignUpUrl || this.fromProps.afterSignUpUrl || this.fromOptions.afterSignUpUrl,
              redirectUrl: this.fromSearchParams.redirectUrl || this.fromProps.redirectUrl || this.fromOptions.redirectUrl
            };
          return t && delete s.signUpFallbackRedirectUrl, i && delete s.signInFallbackRedirectUrl, s;
        }
        function ik(t) {
          var e, i;
          let n, r;
          let s = "".concat(t, "ForceRedirectUrl"),
            a = "".concat(t, "FallbackRedirectUrl"),
            o = "after".concat(t[0].toUpperCase()).concat(t.slice(1), "Url");
          (r = this.fromSearchParams[s] || this.fromProps[s] || this.fromOptions[s]) && (n = s), r || (r = this.fromSearchParams.redirectUrl), r && (n = "redirectUrl"), r || (r = this.fromSearchParams[a] || this.fromProps[a] || this.fromOptions[a]), r && (n = a);
          let l = this.fromSearchParams[o] || this.fromProps[o] || this.fromProps.redirectUrl || this.fromOptions[o];
          return e = n, (i = r) && l && g.k.warnOnce('Clerk: The "'.concat(e, '" prop ("').concat(i, '") has priority over the legacy "').concat(o, '" (or "redirectUrl") ("').concat(l, '"), which will be completely ignored in this case. "').concat(o, '" (or "redirectUrl" prop) should be replaced with the new "fallbackRedirectUrl" or "forceRedirectUrl" props instead. Learn more: https://clerk.com/docs/guides/custom-redirects#redirect-url-props')), r || (r = l), r || "/";
        }
        function iS(t) {
          tA(t);
          let e = {};
          return iw.keys.forEach(i => {
            e[i] = t[i];
          }), ep(this, iv, iA).call(this, a(this, ig).call(this, e));
        }
        function iU(t) {
          tA(t);
          let e = {};
          return iw.keys.forEach(i => {
            e[i] = t[(0, J.a1)(i)];
          }), e.redirectUrl = t.redirect_url, ep(this, iv, iA).call(this, a(this, ig).call(this, e));
        }
        function iA(t) {
          return io(t, t => {
            var e;
            return e = window.location.origin, !function (t) {
              if (!t) return !1;
              try {
                return new URL(t), !0;
              } catch (t) {
                return !1;
              }
            }(t) ? new URL(t, e).href : t;
          });
        }
        d(iw, "keys", ["signInForceRedirectUrl", "signInFallbackRedirectUrl", "signUpForceRedirectUrl", "signUpFallbackRedirectUrl", "afterSignInUrl", "afterSignUpUrl", "redirectUrl"]), d(iw, "preserved", ["redirectUrl"]);
        var iO = "__clerk_db_jwt";
        function iI(t, e) {
          let i = new URL(t),
            n = i.searchParams.get(iO);
          i.searchParams.delete(iO);
          let r = n || e;
          return r && i.searchParams.set(iO, r), i;
        }
        var iC = t => t.searchParams.get(iO) || "",
          iE = t => iP(ix(t)),
          iP = t => {
            let e = new URL(t);
            return e.searchParams.delete(iO), e;
          },
          ix = t => {
            let e = new URL(t);
            return e.searchParams.delete("__dev_session"), e.hash = decodeURI(e.hash).replace(/__clerk_db_jwt\[(.*)\]/, ""), e.href.endsWith("#") && (e.hash = ""), e;
          };
        function iT(t) {
          for (var e = 1; e < arguments.length; e++) {
            var i = arguments[e];
            for (var n in i) t[n] = i[n];
          }
          return t;
        }
        var iR = function t(e, i) {
          function n(t, n, r) {
            if ("undefined" != typeof document) {
              "number" == typeof (r = iT({}, i, r)).expires && (r.expires = new Date(Date.now() + 864e5 * r.expires)), r.expires && (r.expires = r.expires.toUTCString()), t = encodeURIComponent(t).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
              var s = "";
              for (var a in r) {
                if (r[a]) s += "; " + a, !0 !== r[a] && (s += "=" + r[a].split(";")[0]);
              }
              return document.cookie = t + "=" + e.write(n, t) + s;
            }
          }
          return Object.create({
            set: n,
            get: function (t) {
              if ("undefined" != typeof document && (!arguments.length || t)) {
                for (var i = document.cookie ? document.cookie.split("; ") : [], n = {}, r = 0; r < i.length; r++) {
                  var s = i[r].split("="),
                    a = s.slice(1).join("=");
                  try {
                    var o = decodeURIComponent(s[0]);
                    if (n[o] = e.read(a, o), t === o) break;
                  } catch (t) {}
                }
                return t ? n[t] : n;
              }
            },
            remove: function (t, e) {
              n(t, "", iT({}, e, {
                expires: -1
              }));
            },
            withAttributes: function (e) {
              return t(this.converter, iT({}, this.attributes, e));
            },
            withConverter: function (e) {
              return t(iT({}, this.converter, e), this.attributes);
            }
          }, {
            attributes: {
              value: Object.freeze(i)
            },
            converter: {
              value: Object.freeze(e)
            }
          });
        }({
          read: function (t) {
            return '"' === t[0] && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
          },
          write: function (t) {
            return encodeURIComponent(t).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
          }
        }, {
          path: "/"
        });
        function iM(t) {
          return {
            get: () => iR.get(t),
            set(e, i = {}) {
              iR.set(t, e, i);
            },
            remove(e) {
              iR.remove(t, e);
            }
          };
        }
        var iz = i("3861");
        let iW = iM("__clerk_test_etld"),
          iN = t => "https:" === window.location.protocol || "None" === t && void 0 === window.safari && (void 0 !== window.isSecureContext ? window.isSecureContext : "localhost" === window.location.hostname),
          iF = "__client_uat",
          iL = t => {
            let e = iM(iF),
              i = iM((0, m._d)(iF, t));
            return {
              set: t => {
                let r = (0, iz.Bc)(Date.now(), 1),
                  s = to() ? "None" : "Strict",
                  a = iN(s),
                  o = function () {
                    let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window.location.hostname,
                      e = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : iW;
                    if (n) return n;
                    if (["localhost", "127.0.0.1", "0.0.0.0"].includes(t)) return t;
                    let i = t.split(".");
                    if (1 === i.length) return t;
                    for (let t = i.length - 2; t >= 0; t--) {
                      let r = i.slice(t).join(".");
                      if (e.set("1", {
                        domain: r
                      }), "1" === e.get()) return e.remove({
                        domain: r
                      }), n = r, r;
                      e.remove({
                        domain: r
                      });
                    }
                  }(),
                  l = "0";
                t && t.updatedAt && t.activeSessions.length > 0 && (l = Math.floor(t.updatedAt.getTime() / 1e3).toString()), i.remove(), e.remove(), i.set(l, {
                  expires: r,
                  sameSite: s,
                  domain: o,
                  secure: a
                }), e.set(l, {
                  expires: r,
                  sameSite: s,
                  domain: o,
                  secure: a
                });
              },
              get: () => parseInt(i.get() || e.get() || "0", 10)
            };
          },
          iD = "__session",
          ij = t => {
            let e = iM(iD),
              i = iM((0, m._d)(iD, t));
            return {
              set: t => {
                let n = (0, iz.Bc)(Date.now(), 1),
                  r = to() ? "None" : "Lax",
                  s = iN(r);
                i.set(t, {
                  expires: n,
                  sameSite: r,
                  secure: s
                }), e.set(t, {
                  expires: n,
                  sameSite: r,
                  secure: s
                });
              },
              remove: () => {
                i.remove(), e.remove();
              }
            };
          };
        async function iJ(t) {
          let e;
          try {
            e = await (0, m.P)(t);
          } catch (a) {
            g.k.logOnce("Suffixed cookie failed due to ".concat(a.message, " (secure-context: ").concat(window.isSecureContext, ", url: ").concat(window.location.href, ")"));
            let {
                default: n
              } = await i.e("199").then(i.t.bind(i, 1637, 23)),
              {
                default: r
              } = await i.e("199").then(i.t.bind(i, 8139, 23)),
              s = n(t);
            e = r.stringify(s).replace(/\+/gi, "-").replace(/\//gi, "_").substring(0, 8);
          }
          return e;
        }
        let iV = t => {
          let e = iM(iO),
            i = iM((0, m._d)(iO, t));
          return {
            get: () => i.get() || e.get(),
            set: t => {
              let n = (0, iz.Bc)(Date.now(), 1),
                r = to() ? "None" : "Lax",
                s = iN(r);
              i.set(t, {
                expires: n,
                sameSite: r,
                secure: s
              }), e.set(t, {
                expires: n,
                sameSite: r,
                secure: s
              });
            },
            remove: () => {
              i.remove(), e.remove();
            }
          };
        };
        var iK = i("8826"),
          iB = i("1096"),
          i$ = i.n(iB);
        class iq {
          startPollingForSessionToken(t) {
            !this.timerId && (this.timerId = this.workerTimers.setInterval(() => {
              this.lock.acquireLockAndRun(t);
            }, 5e3));
          }
          stopPollingForSessionToken() {
            this.timerId && (this.workerTimers.clearInterval(this.timerId), this.timerId = null);
          }
          constructor() {
            d(this, "lock", function (t) {
              let e = new (i$())();
              return window.addEventListener("beforeunload", async () => {
                await e.releaseLock(t);
              }), {
                acquireLockAndRun: async i => {
                  if (await e.acquireLock(t, 5e3)) try {
                    return await i();
                  } finally {
                    await e.releaseLock(t);
                  }
                }
              };
            }("clerk.lock.refreshSessionToken")), d(this, "workerTimers", (0, iK.Q)()), d(this, "timerId", null);
          }
        }
        class iG {
          static async create(t, e) {
            let i = await iJ(t.publishableKey);
            return new iG(t, e, i);
          }
          setEnvironment(t) {
            this.environment = t, this.setClientUatCookieForDevelopmentInstances();
          }
          isSignedOut() {
            return this.clerk.loaded ? !!this.clerk.user : 0 >= this.clientUat.get();
          }
          async setupDevelopment() {
            await this.devBrowser.setup();
          }
          setupProduction() {
            this.devBrowser.clear();
          }
          async handleUnauthenticatedDevBrowser() {
            this.devBrowser.clear(), await this.devBrowser.setup();
          }
          decorateUrlWithDevBrowserToken(t) {
            let e = this.devBrowser.getDevBrowserJWT();
            return e ? iI(t, e) : function () {
              throw Error("".concat(tO, " Missing dev browser jwt. Please contact support."));
            }();
          }
          startPollingForToken() {
            this.poller || (this.poller = new iq()), this.poller.startPollingForSessionToken(() => this.refreshSessionToken());
          }
          refreshTokenOnFocus() {
            window.addEventListener("focus", () => {
              "visible" === document.visibilityState && this.refreshSessionToken({
                updateCookieImmediately: !0
              });
            });
          }
          async refreshSessionToken() {
            let {
              updateCookieImmediately: t = !1
            } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
            if (this.clerk.session) try {
              let e = await this.clerk.session.getToken();
              t && this.updateSessionCookie(e);
            } catch (t) {
              return this.handleGetTokenError(t);
            }
          }
          updateSessionCookie(t) {
            if (document.hasFocus() || this.isCurrentOrganizationActive()) return this.setActiveOrganizationInStorage(), t ? this.sessionCookie.set(t) : this.sessionCookie.remove();
          }
          setClientUatCookieForDevelopmentInstances() {
            var t;
            (null === (t = this.environment) || void 0 === t ? void 0 : t.isDevelopmentOrStaging()) && this.inCustomDevelopmentDomain() && this.clientUat.set(this.clerk.client);
          }
          inCustomDevelopmentDomain() {
            let t = this.clerk.frontendApi.replace("clerk.", "");
            return !window.location.host.endsWith(t);
          }
          handleGetTokenError(t) {
            if ((0, f.kD)(t) || tC(t.message || t), (0, f.ix)(t)) {
              this.clerk.handleUnauthenticated();
              return;
            }
            !(0, f.eE)(t) && tC(t.toString());
          }
          setActiveOrganizationInStorage() {
            var t;
            (null === (t = this.clerk.organization) || void 0 === t ? void 0 : t.id) ? localStorage.setItem("clerk_active_org", this.clerk.organization.id) : localStorage.removeItem("clerk_active_org");
          }
          isCurrentOrganizationActive() {
            var t, e;
            let i = localStorage.getItem("clerk_active_org");
            return !i && (null === (t = this.clerk.organization) || void 0 === t || !t.id) || (null === (e = this.clerk.organization) || void 0 === e ? void 0 : e.id) === i;
          }
          constructor(t, e, i) {
            d(this, "clerk", void 0), d(this, "environment", void 0), d(this, "poller", void 0), d(this, "clientUat", void 0), d(this, "sessionCookie", void 0), d(this, "devBrowser", void 0), this.clerk = t, this.poller = null, eO.on(eA.TokenUpdate, t => {
              let {
                token: e
              } = t;
              this.updateSessionCookie(e && e.getRawString()), this.setClientUatCookieForDevelopmentInstances();
            }), this.refreshTokenOnFocus(), this.startPollingForToken(), this.clientUat = iL(i), this.sessionCookie = ij(i), this.devBrowser = function (t) {
              let {
                  cookieSuffix: e,
                  frontendApi: i,
                  fapiClient: n
                } = t,
                r = iV(e);
              function s() {
                return r.get();
              }
              function a(t) {
                r.set(t);
              }
              function o() {
                r.remove();
              }
              return {
                clear: function () {
                  o();
                },
                setup: async function () {
                  if (!q(i)) return;
                  n.onBeforeRequest(t => {
                    let e = s();
                    e && (null == t ? void 0 : t.url) && (t.url = iI(t.url, e));
                  }), n.onAfterResponse((t, e) => {
                    var i;
                    let n = null == e ? void 0 : null === (i = e.headers) || void 0 === i ? void 0 : i.get("Clerk-Db-Jwt");
                    n && a(n);
                  });
                  let t = function (t) {
                    let e = iC(t);
                    return iE(t).href !== t.href && void 0 !== globalThis.history && globalThis.history.replaceState(null, "", iE(t)), e;
                  }(new URL(window.location.href));
                  if (t) {
                    a(t);
                    return;
                  }
                  if (r.get()) return;
                  let e = n.buildUrl({
                      path: "/dev_browser"
                    }),
                    o = await fetch(e.toString(), {
                      method: "POST"
                    });
                  if (!o.ok) {
                    let t = await o.json(),
                      e = (0, f.iR)(t.errors);
                    e[0] ? tI(e[0].longMessage) : tI();
                  }
                  let l = await o.json();
                  a(null == l ? void 0 : l.id);
                },
                getDevBrowserJWT: s,
                setDevBrowserJWT: a,
                removeDevBrowserJWT: o
              };
            }({
              frontendApi: t.frontendApi,
              fapiClient: e,
              cookieSuffix: i
            });
          }
        }
        let iH = "__clerk_synced",
          iZ = "__clerk_satellite_url",
          iY = {
            FORM_IDENTIFIER_NOT_FOUND: "form_identifier_not_found"
          },
          iQ = t => "\uD83D\uDD12 Clerk:\n".concat(t.trim(), "\n(This notice only appears in development)"),
          iX = {
            cannotRenderComponentWhenSessionExists: "The <SignUp/> and <SignIn/> components cannot render when a user is already signed in, unless the application allows multiple sessions. Since a user is signed in and this application only allows a single session, Clerk is redirecting to the Home URL instead.",
            cannotRenderSignUpComponentWhenSessionExists: "The <SignUp/> component cannot render when a user is already signed in, unless the application allows multiple sessions. Since a user is signed in and this application only allows a single session, Clerk is redirecting to the value set in `afterSignUp` URL instead.",
            cannotRenderSignInComponentWhenSessionExists: "The <SignIn/> component cannot render when a user is already signed in, unless the application allows multiple sessions. Since a user is signed in and this application only allows a single session, Clerk is redirecting to the `afterSignIn` URL instead.",
            cannotRenderComponentWhenUserDoesNotExist: "<UserProfile/> cannot render unless a user is signed in. Since no user is signed in, this is no-op.",
            cannotRenderComponentWhenOrgDoesNotExist: "<OrganizationProfile/> cannot render unless an organization is active. Since no organization is currently active, this is no-op.",
            cannotRenderAnyOrganizationComponent: t => iQ("The <".concat(t, "/> cannot be rendered when the feature is turned off. Visit 'dashboard.clerk.com' to enable the feature. Since the feature is turned off, this is no-op.")),
            cannotOpenUserProfile: "The UserProfile modal cannot render unless a user is signed in. Since no user is signed in, this is no-op.",
            cannotOpenSignInOrSignUp: "The SignIn or SignUp modals do not render when a user is already signed in, unless the application allows multiple sessions. Since a user is signed in and this application only allows a single session, this is no-op."
          };
        for (let t of Object.keys(iX)) {
          let e = iX[t];
          "function" != typeof e && (iX[t] = iQ(e));
        }
        let i0 = {
          polling: !0,
          standardBrowser: !0,
          touchSession: !0,
          isSatellite: !1,
          signInUrl: void 0,
          signUpUrl: void 0,
          afterSignOutUrl: void 0,
          signInFallbackRedirectUrl: void 0,
          signUpFallbackRedirectUrl: void 0,
          signInForceRedirectUrl: void 0,
          signUpForceRedirectUrl: void 0
        };
        var i1 = new WeakMap(),
          i3 = new WeakMap(),
          i2 = new WeakMap(),
          i5 = new WeakMap(),
          i6 = new WeakMap(),
          i4 = new WeakMap(),
          i9 = new WeakMap(),
          i8 = new WeakMap(),
          i7 = new WeakMap(),
          nt = new WeakMap(),
          ne = new WeakMap(),
          ni = new WeakMap(),
          nn = new WeakMap(),
          nr = new WeakMap(),
          ns = new WeakMap(),
          na = new WeakMap(),
          no = new WeakMap(),
          nl = new WeakMap(),
          nc = new WeakMap(),
          nh = new WeakMap(),
          nd = new WeakMap(),
          nu = new WeakMap(),
          np = new WeakMap(),
          nf = new WeakMap(),
          nm = new WeakMap(),
          nv = new WeakMap(),
          ng = new WeakMap(),
          nw = new WeakMap(),
          n_ = new WeakMap(),
          nb = new WeakMap(),
          ny = new WeakMap(),
          nk = new WeakMap(),
          nS = new WeakMap(),
          nU = new WeakMap(),
          nA = new WeakMap(),
          nO = new WeakMap(),
          nI = new WeakMap(),
          nC = new WeakMap(),
          nE = new WeakMap(),
          nP = new WeakMap();
        class nx {
          get publishableKey() {
            return a(this, i1);
          }
          get version() {
            return nx.version;
          }
          set sdkMetadata(t) {
            nx.sdkMetadata = t;
          }
          get sdkMetadata() {
            return nx.sdkMetadata;
          }
          get loaded() {
            return a(this, i7);
          }
          get isSatellite() {
            return !!ta() && (0, k.YZ)(a(this, ne).isSatellite, new URL(window.location.href), !1);
          }
          get domain() {
            if (ta()) {
              let t = (0, y.d5)((0, k.YZ)(a(this, i3), new URL(window.location.href)));
              return "production" === a(this, i8) ? (0, y.xy)(t) : t;
            }
            return "";
          }
          get proxyUrl() {
            if (ta()) {
              let t = (0, k.YZ)(a(this, i2), new URL(window.location.href));
              return !(!t || w(t) || _(t)) && z.throwInvalidProxyUrl({
                url: t
              }), t ? _(t) ? new URL(t, window.location.origin).toString() : t : "";
            }
            return "";
          }
          get frontendApi() {
            let t = (0, m.nQ)(this.publishableKey);
            return t ? t.frontendApi : z.throwInvalidPublishableKeyError({
              key: this.publishableKey
            });
          }
          get instanceType() {
            return a(this, i8);
          }
          get isStandardBrowser() {
            return a(this, ne).standardBrowser || !1;
          }
          buildUrlWithAuth(t) {
            if ("production" === a(this, i8)) return t;
            let e = new URL(t, window.location.origin);
            return e.origin !== window.location.origin && a(this, i5) ? a(this, i5).decorateUrlWithDevBrowserToken(e).href : e.href;
          }
          buildSignInUrl(t) {
            return a(this, nC).call(this, "signInUrl", {
              ...t,
              redirectUrl: (null == t ? void 0 : t.redirectUrl) || window.location.href
            }, null == t ? void 0 : t.initialValues);
          }
          buildSignUpUrl(t) {
            return a(this, nC).call(this, "signUpUrl", {
              ...t,
              redirectUrl: (null == t ? void 0 : t.redirectUrl) || window.location.href
            }, null == t ? void 0 : t.initialValues);
          }
          buildUserProfileUrl() {
            return this.environment && this.environment.displayConfig ? this.buildUrlWithAuth(this.environment.displayConfig.userProfileUrl) : "";
          }
          buildHomeUrl() {
            return this.environment && this.environment.displayConfig ? this.buildUrlWithAuth(this.environment.displayConfig.homeUrl) : "";
          }
          buildAfterSignInUrl() {
            return this.buildUrlWithAuth(new iw(a(this, ne)).getAfterSignInUrl());
          }
          buildAfterSignUpUrl() {
            return this.buildUrlWithAuth(new iw(a(this, ne)).getAfterSignUpUrl());
          }
          buildAfterSignOutUrl() {
            return a(this, ne).afterSignOutUrl ? this.buildUrlWithAuth(a(this, ne).afterSignOutUrl) : "/";
          }
          buildAfterMultiSessionSingleSignOutUrl() {
            if (!a(this, ne).afterMultiSessionSingleSignOutUrl) {
              var t;
              return this.buildUrlWithAuth(Z({
                base: a(this, ne).signInUrl ? "".concat(a(this, ne).signInUrl, "/choose") : null === (t = this.environment) || void 0 === t ? void 0 : t.displayConfig.afterSignOutOneUrl
              }, {
                stringify: !0
              }));
            }
            return this.buildUrlWithAuth(a(this, ne).afterMultiSessionSingleSignOutUrl);
          }
          buildCreateOrganizationUrl() {
            return this.environment && this.environment.displayConfig ? this.buildUrlWithAuth(this.environment.displayConfig.createOrganizationUrl) : "";
          }
          buildOrganizationProfileUrl() {
            return this.environment && this.environment.displayConfig ? this.buildUrlWithAuth(this.environment.displayConfig.organizationProfileUrl) : "";
          }
          updateEnvironment(t) {
            var e;
            this.environment = t, null === (e = a(this, i5)) || void 0 === e || e.setEnvironment(t);
          }
          get __internal_last_error() {
            let t = this.internal_last_error;
            return this.internal_last_error = null, t;
          }
          set __internal_last_error(t) {
            this.internal_last_error = t;
          }
          get __unstable__environment() {
            return this.environment;
          }
          __internal_navigateWithError(t, e) {
            return this.__internal_last_error = e, this.navigate(t);
          }
          assertComponentsReady(t) {
            if (!nx.mountComponentRenderer) throw Error("ClerkJS was loaded without UI components.");
            if (!t) throw Error("ClerkJS components are not ready yet.");
          }
          constructor(t, e) {
            var i = this;
            if (d(this, "__experimental_ui", void 0), d(this, "client", void 0), d(this, "session", void 0), d(this, "organization", void 0), d(this, "user", void 0), d(this, "__internal_country", void 0), d(this, "telemetry", void 0), d(this, "internal_last_error", null), d(this, "environment", void 0), l(this, i1, {
              writable: !0,
              value: ""
            }), l(this, i3, {
              writable: !0,
              value: void 0
            }), l(this, i2, {
              writable: !0,
              value: void 0
            }), l(this, i5, {
              writable: !0,
              value: void 0
            }), l(this, i6, {
              writable: !0,
              value: null
            }), l(this, i4, {
              writable: !0,
              value: void 0
            }), l(this, i9, {
              writable: !0,
              value: void 0
            }), l(this, i8, {
              writable: !0,
              value: void 0
            }), l(this, i7, {
              writable: !0,
              value: !1
            }), l(this, nt, {
              writable: !0,
              value: []
            }), l(this, ne, {
              writable: !0,
              value: {}
            }), l(this, ni, {
              writable: !0,
              value: null
            }), l(this, nn, {
              writable: !0,
              value: 0
            }), d(this, "getFapiClient", () => a(this, i9)), d(this, "load", async t => {
              !this.loaded && ("development" === a(this, i8) && g.k.warnOnce("Clerk: Clerk has been loaded with development keys. Development instances have strict usage limits and should not be used when deploying your application to production. Learn more: https://clerk.com/docs/deployments/overview"), h(this, ne, {
                ...i0,
                ...t
              }), tA(a(this, ne)), a(this, ne).sdkMetadata && (nx.sdkMetadata = a(this, ne).sdkMetadata), !1 !== a(this, ne).telemetry && (this.telemetry = new b.NS({
                clerkVersion: nx.version,
                samplingRate: 1,
                publishableKey: this.publishableKey,
                ...a(this, ne).telemetry
              })), a(this, ne).allowedRedirectOrigins = function (t, e) {
                if (Array.isArray(t) && t.length) return t;
                let i = [];
                return "undefined" != typeof window && window.location && i.push(window.location.origin), i.push("https://".concat(H(e))), i.push("https://*.".concat(H(e))), i;
              }(a(this, ne).allowedRedirectOrigins, this.frontendApi), a(this, ne).standardBrowser ? h(this, i7, await a(this, nf).call(this)) : h(this, i7, await a(this, nm).call(this)), this.client && (this.__experimental_ui = new A({
                router: a(this, ne).__experimental_router,
                clerk: this,
                options: a(this, ne)
              })));
            }), d(this, "signOut", async (t, e) => {
              var i, n, r;
              if (!this.client || 0 === this.client.sessions.length) return;
              let s = t && "object" == typeof t ? t : e || {},
                o = (null == s ? void 0 : s.redirectUrl) || this.buildAfterSignOutUrl(),
                l = "function" == typeof t ? t : () => this.navigate(o);
              if (!s.sessionId || 1 === this.client.activeSessions.length) return null === (r = null === (n = a(this, ne).experimental) || void 0 === n ? void 0 : n.persistClient) || void 0 === r || r ? await this.client.removeSessions() : await this.client.destroy(), this.setActive({
                session: null,
                beforeEmit: L(l),
                redirectUrl: o
              });
              let c = this.client.activeSessions.find(t => t.id === s.sessionId),
                h = (null == c ? void 0 : c.id) && (null === (i = this.session) || void 0 === i ? void 0 : i.id) === c.id;
              if (await (null == c ? void 0 : c.remove()), h) return this.setActive({
                session: null,
                beforeEmit: L(l),
                redirectUrl: o
              });
            }), d(this, "openGoogleOneTap", t => {
              this.assertComponentsReady(a(this, i4)), a(this, i4).ensureMounted({
                preloadHint: "GoogleOneTap"
              }).then(e => e.openModal("googleOneTap", t || {}));
            }), d(this, "closeGoogleOneTap", () => {
              this.assertComponentsReady(a(this, i4)), a(this, i4).ensureMounted().then(t => t.closeModal("googleOneTap"));
            }), d(this, "openSignIn", t => {
              if (this.assertComponentsReady(a(this, i4)), P(this, this.environment)) {
                if ("development" === a(this, i8)) throw new f.w$(iX.cannotOpenSignInOrSignUp, {
                  code: "cannot_render_single_session_enabled"
                });
                return;
              }
              a(this, i4).ensureMounted({
                preloadHint: "SignIn"
              }).then(e => e.openModal("signIn", t || {}));
            }), d(this, "closeSignIn", () => {
              this.assertComponentsReady(a(this, i4)), a(this, i4).ensureMounted().then(t => t.closeModal("signIn"));
            }), d(this, "__experimental_openUserVerification", t => {
              if (this.assertComponentsReady(a(this, i4)), x(this)) {
                if ("development" === a(this, i8)) throw new f.w$(iX.cannotOpenUserProfile, {
                  code: "cannot_render_user_missing"
                });
                return;
              }
              a(this, i4).ensureMounted({
                preloadHint: "UserVerification"
              }).then(e => e.openModal("userVerification", t || {}));
            }), d(this, "__experimental_closeUserVerification", () => {
              this.assertComponentsReady(a(this, i4)), a(this, i4).ensureMounted().then(t => t.closeModal("userVerification"));
            }), d(this, "openSignUp", t => {
              if (this.assertComponentsReady(a(this, i4)), P(this, this.environment)) {
                if ("development" === a(this, i8)) throw new f.w$(iX.cannotOpenSignInOrSignUp, {
                  code: "cannot_render_single_session_enabled"
                });
                return;
              }
              a(this, i4).ensureMounted({
                preloadHint: "SignUp"
              }).then(e => e.openModal("signUp", t || {}));
            }), d(this, "closeSignUp", () => {
              this.assertComponentsReady(a(this, i4)), a(this, i4).ensureMounted().then(t => t.closeModal("signUp"));
            }), d(this, "openUserProfile", t => {
              if (this.assertComponentsReady(a(this, i4)), x(this)) {
                if ("development" === a(this, i8)) throw new f.w$(iX.cannotOpenUserProfile, {
                  code: "cannot_render_user_missing"
                });
                return;
              }
              a(this, i4).ensureMounted({
                preloadHint: "UserProfile"
              }).then(e => e.openModal("userProfile", t || {}));
            }), d(this, "closeUserProfile", () => {
              this.assertComponentsReady(a(this, i4)), a(this, i4).ensureMounted().then(t => t.closeModal("userProfile"));
            }), d(this, "openOrganizationProfile", t => {
              if (this.assertComponentsReady(a(this, i4)), R(this, this.environment)) {
                if ("development" === a(this, i8)) throw new f.w$(iX.cannotRenderAnyOrganizationComponent("OrganizationProfile"), {
                  code: "cannot_render_organizations_disabled"
                });
                return;
              }
              if (T(this)) {
                if ("development" === a(this, i8)) throw new f.w$(iX.cannotRenderComponentWhenOrgDoesNotExist, {
                  code: "cannot_render_organization_missing"
                });
                return;
              }
              a(this, i4).ensureMounted({
                preloadHint: "OrganizationProfile"
              }).then(e => e.openModal("organizationProfile", t || {}));
            }), d(this, "closeOrganizationProfile", () => {
              this.assertComponentsReady(a(this, i4)), a(this, i4).ensureMounted().then(t => t.closeModal("organizationProfile"));
            }), d(this, "openCreateOrganization", t => {
              if (this.assertComponentsReady(a(this, i4)), R(this, this.environment)) {
                if ("development" === a(this, i8)) throw new f.w$(iX.cannotRenderAnyOrganizationComponent("CreateOrganization"), {
                  code: "cannot_render_organizations_disabled"
                });
                return;
              }
              a(this, i4).ensureMounted({
                preloadHint: "CreateOrganization"
              }).then(e => e.openModal("createOrganization", t || {}));
            }), d(this, "closeCreateOrganization", () => {
              this.assertComponentsReady(a(this, i4)), a(this, i4).ensureMounted().then(t => t.closeModal("createOrganization"));
            }), d(this, "mountSignIn", (t, e) => {
              var i, n;
              e && (null === (i = e.__experimental) || void 0 === i ? void 0 : i.newComponents) && this.__experimental_ui ? this.__experimental_ui.mount("SignIn", t, e) : (this.assertComponentsReady(a(this, i4)), a(this, i4).ensureMounted({
                preloadHint: "SignIn"
              }).then(i => i.mountComponent({
                name: "SignIn",
                appearanceKey: "signIn",
                node: t,
                props: e
              }))), null === (n = this.telemetry) || void 0 === n || n.record((0, b.nx)("SignIn", e));
            }), d(this, "unmountSignIn", t => {
              this.assertComponentsReady(a(this, i4)), a(this, i4).ensureMounted().then(e => e.unmountComponent({
                node: t
              }));
            }), d(this, "mountSignUp", (t, e) => {
              var i, n;
              e && (null === (i = e.__experimental) || void 0 === i ? void 0 : i.newComponents) && this.__experimental_ui ? this.__experimental_ui.mount("SignUp", t, e) : (this.assertComponentsReady(a(this, i4)), a(this, i4).ensureMounted({
                preloadHint: "SignUp"
              }).then(i => i.mountComponent({
                name: "SignUp",
                appearanceKey: "signUp",
                node: t,
                props: e
              }))), null === (n = this.telemetry) || void 0 === n || n.record((0, b.nx)("SignUp", e));
            }), d(this, "unmountSignUp", t => {
              this.assertComponentsReady(a(this, i4)), a(this, i4).ensureMounted().then(e => e.unmountComponent({
                node: t
              }));
            }), d(this, "mountUserProfile", (t, e) => {
              var i;
              if (this.assertComponentsReady(a(this, i4)), x(this)) {
                if ("development" === a(this, i8)) throw new f.w$(iX.cannotRenderComponentWhenUserDoesNotExist, {
                  code: "cannot_render_user_missing"
                });
                return;
              }
              a(this, i4).ensureMounted({
                preloadHint: "UserProfile"
              }).then(i => i.mountComponent({
                name: "UserProfile",
                appearanceKey: "userProfile",
                node: t,
                props: e
              })), null === (i = this.telemetry) || void 0 === i || i.record((0, b.nx)("UserProfile", e));
            }), d(this, "unmountUserProfile", t => {
              this.assertComponentsReady(a(this, i4)), a(this, i4).ensureMounted().then(e => e.unmountComponent({
                node: t
              }));
            }), d(this, "mountOrganizationProfile", (t, e) => {
              var i;
              if (this.assertComponentsReady(a(this, i4)), R(this, this.environment)) {
                if ("development" === a(this, i8)) throw new f.w$(iX.cannotRenderAnyOrganizationComponent("OrganizationProfile"), {
                  code: "cannot_render_organizations_disabled"
                });
                return;
              }
              let n = !x(this);
              if (T(this) && n) {
                if ("development" === a(this, i8)) throw new f.w$(iX.cannotRenderComponentWhenOrgDoesNotExist, {
                  code: "cannot_render_organization_missing"
                });
                return;
              }
              a(this, i4).ensureMounted({
                preloadHint: "OrganizationProfile"
              }).then(i => i.mountComponent({
                name: "OrganizationProfile",
                appearanceKey: "userProfile",
                node: t,
                props: e
              })), null === (i = this.telemetry) || void 0 === i || i.record((0, b.nx)("OrganizationProfile", e));
            }), d(this, "unmountOrganizationProfile", t => {
              this.assertComponentsReady(a(this, i4)), a(this, i4).ensureMounted().then(e => e.unmountComponent({
                node: t
              }));
            }), d(this, "mountCreateOrganization", (t, e) => {
              var i, n;
              if (this.assertComponentsReady(a(this, i4)), R(this, this.environment)) {
                if ("development" === a(this, i8)) throw new f.w$(iX.cannotRenderAnyOrganizationComponent("CreateOrganization"), {
                  code: "cannot_render_organizations_disabled"
                });
                return;
              }
              null === (i = a(this, i4)) || void 0 === i || i.ensureMounted({
                preloadHint: "CreateOrganization"
              }).then(i => i.mountComponent({
                name: "CreateOrganization",
                appearanceKey: "createOrganization",
                node: t,
                props: e
              })), null === (n = this.telemetry) || void 0 === n || n.record((0, b.nx)("CreateOrganization", e));
            }), d(this, "unmountCreateOrganization", t => {
              var e;
              this.assertComponentsReady(a(this, i4)), null === (e = a(this, i4)) || void 0 === e || e.ensureMounted().then(e => e.unmountComponent({
                node: t
              }));
            }), d(this, "mountOrganizationSwitcher", (t, e) => {
              var i, n;
              if (this.assertComponentsReady(a(this, i4)), R(this, this.environment)) {
                if ("development" === a(this, i8)) throw new f.w$(iX.cannotRenderAnyOrganizationComponent("OrganizationSwitcher"), {
                  code: "cannot_render_organizations_disabled"
                });
                return;
              }
              null === (i = a(this, i4)) || void 0 === i || i.ensureMounted({
                preloadHint: "OrganizationSwitcher"
              }).then(i => i.mountComponent({
                name: "OrganizationSwitcher",
                appearanceKey: "organizationSwitcher",
                node: t,
                props: e
              })), null === (n = this.telemetry) || void 0 === n || n.record((0, b.nx)("OrganizationSwitcher", e));
            }), d(this, "unmountOrganizationSwitcher", t => {
              var e;
              this.assertComponentsReady(a(this, i4)), null === (e = a(this, i4)) || void 0 === e || e.ensureMounted().then(e => e.unmountComponent({
                node: t
              }));
            }), d(this, "__experimental_prefetchOrganizationSwitcher", () => {
              var t;
              this.assertComponentsReady(a(this, i4)), null === (t = a(this, i4)) || void 0 === t || t.ensureMounted({
                preloadHint: "OrganizationSwitcher"
              }).then(t => t.prefetch("organizationSwitcher"));
            }), d(this, "mountOrganizationList", (t, e) => {
              var i, n;
              if (this.assertComponentsReady(a(this, i4)), R(this, this.environment)) {
                if ("development" === a(this, i8)) throw new f.w$(iX.cannotRenderAnyOrganizationComponent("OrganizationList"), {
                  code: "cannot_render_organizations_disabled"
                });
                return;
              }
              null === (i = a(this, i4)) || void 0 === i || i.ensureMounted({
                preloadHint: "OrganizationList"
              }).then(i => i.mountComponent({
                name: "OrganizationList",
                appearanceKey: "organizationList",
                node: t,
                props: e
              })), null === (n = this.telemetry) || void 0 === n || n.record((0, b.nx)("OrganizationList", e));
            }), d(this, "unmountOrganizationList", t => {
              var e;
              this.assertComponentsReady(a(this, i4)), null === (e = a(this, i4)) || void 0 === e || e.ensureMounted().then(e => e.unmountComponent({
                node: t
              }));
            }), d(this, "mountUserButton", (t, e) => {
              var i, n;
              this.assertComponentsReady(a(this, i4)), null === (i = a(this, i4)) || void 0 === i || i.ensureMounted({
                preloadHint: "UserButton"
              }).then(i => i.mountComponent({
                name: "UserButton",
                appearanceKey: "userButton",
                node: t,
                props: e
              })), null === (n = this.telemetry) || void 0 === n || n.record((0, b.nx)("UserButton", e));
            }), d(this, "unmountUserButton", t => {
              var e;
              this.assertComponentsReady(a(this, i4)), null === (e = a(this, i4)) || void 0 === e || e.ensureMounted().then(e => e.unmountComponent({
                node: t
              }));
            }), d(this, "setActive", async t => {
              let {
                session: e,
                organization: i,
                beforeEmit: n,
                redirectUrl: r
              } = t;
              if (!this.client) throw Error("setActive is being called before the client is loaded. Wait for init.");
              if (void 0 === e && !this.session) throw Error("setActive should either be called with a session param or there should be already an active session.");
              let s = "undefined" != typeof window && "function" == typeof window.__unstable__onBeforeSetActive ? window.__unstable__onBeforeSetActive : k.ZT,
                o = "undefined" != typeof window && "function" == typeof window.__unstable__onAfterSetActive ? window.__unstable__onAfterSetActive : k.ZT;
              "string" == typeof e && (e = this.client.sessions.find(t => t.id === e) || null);
              let l = void 0 === e ? this.session : e,
                c = void 0 !== i;
              if (l && c) {
                let t = "string" == typeof i ? i : null == i ? void 0 : i.id;
                if ("string" == typeof t && t.startsWith("org_")) l.lastActiveOrganizationId = t || null;else {
                  let e = l.user.organizationMemberships.find(e => e.organization.slug === t);
                  l.lastActiveOrganizationId = (null == e ? void 0 : e.organization.id) || null;
                }
              }
              (null == e ? void 0 : e.lastActiveToken) && eO.dispatch(eA.TokenUpdate, {
                token: e.lastActiveToken
              }), await s(), this.session && null === l && (a(this, nb).call(this), eO.dispatch(eA.TokenUpdate, {
                token: null
              })), (ta() && globalThis.document.hasFocus() || !a(this, ne).standardBrowser) && (await a(this, nw).call(this, l), l = a(this, nA).call(this, null == l ? void 0 : l.id)), (await (null == l ? void 0 : l.getToken())) || eO.dispatch(eA.TokenUpdate, {
                token: null
              });
              let h = a(this, ne).standardBrowser ? E() : void 0;
              if (n && (null == h || h.startTracking(), a(this, nk).call(this), (0, p.x9)("beforeEmit", "Use the `redirectUrl` property instead."), await n(l), null == h || h.stopTracking()), r) {
                if (null == h || h.startTracking(), a(this, nk).call(this), this.client.isEligibleForTouch()) {
                  let t = new URL(r, window.location.href);
                  await this.navigate(this.buildUrlWithAuth(this.client.buildTouchUrl({
                    redirectUrl: t
                  })));
                } else await this.navigate(r);
                null == h || h.stopTracking();
              }
              (null == h || !h.isUnloading()) && (a(this, nU).call(this, l), a(this, n_).call(this), await o(), a(this, ny).call(this));
            }), d(this, "addListener", t => {
              var e;
              let i;
              return e = t, t = t => {
                var n;
                i || (i = {
                  ...t
                }), e(i = {
                  client: is((n = i).client, t.client),
                  session: is(n.session, t.session),
                  user: is(n.user, t.user),
                  organization: is(n.organization, t.organization)
                });
              }, a(this, nt).push(t), this.client && t({
                client: this.client,
                session: this.session,
                user: this.user,
                organization: this.organization
              }), () => {
                h(this, nt, a(this, nt).filter(e => e !== t));
              };
            }), d(this, "navigate", async (t, e) => {
              var i;
              if (!t || !ta()) return;
              let n = new URL(t, window.location.href);
              I.includes(n.protocol) || (console.warn('Clerk: "'.concat(n.protocol, '" is not a valid protocol. Redirecting to "/" instead. If you think this is a mistake, please open an issue.')), n = new URL("/", window.location.href));
              let r = (null == e ? void 0 : e.replace) && a(this, ne).routerReplace ? a(this, ne).routerReplace : a(this, ne).routerPush;
              if (a(this, ne).routerDebug && console.log("Clerk is navigating to: ".concat(n)), n.origin !== window.location.origin || !r) {
                C(n);
                return;
              }
              let s = {
                ...((null == e ? void 0 : e.metadata) ? {
                  __internal_metadata: null == e ? void 0 : e.metadata
                } : {}),
                windowNavigate: C
              };
              return await r((i = new URL((i = n).toString(), window.location.origin)).href.replace(i.origin, ""), s);
            }), l(this, nr, {
              writable: !0,
              value: async () => {
                if (!ta()) return;
                let t = new URLSearchParams({
                    [iH]: "true"
                  }),
                  e = W(iZ);
                e && w(e) || function () {
                  throw Error("".concat(tO, " Invalid redirect_url. A valid http or https url should be used for the redirection."));
                }();
                let i = Z({
                  base: W(iZ),
                  searchParams: t
                }, {
                  stringify: !0
                });
                return this.navigate(this.buildUrlWithAuth(i));
              }
            }), d(this, "redirectWithAuth", async t => {
              if (ta()) return this.navigate(this.buildUrlWithAuth(t));
            }), d(this, "redirectToSignIn", async t => {
              if (ta()) return this.navigate(this.buildSignInUrl(t));
            }), d(this, "redirectToSignUp", async t => {
              if (ta()) return this.navigate(this.buildSignUpUrl(t));
            }), d(this, "redirectToUserProfile", async () => {
              if (ta()) return this.navigate(this.buildUserProfileUrl());
            }), d(this, "redirectToCreateOrganization", async () => {
              if (ta()) return this.navigate(this.buildCreateOrganizationUrl());
            }), d(this, "redirectToOrganizationProfile", async () => {
              if (ta()) return this.navigate(this.buildOrganizationProfileUrl());
            }), d(this, "redirectToAfterSignIn", async () => {
              if (ta()) return this.navigate(this.buildAfterSignInUrl());
            }), d(this, "redirectToAfterSignUp", async () => {
              if (ta()) return this.navigate(this.buildAfterSignUpUrl());
            }), d(this, "redirectToAfterSignOut", async () => {
              if (ta()) return this.navigate(this.buildAfterSignOutUrl());
            }), d(this, "handleEmailLinkVerification", async (t, e) => {
              if (!this.client) return;
              let i = W("__clerk_status");
              if ("expired" === i) throw new f.N(f._L.Expired);
              if ("client_mismatch" === i) throw new f.N(f._L.ClientMismatch);
              if ("verified" !== i) throw new f.N(f._L.Failed);
              let n = W("__clerk_created_session"),
                {
                  signIn: r,
                  signUp: s,
                  sessions: a
                } = this.client,
                o = a.some(t => t.id === n),
                l = "needs_second_factor" === r.status || "missing_requirements" === s.status,
                c = t => e && "function" == typeof e ? e(t) : this.navigate(t),
                h = t.redirectUrl ? () => c(t.redirectUrl) : k.ZT;
              return o ? this.setActive({
                session: n,
                redirectUrl: t.redirectUrlComplete
              }) : l ? h() : ("function" == typeof t.onVerifiedOnOtherDevice && t.onVerifiedOnOtherDevice(), null);
            }), d(this, "handleGoogleOneTapCallback", async (t, e, i) => {
              if (!this.loaded || !this.environment || !this.client) return;
              let {
                  signIn: n,
                  signUp: r
                } = this.client,
                s = "identifier" in (t || {}) ? t : n,
                a = "missingFields" in (t || {}) ? t : r;
              return this._handleRedirectCallback(e, {
                signUp: a,
                signIn: s,
                navigate: t => i && "function" == typeof i ? i(this.buildUrlWithAuth(t)) : this.navigate(this.buildUrlWithAuth(t))
              });
            }), d(this, "_handleRedirectCallback", async (t, e) => {
              var i, n, r, s, o, l;
              let {
                signIn: c,
                signUp: h,
                navigate: d
              } = e;
              if (!this.loaded || !this.environment || !this.client) return;
              let {
                  displayConfig: u
                } = this.environment,
                {
                  firstFactorVerification: p
                } = c,
                {
                  externalAccount: f
                } = h.verifications,
                m = {
                  status: h.status,
                  missingFields: h.missingFields,
                  externalAccountStatus: f.status,
                  externalAccountErrorCode: null === (i = f.error) || void 0 === i ? void 0 : i.code,
                  externalAccountSessionId: null === (r = f.error) || void 0 === r ? void 0 : null === (n = r.meta) || void 0 === n ? void 0 : n.sessionId,
                  sessionId: h.createdSessionId
                },
                v = {
                  status: c.status,
                  firstFactorVerificationStatus: p.status,
                  firstFactorVerificationErrorCode: null === (s = p.error) || void 0 === s ? void 0 : s.code,
                  firstFactorVerificationSessionId: null === (l = p.error) || void 0 === l ? void 0 : null === (o = l.meta) || void 0 === o ? void 0 : o.sessionId,
                  sessionId: c.createdSessionId
                },
                g = t => () => d(t),
                w = g(t.signInUrl || u.signInUrl),
                _ = g(t.signUpUrl || u.signUpUrl),
                b = g(t.firstFactorUrl || Z({
                  base: u.signInUrl,
                  hashPath: "/factor-one"
                }, {
                  stringify: !0
                })),
                y = g(t.secondFactorUrl || Z({
                  base: u.signInUrl,
                  hashPath: "/factor-two"
                }, {
                  stringify: !0
                })),
                k = g(t.resetPasswordUrl || Z({
                  base: u.signInUrl,
                  hashPath: "/reset-password"
                }, {
                  stringify: !0
                })),
                S = new iw(a(this, ne), t),
                U = g(t.continueSignUpUrl || Z({
                  base: u.signUpUrl,
                  hashPath: "/continue"
                }, {
                  stringify: !0
                })),
                A = e => {
                  let {
                    missingFields: i
                  } = e;
                  return i.length ? U() : tU({
                    signUp: h,
                    verifyEmailPath: t.verifyEmailAddressUrl || Z({
                      base: u.signUpUrl,
                      hashPath: "/verify-email-address"
                    }, {
                      stringify: !0
                    }),
                    verifyPhonePath: t.verifyPhoneNumberUrl || Z({
                      base: u.signUpUrl,
                      hashPath: "/verify-phone-number"
                    }, {
                      stringify: !0
                    }),
                    navigate: d
                  });
                };
              if ("complete" === v.status) return this.setActive({
                session: v.sessionId,
                redirectUrl: S.getAfterSignInUrl()
              });
              if ("transferable" === m.externalAccountStatus && "external_account_exists" === m.externalAccountErrorCode) {
                let t = await c.create({
                  transfer: !0
                });
                switch (t.status) {
                  case "complete":
                    return this.setActive({
                      session: t.createdSessionId,
                      redirectUrl: S.getAfterSignInUrl()
                    });
                  case "needs_first_factor":
                    return b();
                  case "needs_second_factor":
                    return y();
                  case "needs_new_password":
                    return k();
                  default:
                    tE("sign in");
                }
              }
              let O = "user_locked" === m.externalAccountErrorCode,
                I = "user_locked" === v.firstFactorVerificationErrorCode;
              if (O) return _();
              if (I) return w();
              if ("needs_first_factor" === v.status) return b();
              if ("needs_new_password" === v.status) return k();
              if ("transferable" === v.firstFactorVerificationStatus) {
                if (!1 === t.transferable) return w();
                let e = await h.create({
                  transfer: !0
                });
                switch (e.status) {
                  case "complete":
                    return this.setActive({
                      session: e.createdSessionId,
                      redirectUrl: S.getAfterSignUpUrl()
                    });
                  case "missing_requirements":
                    return A({
                      missingFields: e.missingFields
                    });
                  default:
                    tE("sign in");
                }
              }
              if ("complete" === m.status) return this.setActive({
                session: m.sessionId,
                redirectUrl: S.getAfterSignUpUrl()
              });
              if ("needs_second_factor" === v.status) return y();
              let C = ("failed" === m.externalAccountStatus || "unverified" === m.externalAccountStatus) && "identifier_already_signed_in" === m.externalAccountErrorCode && m.externalAccountSessionId,
                E = "failed" === v.firstFactorVerificationStatus && "identifier_already_signed_in" === v.firstFactorVerificationErrorCode && v.firstFactorVerificationSessionId;
              if (C || E) {
                let t = v.firstFactorVerificationSessionId || m.externalAccountSessionId;
                if (t) return this.setActive({
                  session: t,
                  redirectUrl: S.getAfterSignInUrl()
                });
              }
              return Q(h) ? _() : "verified" === m.externalAccountStatus && "missing_requirements" === m.status ? A({
                missingFields: h.missingFields
              }) : w();
            }), d(this, "handleRedirectCallback", async function () {
              let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                e = arguments.length > 1 ? arguments[1] : void 0;
              if (!i.loaded || !i.environment || !i.client) return;
              let {
                signIn: n,
                signUp: r
              } = i.client;
              return i._handleRedirectCallback(t, {
                signUp: r,
                signIn: n,
                navigate: t => e && "function" == typeof e ? e(t) : i.navigate(t)
              });
            }), d(this, "handleUnauthenticated", async function () {
              let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
                broadcast: !0
              };
              if (!i.client || !i.session) return;
              let e = await tJ.getInstance().fetch();
              if (i.updateClient(e), !i.session) return t.broadcast && a(i, nb).call(i), i.setActive({
                session: null
              });
            }), d(this, "authenticateWithGoogleOneTap", async t => {
              var e;
              return null === (e = this.client) || void 0 === e ? void 0 : e.signIn.create({
                strategy: "google_one_tap",
                token: t.token
              }).catch(e => {
                if ((0, f.kD)(e) && "external_account_not_found" === e.errors[0].code) {
                  var i;
                  return null === (i = this.client) || void 0 === i ? void 0 : i.signUp.create({
                    strategy: "google_one_tap",
                    token: t.token,
                    __experimental_legalAccepted: t.__experimental_legalAccepted
                  });
                }
                throw e;
              });
            }), d(this, "authenticateWithMetamask", async function () {
              let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              await i.authenticateWithWeb3({
                ...t,
                strategy: "web3_metamask_signature"
              });
            }), d(this, "authenticateWithCoinbaseWallet", async function () {
              let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
              await i.authenticateWithWeb3({
                ...t,
                strategy: "web3_coinbase_wallet_signature"
              });
            }), d(this, "authenticateWithWeb3", async t => {
              let e,
                {
                  redirectUrl: i,
                  signUpContinueUrl: n,
                  customNavigate: r,
                  unsafeMetadata: s,
                  strategy: a,
                  __experimental_legalAccepted: o
                } = t;
              if (!this.client || !this.environment) return;
              let l = a.replace("web3_", "").replace("_signature", ""),
                c = await tg({
                  provider: l
                }),
                h = "metamask" === l ? ty : tk;
              try {
                e = await this.client.signIn.authenticateWithWeb3({
                  identifier: c,
                  generateSignature: h,
                  strategy: a
                });
              } catch (t) {
                if (M(t, iY.FORM_IDENTIFIER_NOT_FOUND)) {
                  if (e = await this.client.signUp.authenticateWithWeb3({
                    identifier: c,
                    generateSignature: h,
                    unsafeMetadata: s,
                    strategy: a,
                    __experimental_legalAccepted: o
                  }), n && "missing_requirements" === e.status && "verified" === e.verifications.web3Wallet.status) await (r && "function" == typeof r ? r(n) : this.navigate(n));
                } else throw t;
              }
              e.createdSessionId && (await this.setActive({
                session: e.createdSessionId,
                redirectUrl: i
              }));
            }), d(this, "createOrganization", async t => {
              let {
                name: e,
                slug: i
              } = t;
              return eo.create({
                name: e,
                slug: i
              });
            }), d(this, "getOrganization", async t => eo.get(t)), d(this, "__internal_setCountry", t => {
              this.__internal_country || (this.__internal_country = t);
            }), d(this, "updateClient", t => {
              if (!this.client) {
                let e = a(this, ne).selectInitialSession ? a(this, ne).selectInitialSession(t) : a(this, nv).call(this, t);
                a(this, nU).call(this, e);
              }
              if (this.client = t, this.session) {
                let t = a(this, nA).call(this, this.session.id);
                a(this, nU).call(this, t);
              }
              a(this, n_).call(this);
            }), d(this, "__unstable__setEnvironment", async t => {
              this.environment = new tG(t), nx.mountComponentRenderer && h(this, i4, nx.mountComponentRenderer(this, this.environment, a(this, ne)));
            }), d(this, "__unstable__onBeforeRequest", t => {
              a(this, i9).onBeforeRequest(t);
            }), d(this, "__unstable__onAfterResponse", t => {
              a(this, i9).onAfterResponse(t);
            }), d(this, "__unstable__updateProps", t => {
              var e;
              return null === (e = a(this, i4)) || void 0 === e ? void 0 : e.ensureMounted().then(e => e.updateProps(t));
            }), l(this, ns, {
              writable: !0,
              value: () => "true" === W(iH)
            }), l(this, na, {
              writable: !0,
              value: () => N(iH)
            }), l(this, no, {
              writable: !0,
              value: () => {
                let t = new URLSearchParams({
                  [iZ]: window.location.href
                });
                return Z({
                  base: a(this, ne).signInUrl,
                  searchParams: t
                }, {
                  stringify: !0
                });
              }
            }), l(this, nl, {
              writable: !0,
              value: () => {
                let t;
                if (this.proxyUrl) {
                  let e = new URL(this.proxyUrl);
                  t = new URL("".concat(e.pathname, "/v1/client/sync"), e.origin);
                } else this.domain && (t = new URL("/v1/client/sync", "https://".concat(this.domain)));
                return null == t || t.searchParams.append("redirect_url", window.location.href), (null == t ? void 0 : t.toString()) || "";
              }
            }), l(this, nc, {
              writable: !0,
              value: () => {
                var t;
                return a(this, ns).call(this) ? (a(this, na).call(this), !1) : !!this.isSatellite && !!(null === (t = a(this, i5)) || void 0 === t ? void 0 : t.isSignedOut());
              }
            }), l(this, nh, {
              writable: !0,
              value: () => "production" !== a(this, i8) && !this.isSatellite && !!W(iZ)
            }), l(this, nd, {
              writable: !0,
              value: async () => {
                "development" === this.instanceType ? await this.navigate(a(this, no).call(this)) : "production" === this.instanceType && (await this.navigate(a(this, nl).call(this)));
              }
            }), l(this, nu, {
              writable: !0,
              value: (t, e) => {
                let i;
                try {
                  i = new URL(t);
                } catch {
                  !function () {
                    throw Error("".concat(tO, " The signInUrl needs to have a absolute url format."));
                  }();
                }
                i.origin === e && function () {
                  throw Error("".concat(tO, " The signInUrl needs to be on a different origin than your satellite application."));
                }();
              }
            }), l(this, np, {
              writable: !0,
              value: () => {
                this.isSatellite && ("development" !== a(this, i8) || a(this, ne).signInUrl || function () {
                  throw Error("".concat(tO, " Missing signInUrl. A satellite application needs to specify the signInUrl for development instances."));
                }(), this.proxyUrl || this.domain || function () {
                  throw Error("".concat(tO, " Missing domain and proxyUrl. A satellite application needs to specify a domain or a proxyUrl."));
                }(), a(this, ne).signInUrl && a(this, nu).call(this, a(this, ne).signInUrl, window.location.origin));
              }
            }), l(this, nf, {
              writable: !0,
              value: async () => {
                var t, e, i;
                if (h(this, i5, await iG.create(this, a(this, i9))), a(this, np).call(this), a(this, nc).call(this)) return await a(this, nd).call(this), !1;
                if ("production" === a(this, i8) ? null === (e = a(this, i5)) || void 0 === e || e.setupProduction() : await (null === (i = a(this, i5)) || void 0 === i ? void 0 : i.setupDevelopment()), a(this, nh).call(this)) return await a(this, nr).call(this), !1;
                h(this, ni, ts()), h(this, i6, new v("clerk")), a(this, ng).call(this);
                let n = function () {
                    let t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : window.location.hostname;
                    if (!t) return !1;
                    let e = G.get(t);
                    return void 0 === e && (e = (0, y.A5)(t) || (0, y.LQ)(t), G.set(t, e)), e;
                  }(null === (t = window) || void 0 === t ? void 0 : t.location.hostname),
                  r = "development" === a(this, i8) && !n,
                  s = 0;
                for (; s < 2;) {
                  s++;
                  try {
                    let [t, e] = await Promise.all([tG.getInstance().fetch({
                      touch: r
                    }), tJ.getInstance().fetch()]);
                    if (this.updateClient(e), this.updateEnvironment(t), a(this, i5).setActiveOrganizationInStorage(), await a(this, nE).call(this)) return !1;
                    nx.mountComponentRenderer && h(this, i4, nx.mountComponentRenderer(this, this.environment, a(this, ne)));
                    break;
                  } catch (t) {
                    if (M(t, "dev_browser_unauthenticated")) await a(this, i5).handleUnauthenticatedDevBrowser();else if (!(0, u.af)()) return console.warn(t), !1;else throw t;
                  }
                  s >= 2 && function () {
                    throw Error("".concat(tO, " Something went wrong initializing Clerk."));
                  }();
                }
                return a(this, nP).call(this), a(this, nI).call(this), !0;
              }
            }), l(this, nm, {
              writable: !0,
              value: async () => {
                let [t, e] = await Promise.all([tG.getInstance().fetch({
                  touch: !1
                }), tJ.getInstance().fetch()]);
                return this.updateClient(e), this.updateEnvironment(t), nx.mountComponentRenderer && h(this, i4, nx.mountComponentRenderer(this, this.environment, a(this, ne))), !0;
              }
            }), l(this, nv, {
              writable: !0,
              value: t => {
                if (t.lastActiveSessionId) {
                  let e = t.activeSessions.find(e => e.id === t.lastActiveSessionId);
                  if (e) return e;
                }
                return t.activeSessions[0] || null;
              }
            }), l(this, ng, {
              writable: !0,
              value: () => {
                var t, e;
                (0, u._f)() && (null === (t = a(this, ni)) || void 0 === t || t.onPageFocus(() => {
                  this.session && !(a(this, nn) > Date.now()) && (h(this, nn, Date.now() + 5e3), a(this, nw).call(this, this.session));
                }), null === (e = a(this, i6)) || void 0 === e || e.addEventListener("message", t => {
                  let {
                    data: e
                  } = t;
                  "signout" === e.type && this.handleUnauthenticated();
                }));
              }
            }), l(this, nw, {
              writable: !0,
              value: async t => {
                if (!t || !a(this, ne).touchSession) return Promise.resolve();
                await t.touch().catch(t => {
                  (0, f.ix)(t) && this.handleUnauthenticated();
                });
              }
            }), l(this, n_, {
              writable: !0,
              value: () => {
                if (this.client) for (let t of a(this, nt)) t({
                  client: this.client,
                  session: this.session,
                  user: this.user,
                  organization: this.organization
                });
              }
            }), l(this, nb, {
              writable: !0,
              value: () => {
                var t;
                null === (t = a(this, i6)) || void 0 === t || t.postMessage({
                  type: "signout"
                });
              }
            }), l(this, ny, {
              writable: !0,
              value: () => {
                nx.mountComponentRenderer && (this.closeSignUp(), this.closeSignIn());
              }
            }), l(this, nk, {
              writable: !0,
              value: () => {
                this.session = void 0, this.organization = void 0, this.user = void 0, a(this, n_).call(this);
              }
            }), l(this, nS, {
              writable: !0,
              value: () => {
                var t;
                return ((null === (t = this.session) || void 0 === t ? void 0 : t.user.organizationMemberships) || []).map(t => t.organization).find(t => {
                  var e;
                  return t.id === (null === (e = this.session) || void 0 === e ? void 0 : e.lastActiveOrganizationId);
                }) || null;
              }
            }), l(this, nU, {
              writable: !0,
              value: t => {
                this.session = t || null, this.organization = a(this, nS).call(this), a(this, nO).call(this);
              }
            }), l(this, nA, {
              writable: !0,
              value: t => {
                var e;
                return (null === (e = this.client) || void 0 === e ? void 0 : e.activeSessions.find(e => e.id === t)) || null;
              }
            }), l(this, nO, {
              writable: !0,
              value: () => {
                this.user = this.session ? this.session.user : null;
              }
            }), l(this, nI, {
              writable: !0,
              value: () => {
                this.addListener(t => {
                  let {
                    session: e
                  } = t;
                  if (null == e ? void 0 : e.actor) {
                    var i;
                    null === (i = a(this, i4)) || void 0 === i || i.ensureMounted().then(t => t.mountImpersonationFab());
                  }
                });
              }
            }), l(this, nC, {
              writable: !0,
              value: (t, e, i) => {
                if (!t || !this.loaded || !this.environment || !this.environment.displayConfig) return "";
                let n = a(this, ne)[t] || this.environment.displayConfig[t],
                  r = new iw(a(this, ne), e).toSearchParams(),
                  s = Z({
                    base: n,
                    hashSearchParams: [new URLSearchParams(i || {}), r]
                  }, {
                    stringify: !0
                  });
                return this.buildUrlWithAuth(s);
              }
            }), l(this, nE, {
              writable: !0,
              value: async () => {
                var t, e;
                let i = new URLSearchParams(window.location.search).get("redirect_url"),
                  n = "production" === this.instanceType,
                  r = null !== i && function (t, e) {
                    let i = new URL(e, $),
                      n = i.pathname,
                      r = X.includes(n) || tt.includes(n);
                    return t === i.host && r;
                  }(this.frontendApi, i);
                if (n || !r) return !1;
                let s = this.session,
                  o = a(this, ne).signInUrl || (null === (t = this.environment) || void 0 === t ? void 0 : t.displayConfig.signInUrl),
                  l = o && window.location.href.startsWith(o),
                  c = a(this, ne).signUpUrl || (null === (e = this.environment) || void 0 === e ? void 0 : e.displayConfig.signUpUrl),
                  h = c && window.location.href.startsWith(c);
                return (!function (t) {
                  let e = new URL(t, $);
                  return X.includes(e.pathname);
                }(i) || !!s || !l && !h) && (await this.navigate(this.buildUrlWithAuth(i)), !0);
              }
            }), l(this, nP, {
              writable: !0,
              value: () => {
                try {
                  N("__clerk_handshake"), N("__clerk_help");
                } catch (t) {}
              }
            }), t = (t || "").trim(), h(this, i3, null == e ? void 0 : e.domain), h(this, i2, null == e ? void 0 : e.proxyUrl), !t) return z.throwMissingPublishableKeyError();
            let n = (0, m.nQ)(t);
            if (!n) return z.throwInvalidPublishableKeyError({
              key: t
            });
            h(this, i1, t), h(this, i8, n.instanceType), h(this, i9, eB(this)), tW.clerk = this;
          }
        }
        d(nx, "mountComponentRenderer", void 0), d(nx, "version", "5.30.3"), d(nx, "sdkMetadata", {
          name: "@clerk/clerk-js",
          version: "5.30.3",
          environment: "production"
        }), (t = i.hmd(t)).hot && t.hot.accept();
      },
      2634: function (t, e, i) {
        "use strict";

        i.d(e, {
          x9: () => a
        });
        var n = () => !1,
          r = () => {
            try {
              return !0;
            } catch (t) {}
            return !1;
          },
          s = new Set(),
          a = (t, e, i) => {
            let a = n() || r(),
              o = null != i ? i : t;
            !s.has(o) && !a && (s.add(o), console.warn(`Clerk - DEPRECATION WARNING: "${t}" is deprecated and will be removed in the next major release.
${e}`));
          };
      },
      2689: function (t, e, i) {
        "use strict";

        i.d(e, {
          Ko: function () {
            return p;
          },
          U9: function () {
            return m;
          },
          ac: function () {
            return u;
          },
          qx: function () {
            return f;
          },
          r2: function () {
            return l;
          },
          yA: function () {
            return h;
          }
        });
        var n = Object.defineProperty,
          r = Object.getOwnPropertyDescriptor,
          s = Object.getOwnPropertyNames,
          a = Object.prototype.hasOwnProperty,
          o = t => {
            throw TypeError(t);
          },
          l = (t, e) => {
            for (var i in e) n(t, i, {
              get: e[i],
              enumerable: !0
            });
          },
          c = (t, e, i, o) => {
            if (e && "object" == typeof e || "function" == typeof e) for (let l of s(e)) a.call(t, l) || l === i || n(t, l, {
              get: () => e[l],
              enumerable: !(o = r(e, l)) || o.enumerable
            });
            return t;
          },
          h = (t, e, i) => (c(t, e, "default"), i && c(i, e, "default")),
          d = (t, e, i) => e.has(t) || o("Cannot " + i),
          u = (t, e, i) => (d(t, e, "read from private field"), i ? i.call(t) : e.get(t)),
          p = (t, e, i) => e.has(t) ? o("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, i),
          f = (t, e, i, n) => (d(t, e, "write to private field"), n ? n.call(t, i) : e.set(t, i), i),
          m = (t, e, i) => (d(t, e, "access private method"), i);
      },
      5427: function (t, e, i) {
        "use strict";

        i.d(e, {
          Z: function () {
            return n;
          }
        });
        var n = (...t) => {};
      },
      8502: function (t, e, i) {
        "use strict";

        i.d(e, {
          k: function () {
            return r;
          }
        });
        var n = new Set(),
          r = {
            warnOnce: t => {
              !n.has(t) && (n.add(t), console.warn(t));
            },
            logOnce: t => {
              !n.has(t) && (console.log(t), n.add(t));
            }
          };
      },
      3861: function (t, e, i) {
        "use strict";

        function n(t) {
          try {
            return new Date(t || new Date());
          } catch (t) {
            return new Date();
          }
        }
        function r(t, e) {
          let i = n(t);
          return i.setFullYear(i.getFullYear() + e), i;
        }
        i.d(e, {
          Bc: function () {
            return r;
          },
          P9: function () {
            return n;
          }
        });
      },
      3382: function (t, e, i) {
        "use strict";

        i.d(e, {
          JF: function () {
            return r;
          },
          WY: function () {
            return a;
          },
          mv: function () {
            return n;
          },
          vO: function () {
            return s;
          }
        });
        var n = [".lcl.dev", ".lclstage.dev", ".lclclerk.com"],
          r = [".accounts.dev", ".accountsstage.dev", ".accounts.lclclerk.com"],
          s = [".lcl.dev", ".stg.dev", ".lclstage.dev", ".stgstage.dev", ".dev.lclclerk.com", ".stg.lclclerk.com", ".accounts.lclclerk.com", "accountsstage.dev", "accounts.dev"];
        function a(t, e = "svg") {
          return `https://img.clerk.com/static/${t}.${e}`;
        }
      },
      6029: function (t, e, i) {
        "use strict";

        i.d(e, {
          A5: function () {
            return a;
          },
          LQ: function () {
            return o;
          },
          QT: function () {
            return h;
          },
          d5: function () {
            return r;
          },
          mD: function () {
            return d;
          },
          sD: function () {
            return m;
          },
          xn: function () {
            return p;
          },
          xy: function () {
            return s;
          }
        });
        var n = i(3382);
        function r(t = "") {
          return (t || "").replace(/^.+:\/\//, "");
        }
        function s(t) {
          let e;
          if (!t) return "";
          if (t.match(/^(clerk\.)+\w*$/)) e = /(clerk\.)*(?=clerk\.)/;else {
            if (t.match(/\.clerk.accounts/)) return t;
            e = /^(clerk\.)*/gi;
          }
          let i = t.replace(e, "");
          return `clerk.${i}`;
        }
        function a(t) {
          return n.mv.some(e => t.startsWith("accounts.") && t.endsWith(e));
        }
        function o(t) {
          return n.JF.some(e => t.endsWith(e) && !t.endsWith(".clerk" + e));
        }
        var l = /\/$|\/\?|\/#/;
        function c(t = "", e) {
          return e ? l.test(t) : t.endsWith("/");
        }
        function h(t = "", e) {
          if (!e) return (c(t) ? t.slice(0, -1) : t) || "/";
          if (!c(t, !0)) return t || "/";
          let i = t,
            n = "",
            r = t.indexOf("#");
          r >= 0 && (i = t.slice(0, r), n = t.slice(r));
          let [s, ...a] = i.split("?");
          return (s.slice(0, -1) || "/") + (a.length > 0 ? `?${a.join("?")}` : "") + n;
        }
        function d(t = "") {
          return !function (t = "") {
            return t.startsWith("/");
          }(t) ? "/" + t : t;
        }
        var u = /^\.?\//;
        function p(t, ...e) {
          let i = t || "";
          for (let t of e.filter(t => t && "/" !== t)) if (i) {
            let e = t.replace(u, "");
            i = function (t = "", e) {
              return t.endsWith("/") ? t : t + "/";
            }(i) + e;
          } else i = t;
          return i;
        }
        var f = /^[a-zA-Z][a-zA-Z\d+\-.]*?:/,
          m = t => f.test(t);
      },
      4193: function (t, e, i) {
        "use strict";

        i.d(e, {
          nQ: () => o,
          MY: () => l,
          P: () => c,
          _d: () => h
        });
        var n = t => "undefined" != typeof atob && "function" == typeof atob ? atob(t) : "undefined" != typeof global && global.Buffer ? new global.Buffer(t, "base64").toString() : t,
          r = t => "undefined" != typeof btoa && "function" == typeof btoa ? btoa(t) : "undefined" != typeof global && global.Buffer ? new global.Buffer(t).toString("base64") : t,
          s = i("3382"),
          a = "pk_live_";
        function o(t, e = {}) {
          if (!(t = t || "") || !function (t) {
            let e = (t = t || "").startsWith(a) || t.startsWith("pk_test_"),
              i = n(t.split("_")[2] || "").endsWith("$");
            return e && i;
          }(t)) {
            if (e.fatal) throw Error("Publishable key not valid.");
            return null;
          }
          let i = t.startsWith(a) ? "production" : "development",
            r = n(t.split("_")[2]);
          return r = r.slice(0, -1), e.proxyUrl ? r = e.proxyUrl : "development" !== i && e.domain && (r = `clerk.${e.domain}`), {
            instanceType: i,
            frontendApi: r
          };
        }
        function l() {
          let t = new Map();
          return {
            isDevOrStagingUrl: e => {
              if (!e) return !1;
              let i = "string" == typeof e ? e : e.hostname,
                n = t.get(i);
              return void 0 === n && (n = s.vO.some(t => i.endsWith(t)), t.set(i, n)), n;
            }
          };
        }
        async function c(t, e = globalThis.crypto.subtle) {
          let i = new TextEncoder().encode(t);
          return r(String.fromCharCode(...new Uint8Array(await e.digest("sha-1", i)))).replace(/\+/gi, "-").replace(/\//gi, "_").substring(0, 8);
        }
        var h = (t, e) => `${t}_${e}`;
      },
      9934: function (t, e, i) {
        "use strict";

        function n() {
          return "undefined" != typeof window;
        }
        i.d(e, {
          Er: function () {
            return s;
          },
          TN: function () {
            return a;
          },
          _f: function () {
            return n;
          },
          af: function () {
            return o;
          }
        });
        var r = RegExp("bot|spider|crawl|APIs-Google|AdsBot|Googlebot|mediapartners|Google Favicon|FeedFetcher|Google-Read-Aloud|DuplexWeb-Google|googleweblight|bing|yandex|baidu|duckduck|yahoo|ecosia|ia_archiver|facebook|instagram|pinterest|reddit|slack|twitter|whatsapp|youtube|semrush", "i");
        function s() {
          var t;
          let e = n() ? null == window ? void 0 : window.navigator : null;
          return !!e && !((t = null == e ? void 0 : e.userAgent) && r.test(t)) && !(null == e ? void 0 : e.webdriver);
        }
        function a() {
          var t, e;
          let i = n() ? null == window ? void 0 : window.navigator : null;
          if (!i) return !1;
          let r = null == i ? void 0 : i.onLine;
          return (null == (t = null == i ? void 0 : i.connection) ? void 0 : t.rtt) !== 0 && (null == (e = null == i ? void 0 : i.connection) ? void 0 : e.downlink) !== 0 && r;
        }
        function o() {
          return a() && s();
        }
      },
      8826: function (t, e, i) {
        "use strict";

        i.d(e, {
          Q: function () {
            return o;
          }
        });
        var n = i(5427),
          r = 'const respond=r=>{self.postMessage(r)},workerToTabIds={};self.addEventListener("message",r=>{const e=r.data;switch(e.type){case"setTimeout":workerToTabIds[e.id]=setTimeout(()=>{respond({id:e.id})},e.ms);break;case"clearTimeout":workerToTabIds[e.id]&&(clearTimeout(workerToTabIds[e.id]),delete workerToTabIds[e.id]);break;case"setInterval":workerToTabIds[e.id]=setInterval(()=>{respond({id:e.id})},e.ms);break;case"clearInterval":workerToTabIds[e.id]&&(clearInterval(workerToTabIds[e.id]),delete workerToTabIds[e.id]);break}});\n',
          s = (t, e = {}) => {
            if ("undefined" == typeof Worker) return null;
            try {
              let i = new Blob([t], {
                  type: "application/javascript; charset=utf-8"
                }),
                n = globalThis.URL.createObjectURL(i);
              return new Worker(n, e);
            } catch (t) {
              return console.warn("Clerk: Cannot create worker from blob. Consider adding worker-src blob:; to your CSP"), null;
            }
          },
          a = () => {
            let t = globalThis.setTimeout.bind(globalThis),
              e = globalThis.setInterval.bind(globalThis);
            return {
              setTimeout: t,
              setInterval: e,
              clearTimeout: globalThis.clearTimeout.bind(globalThis),
              clearInterval: globalThis.clearInterval.bind(globalThis),
              cleanup: n.Z
            };
          },
          o = () => {
            let t = 0,
              e = () => t++,
              i = new Map(),
              n = (t, e) => null == t ? void 0 : t.postMessage(e),
              o = t => {
                var e;
                null == (e = i.get(t.data.id)) || e();
              },
              l = s(r, {
                name: "clerk-timers"
              });
            if (null == l || l.addEventListener("message", o), !l) return a();
            let c = () => {
              l || null == (l = s(r, {
                name: "clerk-timers"
              })) || l.addEventListener("message", o);
            };
            return {
              setTimeout: (t, r) => {
                c();
                let s = e();
                return i.set(s, t), n(l, {
                  type: "setTimeout",
                  id: s,
                  ms: r
                }), s;
              },
              setInterval: (t, r) => {
                c();
                let s = e();
                return i.set(s, t), n(l, {
                  type: "setInterval",
                  id: s,
                  ms: r
                }), s;
              },
              clearTimeout: t => {
                c(), i.delete(t), n(l, {
                  type: "clearTimeout",
                  id: t
                });
              },
              clearInterval: t => {
                c(), i.delete(t), n(l, {
                  type: "clearInterval",
                  id: t
                });
              },
              cleanup: () => {
                l && (l.terminate(), l = null, i.clear());
              }
            };
          };
      },
      8774: function (t, e, i) {
        "use strict";

        function n(t) {
          let e = t || "";
          return e.charAt(0).toUpperCase() + e.slice(1);
        }
        function r(t) {
          return t ? t.replace(/([-_][a-z])/g, t => t.toUpperCase().replace(/-|_/, "")) : "";
        }
        function s(t) {
          return t ? t.replace(/[A-Z]/g, t => `_${t.toLowerCase()}`) : "";
        }
        i.d(e, {
          MI: function () {
            return n;
          },
          TD: function () {
            return r;
          },
          a1: function () {
            return s;
          },
          aw: function () {
            return o;
          },
          fQ: function () {
            return l;
          },
          hF: function () {
            return c;
          }
        });
        var a = t => {
          let e = i => {
            if (!i) return i;
            if (Array.isArray(i)) return i.map(t => "object" == typeof t || Array.isArray(t) ? e(t) : t);
            let n = {
              ...i
            };
            for (let i of Object.keys(n)) {
              let r = t(i.toString());
              r !== i && (n[r] = n[i], delete n[i]), "object" == typeof n[r] && (n[r] = e(n[r]));
            }
            return n;
          };
          return e;
        };
        a(s);
        var o = a(r);
        function l(t) {
          if ("boolean" == typeof t) return t;
          if (null == t) return !1;
          if ("string" == typeof t) {
            if ("true" === t.toLowerCase()) return !0;
            if ("false" === t.toLowerCase()) return !1;
          }
          let e = parseInt(t, 10);
          return !isNaN(e) && e > 0;
        }
        function c(t) {
          return Object.entries(t).reduce((t, [e, i]) => (void 0 !== i && (t[e] = i), t), {});
        }
      },
      5339: function (t, e, i) {
        "use strict";

        i.d(e, {
          $V: function () {
            return a;
          },
          EB: function () {
            return l;
          },
          YZ: function () {
            return o;
          }
        });
        var n = {
            firstDelay: 125,
            maxDelay: 0,
            timeMultiple: 2,
            shouldRetry: () => !0
          },
          r = async t => new Promise(e => setTimeout(e, t)),
          s = t => {
            let e = 0,
              i = () => {
                let i = t.firstDelay * Math.pow(t.timeMultiple, e);
                return Math.min(t.maxDelay || i, i);
              };
            return async () => {
              await r(i()), e++;
            };
          },
          a = async (t, e = {}) => {
            let i = 0,
              {
                shouldRetry: r,
                firstDelay: a,
                maxDelay: o,
                timeMultiple: l
              } = {
                ...n,
                ...e
              },
              c = s({
                firstDelay: a,
                maxDelay: o,
                timeMultiple: l
              });
            for (;;) try {
              return await t();
            } catch (t) {
              if (!r(t, ++i)) throw t;
              await c();
            }
          };
        function o(t, e, i) {
          return "function" == typeof t ? t(e) : void 0 !== t ? t : void 0 !== i ? i : void 0;
        }
        var l = (t, e) => {
          if (t && e) for (let i in t) Object.prototype.hasOwnProperty.call(t, i) && null !== t[i] && "object" == typeof t[i] ? (void 0 === e[i] && (e[i] = new (Object.getPrototypeOf(t[i]).constructor)()), l(t[i], e[i])) : Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
        };
      },
      5415: function (t, e, i) {
        "use strict";

        function n(t) {
          return ["captcha_invalid", "captcha_not_enabled", "captcha_missing_token"].includes(t.errors[0].code);
        }
        function r(t) {
          let e = null == t ? void 0 : t.status;
          return !!e && e >= 400 && e < 500;
        }
        function s(t) {
          return (`${t.message}${t.name}` || "").toLowerCase().replace(/\s+/g, "").includes("networkerror");
        }
        function a(t) {
          return o(t) || c(t) || l(t);
        }
        function o(t) {
          return "clerkError" in t;
        }
        function l(t) {
          return "clerkRuntimeError" in t;
        }
        function c(t) {
          return "code" in t && [4001, 32602, 32603].includes(t.code) && "message" in t;
        }
        function h(t) {
          var e, i;
          return o(t) && (null == (i = null == (e = t.errors) ? void 0 : e[0]) ? void 0 : i.code) === "user_locked";
        }
        function d(t = []) {
          return t.length > 0 ? t.map(u) : [];
        }
        function u(t) {
          var e, i, n, r, s;
          return {
            code: t.code,
            message: t.message,
            longMessage: t.long_message,
            meta: {
              paramName: null == (e = null == t ? void 0 : t.meta) ? void 0 : e.param_name,
              sessionId: null == (i = null == t ? void 0 : t.meta) ? void 0 : i.session_id,
              emailAddresses: null == (n = null == t ? void 0 : t.meta) ? void 0 : n.email_addresses,
              identifiers: null == (r = null == t ? void 0 : t.meta) ? void 0 : r.identifiers,
              zxcvbn: null == (s = null == t ? void 0 : t.meta) ? void 0 : s.zxcvbn
            }
          };
        }
        i.d(e, {
          G1: function () {
            return v;
          },
          N: function () {
            return m;
          },
          ZC: function () {
            return c;
          },
          _L: function () {
            return g;
          },
          ay: function () {
            return h;
          },
          eE: function () {
            return s;
          },
          gO: function () {
            return p;
          },
          iR: function () {
            return d;
          },
          ix: function () {
            return r;
          },
          kD: function () {
            return o;
          },
          nU: function () {
            return u;
          },
          pG: function () {
            return n;
          },
          sZ: function () {
            return a;
          },
          t5: function () {
            return _;
          },
          uX: function () {
            return l;
          },
          w$: function () {
            return f;
          }
        });
        var p = class t extends Error {
            constructor(e, {
              data: i,
              status: n,
              clerkTraceId: r
            }) {
              super(e), this.toString = () => {
                let t = `[${this.name}]
Message:${this.message}
Status:${this.status}
Serialized errors: ${this.errors.map(t => JSON.stringify(t))}`;
                return this.clerkTraceId && (t += `
Clerk Trace ID: ${this.clerkTraceId}`), t;
              }, Object.setPrototypeOf(this, t.prototype), this.status = n, this.message = e, this.clerkTraceId = r, this.clerkError = !0, this.errors = d(i);
            }
          },
          f = class t extends Error {
            constructor(e, {
              code: i
            }) {
              super(e), this.toString = () => `[${this.name}]
Message:${this.message}`, Object.setPrototypeOf(this, t.prototype), this.code = i, this.message = e, this.clerkRuntimeError = !0;
            }
          },
          m = class t extends Error {
            constructor(e) {
              super(e), this.code = e, Object.setPrototypeOf(this, t.prototype);
            }
          };
        function v(t) {
          return t instanceof m;
        }
        var g = {
            Expired: "expired",
            Failed: "failed",
            ClientMismatch: "client_mismatch"
          },
          w = Object.freeze({
            InvalidProxyUrlErrorMessage: "The proxyUrl passed to Clerk is invalid. The expected value for proxyUrl is an absolute URL or a relative path with a leading '/'. (key={{url}})",
            InvalidPublishableKeyErrorMessage: "The publishableKey passed to Clerk is invalid. You can get your Publishable key at https://dashboard.clerk.com/last-active?path=api-keys. (key={{key}})",
            MissingPublishableKeyErrorMessage: "Missing publishableKey. You can get your key at https://dashboard.clerk.com/last-active?path=api-keys.",
            MissingSecretKeyErrorMessage: "Missing secretKey. You can get your key at https://dashboard.clerk.com/last-active?path=api-keys.",
            MissingClerkProvider: "{{source}} can only be used within the <ClerkProvider /> component. Learn more: https://clerk.com/docs/components/clerk-provider"
          });
        function _({
          packageName: t,
          customMessages: e
        }) {
          let i = t,
            n = {
              ...w,
              ...e
            };
          function r(t, e) {
            if (!e) return `${i}: ${t}`;
            let n = t;
            for (let i of t.matchAll(/{{([a-zA-Z0-9-_]+)}}/g)) {
              let t = (e[i[1]] || "").toString();
              n = n.replace(`{{${i[1]}}}`, t);
            }
            return `${i}: ${n}`;
          }
          return {
            setPackageName({
              packageName: t
            }) {
              return "string" == typeof t && (i = t), this;
            },
            setMessages({
              customMessages: t
            }) {
              return Object.assign(n, t || {}), this;
            },
            throwInvalidPublishableKeyError(t) {
              throw Error(r(n.InvalidPublishableKeyErrorMessage, t));
            },
            throwInvalidProxyUrl(t) {
              throw Error(r(n.InvalidProxyUrlErrorMessage, t));
            },
            throwMissingPublishableKeyError() {
              throw Error(r(n.MissingPublishableKeyErrorMessage));
            },
            throwMissingSecretKeyError() {
              throw Error(r(n.MissingSecretKeyErrorMessage));
            },
            throwMissingClerkProviderError(t) {
              throw Error(r(n.MissingClerkProvider, t));
            },
            throw(t) {
              throw Error(r(t));
            }
          };
        }
      },
      2434: function (t, e, i) {
        "use strict";

        i.d(e, {
          G1: function () {
            return n.G1;
          },
          N: function () {
            return n.N;
          },
          ZC: function () {
            return n.ZC;
          },
          _L: function () {
            return n._L;
          },
          ay: function () {
            return n.ay;
          },
          eE: function () {
            return n.eE;
          },
          gO: function () {
            return n.gO;
          },
          iR: function () {
            return n.iR;
          },
          ix: function () {
            return n.ix;
          },
          kD: function () {
            return n.kD;
          },
          nU: function () {
            return n.nU;
          },
          pG: function () {
            return n.pG;
          },
          sZ: function () {
            return n.sZ;
          },
          t5: function () {
            return n.t5;
          },
          uX: function () {
            return n.uX;
          },
          w$: function () {
            return n.w$;
          }
        });
        var n = i(5415);
        i(2689);
      },
      8003: function (t, e, i) {
        "use strict";

        i.d(e, {
          k: function () {
            return n.k;
          }
        });
        var n = i(8502);
        i(2689);
      },
      8231: function (t, e, i) {
        "use strict";

        i.d(e, {
          W: () => r
        });
        var n = i("8826");
        function r({
          delayInMs: t
        } = {
          delayInMs: 1e3
        }) {
          let e;
          let i = (0, n.Q)(),
            s = !1,
            a = () => {
              e && (i.clearTimeout(e), i.cleanup()), s = !0;
            },
            o = async n => {
              s = !1, await n(a), !s && (e = i.setTimeout(() => {
                o(n);
              }, t));
            };
          return {
            run: o,
            stop: a
          };
        }
        i("2689");
      },
      3310: function (t, e, i) {
        "use strict";

        i.d(e, {
          NS: function () {
            return I;
          },
          Zg: function () {
            return P;
          },
          nx: function () {
            return E;
          }
        });
        var n,
          r,
          s,
          a,
          o,
          l,
          c,
          h,
          d,
          u,
          p,
          f,
          m,
          v,
          g,
          w,
          _,
          b,
          y,
          k = i(8774),
          S = i(4193),
          U = i(2689),
          A = class {
            constructor() {
              (0, U.Ko)(this, s), (0, U.Ko)(this, n, "clerk_telemetry_throttler"), (0, U.Ko)(this, r, 864e5);
            }
            isEventThrottled(t) {
              var e;
              if (!(0, U.ac)(this, s, l)) return !1;
              let i = Date.now(),
                c = (0, U.U9)(this, s, a).call(this, t),
                h = null == (e = (0, U.ac)(this, s, o)) ? void 0 : e[c];
              if (!h) {
                let t = {
                  ...(0, U.ac)(this, s, o),
                  [c]: i
                };
                localStorage.setItem((0, U.ac)(this, n), JSON.stringify(t));
              }
              if (h && i - h > (0, U.ac)(this, r)) {
                let t = (0, U.ac)(this, s, o);
                delete t[c], localStorage.setItem((0, U.ac)(this, n), JSON.stringify(t));
              }
              return !!h;
            }
          };
        n = new WeakMap(), r = new WeakMap(), s = new WeakSet(), a = function (t) {
          let {
              sk: e,
              pk: i,
              payload: n,
              ...r
            } = t,
            s = {
              ...n,
              ...r
            };
          return JSON.stringify(Object.keys({
            ...n,
            ...r
          }).sort().map(t => s[t]));
        }, o = function () {
          let t = localStorage.getItem((0, U.ac)(this, n));
          return t ? JSON.parse(t) : {};
        }, l = function () {
          if ("undefined" == typeof window) return !1;
          let t = window.localStorage;
          if (!t) return !1;
          try {
            let e = "test";
            return t.setItem(e, e), t.removeItem(e), !0;
          } catch (e) {
            return e instanceof DOMException && ("QuotaExceededError" === e.name || "NS_ERROR_DOM_QUOTA_REACHED" === e.name) && t.length > 0 && t.removeItem((0, U.ac)(this, n)), !1;
          }
        };
        var O = {
            samplingRate: 1,
            maxBufferSize: 5,
            endpoint: "https://clerk-telemetry.com"
          },
          I = class {
            constructor(t) {
              var e, i, n, r, s, a;
              (0, U.Ko)(this, f), (0, U.Ko)(this, c), (0, U.Ko)(this, h), (0, U.Ko)(this, d, {}), (0, U.Ko)(this, u, []), (0, U.Ko)(this, p), (0, U.qx)(this, c, {
                maxBufferSize: null != (e = t.maxBufferSize) ? e : O.maxBufferSize,
                samplingRate: null != (i = t.samplingRate) ? i : O.samplingRate,
                disabled: null != (n = t.disabled) && n,
                debug: null != (r = t.debug) && r,
                endpoint: O.endpoint
              }), t.clerkVersion || "undefined" != typeof window ? (0, U.ac)(this, d).clerkVersion = null != (s = t.clerkVersion) ? s : "" : (0, U.ac)(this, d).clerkVersion = "", (0, U.ac)(this, d).sdk = t.sdk, (0, U.ac)(this, d).sdkVersion = t.sdkVersion, (0, U.ac)(this, d).publishableKey = null != (a = t.publishableKey) ? a : "";
              let o = (0, S.nQ)(t.publishableKey);
              o && ((0, U.ac)(this, d).instanceType = o.instanceType), t.secretKey && ((0, U.ac)(this, d).secretKey = t.secretKey.substring(0, 16)), (0, U.qx)(this, h, new A());
            }
            get isEnabled() {
              var t;
              return !("development" !== (0, U.ac)(this, d).instanceType || (0, U.ac)(this, c).disabled || "undefined" != typeof process && (0, k.fQ)(process.env.CLERK_TELEMETRY_DISABLED)) && ("undefined" == typeof window || null == (t = null == window ? void 0 : window.navigator) || !t.webdriver);
            }
            get isDebug() {
              return (0, U.ac)(this, c).debug || "undefined" != typeof process && (0, k.fQ)(process.env.CLERK_TELEMETRY_DEBUG);
            }
            record(t) {
              let e = (0, U.U9)(this, f, y).call(this, t.event, t.payload);
              (0, U.U9)(this, f, _).call(this, e.event, e), (0, U.U9)(this, f, m).call(this, e, t.eventSamplingRate) && ((0, U.ac)(this, u).push(e), (0, U.U9)(this, f, g).call(this));
            }
          };
        c = new WeakMap(), h = new WeakMap(), d = new WeakMap(), u = new WeakMap(), p = new WeakMap(), f = new WeakSet(), m = function (t, e) {
          return this.isEnabled && !this.isDebug && (0, U.U9)(this, f, v).call(this, t, e);
        }, v = function (t, e) {
          let i = Math.random();
          return !(0, U.ac)(this, h).isEventThrottled(t) && i <= (0, U.ac)(this, c).samplingRate && (void 0 === e || i <= e);
        }, g = function () {
          if ("undefined" == typeof window) {
            (0, U.U9)(this, f, w).call(this);
            return;
          }
          if ((0, U.ac)(this, u).length >= (0, U.ac)(this, c).maxBufferSize) {
            (0, U.ac)(this, p) && ("undefined" != typeof cancelIdleCallback ? cancelIdleCallback : clearTimeout)((0, U.ac)(this, p)), (0, U.U9)(this, f, w).call(this);
            return;
          }
          !(0, U.ac)(this, p) && ("requestIdleCallback" in window ? (0, U.qx)(this, p, requestIdleCallback(() => {
            (0, U.U9)(this, f, w).call(this);
          })) : (0, U.qx)(this, p, setTimeout(() => {
            (0, U.U9)(this, f, w).call(this);
          }, 0)));
        }, w = function () {
          fetch(new URL("/v1/event", (0, U.ac)(this, c).endpoint), {
            method: "POST",
            body: JSON.stringify({
              events: (0, U.ac)(this, u)
            }),
            headers: {
              "Content-Type": "application/json"
            }
          }).catch(() => void 0).then(() => {
            (0, U.qx)(this, u, []);
          }).catch(() => void 0);
        }, _ = function (t, e) {
          this.isDebug && (void 0 !== console.groupCollapsed ? (console.groupCollapsed("[clerk/telemetry]", t), console.log(e), console.groupEnd()) : console.log("[clerk/telemetry]", t, e));
        }, b = function () {
          let t = {
            name: (0, U.ac)(this, d).sdk,
            version: (0, U.ac)(this, d).sdkVersion
          };
          return "undefined" != typeof window && window.Clerk && (t = {
            ...t,
            ...window.Clerk.constructor.sdkMetadata
          }), t;
        }, y = function (t, e) {
          var i, n;
          let r = (0, U.U9)(this, f, b).call(this);
          return {
            event: t,
            cv: null != (i = (0, U.ac)(this, d).clerkVersion) ? i : "",
            it: null != (n = (0, U.ac)(this, d).instanceType) ? n : "",
            sdk: r.name,
            sdkv: r.version,
            ...((0, U.ac)(this, d).publishableKey ? {
              pk: (0, U.ac)(this, d).publishableKey
            } : {}),
            ...((0, U.ac)(this, d).secretKey ? {
              sk: (0, U.ac)(this, d).secretKey
            } : {}),
            payload: e
          };
        };
        var C = "COMPONENT_MOUNTED";
        function E(t, e) {
          var i, n, r;
          return {
            event: C,
            eventSamplingRate: .1,
            payload: {
              component: t,
              appearanceProp: !!(null == e ? void 0 : e.appearance),
              baseTheme: !!(null == (i = null == e ? void 0 : e.appearance) ? void 0 : i.baseTheme),
              elements: !!(null == (n = null == e ? void 0 : e.appearance) ? void 0 : n.elements),
              variables: !!(null == (r = null == e ? void 0 : e.appearance) ? void 0 : r.variables)
            }
          };
        }
        function P(t, e = {}) {
          return {
            event: C,
            eventSamplingRate: .1,
            payload: {
              component: t,
              ...e
            }
          };
        }
      },
      5670: function (t, e, i) {
        "use strict";

        i.d(e, {
          MI: function () {
            return n.MI;
          },
          TD: function () {
            return n.TD;
          },
          a1: function () {
            return n.a1;
          },
          aw: function () {
            return n.aw;
          },
          hF: function () {
            return n.hF;
          }
        });
        var n = i(8774);
        i(2689);
      },
      7717: function (t, e, i) {
        "use strict";

        i.d(e, {
          A5: function () {
            return n.A5;
          },
          LQ: function () {
            return n.LQ;
          },
          d5: function () {
            return n.d5;
          },
          xn: function () {
            return n.xn;
          },
          xy: function () {
            return n.xy;
          }
        });
        var n = i(6029);
        i(2689);
      },
      4677: function (t, e, i) {
        "use strict";

        i.d(e, {
          ZT: () => r.Z,
          $V: () => n.$V,
          WK: () => s,
          EB: () => n.EB,
          YZ: () => n.YZ
        });
        var n = i("5339"),
          r = i("5427"),
          s = () => {
            let t = r.Z,
              e = r.Z;
            return {
              promise: new Promise((i, n) => {
                t = i, e = n;
              }),
              resolve: t,
              reject: e
            };
          };
        i("2689");
      },
      5263: function (t, e, i) {
        "use strict";

        i.d(e, {
          C6: function () {
            return a;
          },
          h_: function () {
            return s;
          },
          iW: function () {
            return r;
          }
        });
        var n = i(9934);
        function r() {
          return (0, n.Er)() && "function" == typeof window.PublicKeyCredential;
        }
        async function s() {
          try {
            return r() && (await window.PublicKeyCredential.isConditionalMediationAvailable());
          } catch (t) {
            return !1;
          }
        }
        async function a() {
          try {
            return "undefined" != typeof window && (await window.PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable());
          } catch (t) {
            return !1;
          }
        }
        i(2689);
      }
    },
    e = {};
  function i(n) {
    var r = e[n];
    if (void 0 !== r) return r.exports;
    var s = e[n] = {
      id: n,
      loaded: !1,
      exports: {}
    };
    return t[n].call(s.exports, s, s.exports, i), s.loaded = !0, s.exports;
  }
  return i.m = t, i.n = function (t) {
    var e = t && t.__esModule ? function () {
      return t.default;
    } : function () {
      return t;
    };
    return i.d(e, {
      a: e
    }), e;
  }, (() => {
    var t,
      e = Object.getPrototypeOf ? function (t) {
        return Object.getPrototypeOf(t);
      } : function (t) {
        return t.__proto__;
      };
    i.t = function (n, r) {
      if (1 & r && (n = this(n)), 8 & r || "object" == typeof n && n && (4 & r && n.__esModule || 16 & r && "function" == typeof n.then)) return n;
      var s = Object.create(null);
      i.r(s);
      var a = {};
      t = t || [null, e({}), e([]), e(e)];
      for (var o = 2 & r && n; "object" == typeof o && !~t.indexOf(o); o = e(o)) Object.getOwnPropertyNames(o).forEach(function (t) {
        a[t] = function () {
          return n[t];
        };
      });
      return a.default = function () {
        return n;
      }, i.d(s, a), s;
    };
  })(), i.d = function (t, e) {
    for (var n in e) i.o(e, n) && !i.o(t, n) && Object.defineProperty(t, n, {
      enumerable: !0,
      get: e[n]
    });
  }, i.f = {}, i.e = function (t) {
    return Promise.all(Object.keys(i.f).reduce(function (e, n) {
      return i.f[n](t, e), e;
    }, []));
  }, i.hmd = function (t) {
    return (t = Object.create(t)).children || (t.children = []), Object.defineProperty(t, "exports", {
      enumerable: !0,
      set: function () {
        throw Error("ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead: " + t.id);
      }
    }), t;
  }, i.u = function (t) {
    return "" + ({
      199: "cookieSuffix",
      36: "rebuild--sign-up",
      885: "rebuild--sign-in"
    }[t] || t) + "_" + i.h().slice(0, 6) + "_5.30.3.js";
  }, i.h = function () {
    return "7c33438df1d397c32d3b";
  }, i.g = function () {
    if ("object" == typeof globalThis) return globalThis;
    try {
      return this || Function("return this")();
    } catch (t) {
      if ("object" == typeof window) return window;
    }
  }(), i.o = function (t, e) {
    return Object.prototype.hasOwnProperty.call(t, e);
  }, (() => {
    var t = {},
      e = "@clerk/clerk-js:";
    i.l = function (n, r, s, a) {
      if (t[n]) {
        t[n].push(r);
        return;
      }
      if (void 0 !== s) for (var o, l, c = document.getElementsByTagName("script"), h = 0; h < c.length; h++) {
        var d = c[h];
        if (d.getAttribute("src") == n || d.getAttribute("data-webpack") == e + s) {
          o = d;
          break;
        }
      }
      o || (l = !0, (o = document.createElement("script")).charset = "utf-8", o.timeout = 120, i.nc && o.setAttribute("nonce", i.nc), o.setAttribute("data-webpack", e + s), o.src = n), t[n] = [r];
      var u = function (e, i) {
          o.onerror = o.onload = null, clearTimeout(p);
          var r = t[n];
          if (delete t[n], o.parentNode && o.parentNode.removeChild(o), r && r.forEach(function (t) {
            return t(i);
          }), e) return e(i);
        },
        p = setTimeout(u.bind(null, void 0, {
          type: "timeout",
          target: o
        }), 12e4);
      o.onerror = u.bind(null, o.onerror), o.onload = u.bind(null, o.onload), l && document.head.appendChild(o);
    };
  })(), i.r = function (t) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(t, "__esModule", {
      value: !0
    });
  }, i.nc = void 0, i.p = "", (() => {
    var t = {
      994: 0
    };
    i.f.j = function (e, n) {
      var r = i.o(t, e) ? t[e] : void 0;
      if (0 !== r) {
        if (r) n.push(r[2]);else {
          var s = new Promise(function (i, n) {
            r = t[e] = [i, n];
          });
          n.push(r[2] = s);
          var a = i.p + i.u(e),
            o = Error();
          i.l(a, function (n) {
            if (i.o(t, e) && (0 !== (r = t[e]) && (t[e] = void 0), r)) {
              var s = n && ("load" === n.type ? "missing" : n.type),
                a = n && n.target && n.target.src;
              o.message = "Loading chunk " + e + " failed.\n(" + s + ": " + a + ")", o.name = "ChunkLoadError", o.type = s, o.request = a, r[1](o);
            }
          }, "chunk-" + e, e);
        }
      }
    };
    var e = function (e, n) {
        var r,
          s,
          a = n[0],
          o = n[1],
          l = n[2],
          c = 0;
        if (a.some(function (e) {
          return 0 !== t[e];
        })) {
          for (r in o) i.o(o, r) && (i.m[r] = o[r]);
          l && l(i);
        }
        for (e && e(n); c < a.length; c++) s = a[c], i.o(t, s) && t[s] && t[s][0](), t[s] = 0;
      },
      n = globalThis.webpackChunk_clerk_clerk_js = globalThis.webpackChunk_clerk_clerk_js || [];
    n.forEach(e.bind(null, 0)), n.push = e.bind(null, n.push.bind(n));
  })(), i("5139");
})());